import { j as jsxRuntimeExports, h as useAppSelector, q as keyboardSlice, F as FocusedMathInputContext, M as MathJax } from "./doenetml-CDvV96YD.js";
import React__default, { useRef, useEffect, useContext, useState } from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-YzDSBjpZ.js";
import { P as PropTypes } from "./index-C1xHDTIY.js";
/* empty css                   */
import { a as createCheckWorkComponent, c as calculateValidationState } from "./checkWork-ELAyU3CF.js";
var __extends = /* @__PURE__ */ (function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError(
        "Class extends value " + String(b) + " is not a constructor or null"
      );
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign = function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var L = -1;
var R = 1;
var min = Math.min;
var max = Math.max;
function noop() {
}
function walkUpAsFarAsPossible(node) {
  while (node) {
    if (!node.parent) {
      return node;
    }
    node = node.parent;
  }
  return void 0;
}
function pray(message, cond, optionalContextNodes) {
  if (!cond) {
    var error = new Error("prayer failed: " + message);
    if (optionalContextNodes) {
      var jsonData = {};
      error.dcgExtraErrorMetaData = jsonData;
      for (var contextName in optionalContextNodes) {
        var localNode = optionalContextNodes[contextName];
        var data = jsonData[contextName] = {};
        if (localNode) {
          data.localLatex = localNode.latex();
          var root = walkUpAsFarAsPossible(localNode);
          if (root) {
            data.rootLatex = root.latex();
          }
        } else {
          data.emptyNode = true;
        }
      }
    }
    throw error;
  }
}
function prayDirection(dir) {
  pray("a direction was passed", dir === L || dir === R);
}
function parseHTML(s) {
  var tmp = document.implementation.createHTMLDocument("");
  tmp.body.innerHTML = s;
  if (tmp.body.children.length === 1) return tmp.body.children[0];
  var frag = document.createDocumentFragment();
  while (tmp.body.firstChild) {
    frag.appendChild(tmp.body.firstChild);
  }
  return frag;
}
var h = function h2(type, attributes, children) {
  var el;
  switch (type) {
    case "svg":
    case "path":
      el = document.createElementNS("http://www.w3.org/2000/svg", type);
      break;
    default:
      el = document.createElement(type);
  }
  for (var key_1 in attributes) {
    var value = attributes[key_1];
    if (value === void 0) continue;
    el.setAttribute(
      key_1,
      typeof value === "string" ? value : String(value)
    );
  }
  if (children) {
    for (var i = 0; i < children.length; i++) {
      el.appendChild(children[i]);
    }
  }
  return el;
};
h.text = function(s) {
  return document.createTextNode(s);
};
h.block = function(type, attributes, block, opts) {
  var children = [block.html()];
  if (opts === null || opts === void 0 ? void 0 : opts.beforeChild) {
    children.unshift(opts.beforeChild);
  }
  if (opts === null || opts === void 0 ? void 0 : opts.afterChild) {
    children.push(opts.afterChild);
  }
  var out = h(type, attributes, children);
  block.setDOM(out);
  NodeBase.linkElementByBlockNode(out, block);
  return out;
};
h.entityText = function(s) {
  var val = parseHTML(s);
  pray(
    "entity parses to a single text node",
    val instanceof DocumentFragment && val.childNodes.length === 1 && val.childNodes[0] instanceof Text
  );
  return val.childNodes[0];
};
function closest(el, s) {
  var _a, _b;
  if (typeof (el === null || el === void 0 ? void 0 : el.closest) === "function") {
    return el.closest(s);
  }
  if (!(el instanceof HTMLElement)) return null;
  var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  var match = el;
  do {
    if (matches.call(match, s)) return match;
    match = (_b = (_a = match === null || match === void 0 ? void 0 : match.parentElement) !== null && _a !== void 0 ? _a : match === null || match === void 0 ? void 0 : match.parentNode) !== null && _b !== void 0 ? _b : null;
  } while (match !== null && match.nodeType === 1);
  return null;
}
var U_NO_BREAK_SPACE = " ";
var U_ZERO_WIDTH_SPACE = "​";
var U_DOT_ABOVE = "˙";
var U_NARY_SUMMATION = "∑";
var U_NARY_PRODUCT = "∏";
var U_NARY_COPRODUCT = "∐";
var U_INTEGRAL = "∫";
function getBoundingClientRect(el) {
  if (!el.getClientRects().length) {
    return {
      top: 0,
      left: 0,
      height: 0,
      width: 0,
      x: 0,
      y: 0,
      bottom: 0,
      right: 0
    };
  }
  return el.getBoundingClientRect();
}
function getScrollX() {
  return window.pageXOffset !== void 0 ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
}
function getScrollY() {
  return window.pageYOffset !== void 0 ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
}
var animate = (function() {
  var rafShim, cancelShim;
  if (typeof requestAnimationFrame === "function" && typeof cancelAnimationFrame === "function") {
    rafShim = requestAnimationFrame;
    cancelShim = cancelAnimationFrame;
  } else {
    rafShim = function(cb) {
      return setTimeout(cb, 13);
    };
    cancelShim = clearTimeout;
  }
  return function(duration, cb) {
    var start = Date.now();
    var cancelToken;
    var progress = 0;
    function step() {
      var proposedProgress = (Date.now() - start) / duration;
      if (proposedProgress <= progress) {
        scheduleNext();
      } else {
        progress = proposedProgress;
      }
      cb(progress, scheduleNext, cancel);
    }
    function cancel() {
      if (cancelToken !== void 0) cancelShim(cancelToken);
      cancelToken = void 0;
    }
    function scheduleNext() {
      cancel();
      cancelToken = rafShim(step);
    }
    cb(duration <= 0 ? 1 : 0, scheduleNext, cancel);
  };
})();
var Aria = (
  /** @class */
  (function() {
    function Aria2(controller) {
      this.span = h("span", {
        class: "mq-aria-alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
      });
      this.msg = "";
      this.items = [];
      this.controller = controller;
    }
    Aria2.prototype.attach = function() {
      var container = this.controller.container;
      if (this.span.parentNode !== container) {
        domFrag(container).prepend(domFrag(this.span));
      }
    };
    Aria2.prototype.queue = function(item, shouldDescribe) {
      if (shouldDescribe === void 0) {
        shouldDescribe = false;
      }
      var output = "";
      if (item instanceof MQNode) {
        var itemMathspeak = item.mathspeak({ ignoreShorthand: true });
        if (shouldDescribe) {
          if (item.parent && item.parent.ariaLabel && item.ariaLabel === "block") {
            output = item.parent.ariaLabel + " " + itemMathspeak;
          } else if (item.ariaLabel) {
            output = item.ariaLabel + " " + itemMathspeak;
          }
        }
        if (output === "") {
          output = itemMathspeak;
        }
      } else {
        output = item || "";
      }
      this.items.push(output);
      return this;
    };
    Aria2.prototype.queueDirOf = function(dir) {
      prayDirection(dir);
      return this.queue(dir === L ? "before" : "after");
    };
    Aria2.prototype.queueDirEndOf = function(dir) {
      prayDirection(dir);
      return this.queue(dir === L ? "beginning of" : "end of");
    };
    Aria2.prototype.alert = function(t) {
      this.attach();
      if (t) this.queue(t);
      if (this.items.length) {
        this.msg = this.items.join(" ").replace(/ +(?= )/g, "").trim();
        if (this.controller.containerHasFocus()) {
          if (this.controller.options.logAriaAlerts && this.msg) {
            console.log(this.msg);
          }
          this.span.textContent = this.msg;
        }
      }
      return this.clear();
    };
    Aria2.prototype.clear = function(opts) {
      this.items.length = 0;
      if (opts === null || opts === void 0 ? void 0 : opts.emptyContent)
        this.span.textContent = "";
      return this;
    };
    return Aria2;
  })()
);
var DOMFragment = (
  /** @class */
  (function() {
    function DOMFragment2(first, last) {
      var _a;
      if (arguments.length === 1) last = first;
      if (!first || !last) return;
      this.ends = (_a = {}, _a[L] = first, _a[R] = last, _a);
    }
    DOMFragment2.create = function(first, last) {
      if (arguments.length === 1) last = first;
      pray("No half-empty DOMFragments", !!first === !!last);
      var out = new DOMFragment2(first, last);
      pray("last is a forward sibling of first", out.isValid());
      return out;
    };
    DOMFragment2.prototype.isEmpty = function() {
      return this.ends === void 0;
    };
    DOMFragment2.prototype.isOneNode = function() {
      return !!(this.ends && this.ends[L] === this.ends[R]);
    };
    DOMFragment2.prototype.isValid = function() {
      if (!this.ends) return true;
      if (this.ends[L] === this.ends[R]) return true;
      var maybeLast;
      this.eachNode(function(el) {
        return maybeLast = el;
      });
      return maybeLast === this.ends[R];
    };
    DOMFragment2.prototype.firstNode = function() {
      pray("Fragment is not empty", this.ends);
      return this.ends[L];
    };
    DOMFragment2.prototype.lastNode = function() {
      pray("Fragment is not empty", this.ends);
      return this.ends[R];
    };
    DOMFragment2.prototype.children = function() {
      var el = this.oneNode();
      var first = el.firstChild;
      var last = el.lastChild;
      return first && last ? new DOMFragment2(first, last) : new DOMFragment2();
    };
    DOMFragment2.prototype.join = function(sibling) {
      if (!this.ends) return sibling;
      if (!sibling.ends) return this;
      var found = false;
      var current = this.ends[R].nextSibling;
      while (current) {
        if (current === sibling.ends[L]) {
          found = true;
          break;
        }
        current = current.nextSibling;
      }
      pray("sibling must be a forward DOM sibling of this fragment", found);
      return new DOMFragment2(this.ends[L], sibling.ends[R]);
    };
    DOMFragment2.prototype.oneNode = function() {
      pray(
        "Fragment has a single node",
        this.ends && this.ends[L] === this.ends[R]
      );
      return this.ends[L];
    };
    DOMFragment2.prototype.oneElement = function() {
      var el = this.oneNode();
      pray("Node is an Element", el.nodeType === Node.ELEMENT_NODE);
      return el;
    };
    DOMFragment2.prototype.oneText = function() {
      var el = this.oneNode();
      pray("Node is Text", el.nodeType === Node.TEXT_NODE);
      return el;
    };
    DOMFragment2.prototype.eachNode = function(cb) {
      if (!this.ends) return this;
      var stop = this.ends[R];
      for (var node = this.ends[L], next = void 0; node; node = next) {
        next = node.nextSibling;
        cb(node);
        if (node === stop) break;
      }
      return this;
    };
    DOMFragment2.prototype.eachElement = function(cb) {
      this.eachNode(function(el) {
        if (el.nodeType === Node.ELEMENT_NODE) cb(el);
      });
      return this;
    };
    DOMFragment2.prototype.text = function() {
      var accum = "";
      this.eachNode(function(node) {
        accum += node.textContent || "";
      });
      return accum;
    };
    DOMFragment2.prototype.toNodeArray = function() {
      var accum = [];
      this.eachNode(function(el) {
        return accum.push(el);
      });
      return accum;
    };
    DOMFragment2.prototype.toElementArray = function() {
      var accum = [];
      this.eachElement(function(el) {
        return accum.push(el);
      });
      return accum;
    };
    DOMFragment2.prototype.toDocumentFragment = function() {
      var frag = document.createDocumentFragment();
      this.eachNode(function(el) {
        return frag.appendChild(el);
      });
      return frag;
    };
    DOMFragment2.prototype.insertBefore = function(sibling) {
      return this.insDirOf(L, sibling);
    };
    DOMFragment2.prototype.insertAfter = function(sibling) {
      return this.insDirOf(R, sibling);
    };
    DOMFragment2.prototype.append = function(children) {
      children.appendTo(this.oneElement());
      return this;
    };
    DOMFragment2.prototype.prepend = function(children) {
      children.prependTo(this.oneElement());
      return this;
    };
    DOMFragment2.prototype.appendTo = function(el) {
      return this.insAtDirEnd(R, el);
    };
    DOMFragment2.prototype.prependTo = function(el) {
      return this.insAtDirEnd(L, el);
    };
    DOMFragment2.prototype.parent = function() {
      if (!this.ends) return this;
      var parent = this.ends[L].parentNode;
      if (!parent) return new DOMFragment2();
      return new DOMFragment2(parent);
    };
    DOMFragment2.prototype.wrapAll = function(el) {
      el.textContent = "";
      if (!this.ends) return this;
      var parent = this.ends[L].parentNode;
      var next = this.ends[R].nextSibling;
      this.appendTo(el);
      if (parent) {
        parent.insertBefore(el, next);
      }
      return this;
    };
    DOMFragment2.prototype.replaceWith = function(children) {
      var _a;
      var rightEnd = (_a = this.ends) === null || _a === void 0 ? void 0 : _a[R];
      var parent = rightEnd === null || rightEnd === void 0 ? void 0 : rightEnd.parentNode;
      var nextSibling = rightEnd === null || rightEnd === void 0 ? void 0 : rightEnd.nextSibling;
      this.detach();
      var childDocumentFragment = children.toDocumentFragment();
      if (!rightEnd || !parent) return this;
      parent.insertBefore(childDocumentFragment, nextSibling || null);
      return this;
    };
    DOMFragment2.prototype.nthElement = function(n) {
      if (!this.ends) return void 0;
      if (n < 0 || n !== Math.floor(n)) return void 0;
      var current = this.ends[L];
      while (current) {
        if (current.nodeType === Node.ELEMENT_NODE) {
          if (n <= 0) return current;
          n -= 1;
        }
        if (current === this.ends[R]) return void 0;
        current = current.nextSibling;
      }
      return void 0;
    };
    DOMFragment2.prototype.firstElement = function() {
      return this.nthElement(0);
    };
    DOMFragment2.prototype.lastElement = function() {
      if (!this.ends) return void 0;
      var current = this.ends[R];
      while (current) {
        if (current.nodeType === Node.ELEMENT_NODE) {
          return current;
        }
        if (current === this.ends[L]) return void 0;
        current = current.previousSibling;
      }
      return void 0;
    };
    DOMFragment2.prototype.first = function() {
      return new DOMFragment2(this.firstElement());
    };
    DOMFragment2.prototype.last = function() {
      return new DOMFragment2(this.lastElement());
    };
    DOMFragment2.prototype.eq = function(n) {
      return new DOMFragment2(this.nthElement(n));
    };
    DOMFragment2.prototype.slice = function(n) {
      if (!this.ends) return this;
      var el = this.nthElement(n);
      if (!el) return new DOMFragment2();
      return new DOMFragment2(el, this.ends[R]);
    };
    DOMFragment2.prototype.next = function() {
      var current = this.oneNode();
      while (current) {
        current = current.nextSibling;
        if (current && current.nodeType === Node.ELEMENT_NODE)
          return new DOMFragment2(current);
      }
      return new DOMFragment2();
    };
    DOMFragment2.prototype.prev = function() {
      var current = this.oneNode();
      while (current) {
        current = current.previousSibling;
        if (current && current.nodeType === Node.ELEMENT_NODE)
          return new DOMFragment2(current);
      }
      return new DOMFragment2();
    };
    DOMFragment2.prototype.empty = function() {
      this.eachElement(function(el) {
        el.textContent = "";
      });
      return this;
    };
    DOMFragment2.prototype.remove = function() {
      this.toDocumentFragment();
      return this;
    };
    DOMFragment2.prototype.detach = function() {
      return this.remove();
    };
    DOMFragment2.prototype.insDirOf = function(dir, sibling) {
      var _a;
      if (!this.ends) return this;
      var el = (_a = sibling.ends) === null || _a === void 0 ? void 0 : _a[dir];
      if (!el || !el.parentNode) return this.detach();
      _insDirOf(dir, el.parentNode, this.toDocumentFragment(), el);
      return this;
    };
    DOMFragment2.prototype.insAtDirEnd = function(dir, el) {
      if (!this.ends) return this;
      _insAtDirEnd(dir, this.toDocumentFragment(), el);
      return this;
    };
    DOMFragment2.prototype.hasClass = function(className) {
      var out = false;
      this.eachElement(function(el) {
        if (el.classList.contains(className)) out = true;
      });
      return out;
    };
    DOMFragment2.prototype.addClass = function(classNames) {
      var _loop_1 = function(className2) {
        if (!className2) return "continue";
        this_1.eachElement(function(el) {
          el.classList.add(className2);
        });
      };
      var this_1 = this;
      for (var _i = 0, _a = classNames.split(/\s+/); _i < _a.length; _i++) {
        var className = _a[_i];
        _loop_1(className);
      }
      return this;
    };
    DOMFragment2.prototype.removeClass = function(classNames) {
      var _loop_2 = function(className2) {
        if (!className2) return "continue";
        this_2.eachElement(function(el) {
          el.classList.remove(className2);
        });
      };
      var this_2 = this;
      for (var _i = 0, _a = classNames.split(/\s+/); _i < _a.length; _i++) {
        var className = _a[_i];
        _loop_2(className);
      }
      return this;
    };
    DOMFragment2.prototype.toggleClass = function(classNames, on) {
      if (on === true) return this.addClass(classNames);
      if (on === false) return this.removeClass(classNames);
      var _loop_3 = function(className2) {
        if (!className2) return "continue";
        this_3.eachElement(function(el) {
          el.classList.toggle(className2);
        });
      };
      var this_3 = this;
      for (var _i = 0, _a = classNames.split(/\s+/); _i < _a.length; _i++) {
        var className = _a[_i];
        _loop_3(className);
      }
      return this;
    };
    return DOMFragment2;
  })()
);
var domFrag = DOMFragment.create;
function _insDirOf(dir, parent, source, target) {
  parent.insertBefore(source, dir === L ? target : target.nextSibling);
}
function _insAtDirEnd(dir, source, parent) {
  if (dir === L) {
    parent.insertBefore(source, parent.firstChild);
  } else {
    parent.appendChild(source);
  }
}
var Point = (
  /** @class */
  (function() {
    function Point2(parent, leftward, rightward) {
      this.init(parent, leftward, rightward);
    }
    Point2.prototype.init = function(parent, leftward, rightward) {
      this.parent = parent;
      this[L] = leftward;
      this[R] = rightward;
    };
    Point2.copy = function(pt) {
      return new Point2(pt.parent, pt[L], pt[R]);
    };
    return Point2;
  })()
);
function eachNode(ends, yield_) {
  var el = ends[L];
  if (!el) return;
  var stop = ends[R];
  if (!stop) return;
  stop = stop[R];
  for (; el !== stop; el = el[R]) {
    var result = yield_(el);
    if (result === false) break;
  }
}
function foldNodes(ends, fold, yield_) {
  var el = ends[L];
  if (!el) return fold;
  var stop = ends[R];
  if (!stop) return fold;
  stop = stop[R];
  for (; el !== stop; el = el[R]) {
    fold = yield_(fold, el);
  }
  return fold;
}
var NodeBase = (
  /** @class */
  (function() {
    function NodeBase2() {
      var _c;
      this[_a] = 0;
      this[_b] = 0;
      this.parent = 0;
      this.ends = (_c = {}, _c[L] = 0, _c[R] = 0, _c);
      this.id = NodeBase2.uniqueNodeId();
    }
    NodeBase2.uniqueNodeId = function() {
      return NodeBase2.idCounter += 1;
    };
    NodeBase2.getNodeOfElement = function(el) {
      if (!el) return;
      if (!el.nodeType)
        throw new Error(
          "must pass an Element to NodeBase.getNodeOfElement"
        );
      var elTrackingNode = el;
      return elTrackingNode.mqBlockNode || elTrackingNode.mqCmdNode;
    };
    NodeBase2.linkElementByBlockNode = function(elm, blockNode) {
      elm.mqBlockNode = blockNode;
    };
    NodeBase2.linkElementByCmdNode = function(elm, cmdNode) {
      elm.mqCmdNode = cmdNode;
    };
    NodeBase2.prototype.setEnds = function(ends) {
      this.ends = ends;
      pray("No half-empty node ends", !!this.ends[L] === !!this.ends[R]);
    };
    NodeBase2.prototype.getEnd = function(dir) {
      return this.ends[dir];
    };
    NodeBase2.prototype.toString = function() {
      return "{{ MathQuill Node #" + this.id + " }}";
    };
    NodeBase2.prototype.setDOM = function(el) {
      if (el) {
        pray(
          "DOM is an element or a text node",
          el.nodeType === Node.ELEMENT_NODE || el.nodeType === Node.TEXT_NODE
        );
      }
      this._el = el;
      return this;
    };
    NodeBase2.prototype.domFrag = function() {
      return domFrag(this._el);
    };
    NodeBase2.prototype.createDir = function(dir, cursor) {
      prayDirection(dir);
      var node = this;
      node.html();
      node.domFrag().insDirOf(dir, cursor.domFrag());
      cursor[dir] = node.adopt(cursor.parent, cursor[L], cursor[R]);
      return node;
    };
    NodeBase2.prototype.createLeftOf = function(cursor) {
      this.createDir(L, cursor);
    };
    NodeBase2.prototype.selectChildren = function(leftEnd, rightEnd) {
      return new MQSelection(leftEnd, rightEnd);
    };
    NodeBase2.prototype.bubble = function(yield_) {
      var self = this.getSelfNode();
      for (var ancestor = self; ancestor; ancestor = ancestor.parent) {
        var result = yield_(ancestor);
        if (result === false) break;
      }
      return this;
    };
    NodeBase2.prototype.postOrder = function(yield_) {
      var self = this.getSelfNode();
      (function recurse(descendant) {
        if (!descendant) return false;
        descendant.eachChild(recurse);
        yield_(descendant);
        return true;
      })(self);
      return self;
    };
    NodeBase2.prototype.isEmpty = function() {
      return this.ends[L] === 0 && this.ends[R] === 0;
    };
    NodeBase2.prototype.isQuietEmptyDelimiter = function(dlms) {
      if (!this.isEmpty()) return false;
      if (!dlms) return false;
      if (!this.parent || this.parent.ctrlSeq === void 0) return false;
      var key = this.parent.ctrlSeq.replace(/^\\(left|right)?/, "");
      return dlms.hasOwnProperty(key);
    };
    NodeBase2.prototype.isStyleBlock = function() {
      return false;
    };
    NodeBase2.prototype.isTextBlock = function() {
      return false;
    };
    NodeBase2.prototype.children = function() {
      return new Fragment(this.getEnd(L), this.getEnd(R));
    };
    NodeBase2.prototype.eachChild = function(yield_) {
      eachNode(this.ends, yield_);
      return this;
    };
    NodeBase2.prototype.foldChildren = function(fold, yield_) {
      return foldNodes(this.ends, fold, yield_);
    };
    NodeBase2.prototype.withDirAdopt = function(dir, parent, withDir, oppDir) {
      var self = this.getSelfNode();
      new Fragment(self, self).withDirAdopt(dir, parent, withDir, oppDir);
      return this;
    };
    NodeBase2.prototype.adopt = function(parent, leftward, rightward) {
      var self = this.getSelfNode();
      new Fragment(self, self).adopt(parent, leftward, rightward);
      return this.getSelfNode();
    };
    NodeBase2.prototype.disown = function() {
      var self = this.getSelfNode();
      new Fragment(self, self).disown();
      return this;
    };
    NodeBase2.prototype.remove = function() {
      this.domFrag().remove();
      return this.disown();
    };
    NodeBase2.prototype.shouldIgnoreSubstitutionInSimpleSubscript = function(options) {
      var opt = options.disableAutoSubstitutionInSubscripts;
      if (!opt) return false;
      if (!this.parent) return false;
      if (!(this.parent.parent instanceof SupSub)) return false;
      var before = this.parent.parent[L];
      if (typeof opt === "object" && before instanceof Letter && before.endsWord && opt.except[before.endsWord]) {
        return false;
      }
      if (!this.parent.domFrag().hasClass("mq-sub")) return false;
      return true;
    };
    NodeBase2.prototype.getSelfNode = function() {
      return this;
    };
    NodeBase2.prototype.parser = function() {
      pray("Abstract parser() method is never called", false);
    };
    NodeBase2.prototype.html = function() {
      throw new Error("html() unimplemented in NodeBase");
    };
    NodeBase2.prototype.text = function() {
      return "";
    };
    NodeBase2.prototype.latex = function() {
      var ctx = {
        uncleanedLatex: "",
        uncleanedStartIndex: -1,
        uncleanedEndIndex: -1
      };
      this.latexRecursive(ctx);
      return ctx.uncleanedLatex;
    };
    NodeBase2.prototype.latexRecursive = function(_ctx) {
    };
    NodeBase2.prototype.checkCursorContextOpen = function(ctx) {
      var latexLength = ctx.uncleanedLatex.length;
      if (ctx.startSelectionBefore === this) {
        ctx.uncleanedStartIndex = latexLength;
      }
      if (ctx.endSelectionBefore === this) {
        ctx.uncleanedEndIndex = latexLength;
      }
      var restoreInfo = ctx.restoreInfo;
      if (restoreInfo) {
        if (latexLength === restoreInfo.uncleanedStartIndex) {
          if (restoreInfo.uncleanedEndIndex === restoreInfo.uncleanedStartIndex) {
            if (latexLength === restoreInfo.uncleanedStartIndex) {
              restoreInfo.cursorParent = this.parent;
            }
          } else {
            restoreInfo.selectionL = this;
          }
        }
      }
    };
    NodeBase2.prototype.checkCursorContextClose = function(ctx) {
      var latexLength = ctx.uncleanedLatex.length;
      if (ctx.startSelectionAfter === this) {
        ctx.uncleanedStartIndex = latexLength;
      }
      if (ctx.endSelectionAfter === this) {
        ctx.uncleanedEndIndex = latexLength;
      }
      var restoreInfo = ctx.restoreInfo;
      if (restoreInfo) {
        if (latexLength === restoreInfo.uncleanedEndIndex) {
          if (restoreInfo.uncleanedStartIndex === restoreInfo.uncleanedEndIndex) {
            if (!restoreInfo.cursorL) {
              restoreInfo.cursorL = this;
            }
            if (!restoreInfo.cursorParent) {
              restoreInfo.cursorParent = this.parent;
            } else if (restoreInfo.cursorParent === this.parent) {
              restoreInfo.cursorParent = this;
              restoreInfo.cursorL = 0;
            }
          } else {
            if (!restoreInfo.selectionR) {
              restoreInfo.selectionR = this;
            }
          }
        }
      }
    };
    NodeBase2.prototype.finalizeTree = function(_options, _dir) {
    };
    NodeBase2.prototype.contactWeld = function(_cursor, _dir) {
    };
    NodeBase2.prototype.blur = function(_cursor) {
    };
    NodeBase2.prototype.focus = function() {
    };
    NodeBase2.prototype.intentionalBlur = function() {
    };
    NodeBase2.prototype.reflow = function() {
    };
    NodeBase2.prototype.registerInnerField = function(_innerFields, _mathField) {
    };
    NodeBase2.prototype.chToCmd = function(_ch, _options) {
      pray("Abstract chToCmd() method is never called", false);
    };
    NodeBase2.prototype.mathspeak = function(_options) {
      return "";
    };
    NodeBase2.prototype.seek = function(_clientX, _cursor) {
    };
    NodeBase2.prototype.siblingDeleted = function(_options, _dir) {
    };
    NodeBase2.prototype.siblingCreated = function(_options, _dir) {
    };
    NodeBase2.prototype.finalizeInsert = function(_options, _cursor) {
    };
    NodeBase2.prototype.fixDigitGrouping = function(_opts) {
    };
    NodeBase2.prototype.writeLatex = function(_cursor, _latex) {
    };
    NodeBase2.prototype.write = function(_cursor, _ch) {
    };
    var _a, _b;
    _a = L, _b = R;
    NodeBase2.idCounter = 0;
    return NodeBase2;
  })()
);
function prayWellFormed(parent, leftward, rightward) {
  pray("a parent is always present", parent);
  pray(
    "leftward is properly set up",
    (function() {
      if (!leftward) return parent.getEnd(L) === rightward;
      return leftward[R] === rightward && leftward.parent === parent;
    })(),
    {
      parent,
      leftward,
      leftwardL: leftward && leftward[L],
      leftwardR: leftward && leftward[R],
      rightwardL: rightward && rightward[L],
      rightwardR: rightward && rightward[R]
    }
  );
  pray(
    "rightward is properly set up",
    (function() {
      if (!rightward) return parent.getEnd(R) === leftward;
      return rightward[L] === leftward && rightward.parent === parent;
    })(),
    {
      parent,
      rightward,
      leftwardL: leftward && leftward[L],
      leftwardR: leftward && leftward[R],
      rightwardL: rightward && rightward[L],
      rightwardR: rightward && rightward[R],
      rightwardParent: rightward && rightward.parent
    }
  );
}
var Fragment = (
  /** @class */
  (function() {
    function Fragment2(withDir, oppDir, dir) {
      var _c, _d;
      this.disowned = false;
      if (dir === void 0) dir = L;
      prayDirection(dir);
      pray("no half-empty fragments", !withDir === !oppDir, {
        withDir,
        oppDir
      });
      if (!withDir || !oppDir) {
        this.setEnds((_c = {}, _c[L] = 0, _c[R] = 0, _c));
        return;
      }
      pray("withDir is passed to Fragment", withDir instanceof MQNode);
      pray("oppDir is passed to Fragment", oppDir instanceof MQNode);
      pray(
        "withDir and oppDir have the same parent",
        withDir.parent === oppDir.parent
      );
      var ends = (_d = {}, _d[dir] = withDir, _d[-dir] = oppDir, _d);
      this.setEnds(ends);
      var maybeRightEnd = 0;
      this.each(function(el) {
        maybeRightEnd = el;
      });
      pray(
        "following direction siblings from start reaches end",
        maybeRightEnd === ends[R]
      );
    }
    Fragment2.prototype.getDOMFragFromEnds = function() {
      var left = this.ends[L];
      var right = this.ends[R];
      if (left === 0 || right === 0) {
        return domFrag();
      } else if (left === right) {
        return left.domFrag();
      } else {
        return left.domFrag().join(right.domFrag());
      }
    };
    Fragment2.prototype.setEnds = function(ends) {
      this.ends = ends;
    };
    Fragment2.prototype.getEnd = function(dir) {
      return this.ends ? this.ends[dir] : 0;
    };
    Fragment2.prototype.domFrag = function() {
      return this.getDOMFragFromEnds();
    };
    Fragment2.prototype.withDirAdopt = function(dir, parent, withDir, oppDir) {
      return dir === L ? this.adopt(parent, withDir, oppDir) : this.adopt(parent, oppDir, withDir);
    };
    Fragment2.prototype.adopt = function(parent, leftward, rightward) {
      var _c;
      prayWellFormed(parent, leftward, rightward);
      var self = this;
      this.disowned = false;
      var leftEnd = self.ends[L];
      if (!leftEnd) return this;
      var rightEnd = self.ends[R];
      if (!rightEnd) return this;
      var ends = (_c = {}, _c[L] = parent.getEnd(L), _c[R] = parent.getEnd(R), _c);
      if (leftward) ;
      else {
        ends[L] = leftEnd;
      }
      if (rightward) {
        rightward[L] = rightEnd;
      } else {
        ends[R] = rightEnd;
      }
      parent.setEnds(ends);
      rightEnd[R] = rightward;
      self.each(function(el) {
        el[L] = leftward;
        el.parent = parent;
        if (leftward) leftward[R] = el;
        leftward = el;
        return true;
      });
      return self;
    };
    Fragment2.prototype.disown = function() {
      var _c;
      var self = this;
      var leftEnd = self.ends[L];
      if (!leftEnd || self.disowned) return self;
      this.disowned = true;
      var rightEnd = self.ends[R];
      if (!rightEnd) return self;
      var parent = leftEnd.parent;
      prayWellFormed(parent, leftEnd[L], leftEnd);
      prayWellFormed(parent, rightEnd, rightEnd[R]);
      var ends = (_c = {}, _c[L] = parent.getEnd(L), _c[R] = parent.getEnd(R), _c);
      if (leftEnd[L]) {
        var leftLeftEnd = leftEnd[L];
        leftLeftEnd[R] = rightEnd[R];
      } else {
        ends[L] = rightEnd[R];
      }
      if (rightEnd[R]) {
        var rightRightEnd = rightEnd[R];
        rightRightEnd[L] = leftEnd[L];
      } else {
        ends[R] = leftEnd[L];
      }
      if (ends[L] && ends[R]) {
        parent.setEnds(ends);
      } else {
        parent.ends = ends;
      }
      return self;
    };
    Fragment2.prototype.remove = function() {
      this.domFrag().remove();
      return this.disown();
    };
    Fragment2.prototype.each = function(yield_) {
      eachNode(this.ends, yield_);
      return this;
    };
    Fragment2.prototype.fold = function(fold, yield_) {
      return foldNodes(this.ends, fold, yield_);
    };
    return Fragment2;
  })()
);
var LatexCmds = {};
var CharCmds = {};
function isMQNodeClass(cmd) {
  return cmd && cmd.prototype instanceof MQNode;
}
var Anticursor = (
  /** @class */
  (function(_super) {
    __extends(Anticursor2, _super);
    function Anticursor2(parent, leftward, rightward) {
      var _this_1 = _super.call(this, parent, leftward, rightward) || this;
      _this_1.ancestors = {};
      return _this_1;
    }
    Anticursor2.fromCursor = function(cursor) {
      return new Anticursor2(cursor.parent, cursor[L], cursor[R]);
    };
    return Anticursor2;
  })(Point)
);
var Cursor = (
  /** @class */
  (function(_super) {
    __extends(Cursor2, _super);
    function Cursor2(initParent, options, controller) {
      var _this_1 = _super.call(this, initParent, 0, 0) || this;
      _this_1.upDownCache = {};
      _this_1.cursorElement = h("span", { class: "mq-cursor" }, [
        h.text(U_ZERO_WIDTH_SPACE)
      ]);
      _this_1._domFrag = domFrag();
      _this_1.controller = controller;
      _this_1.options = options;
      _this_1.setDOMFrag(domFrag(_this_1.cursorElement));
      _this_1.blink = function() {
        domFrag(_this_1.cursorElement).toggleClass("mq-blink");
      };
      return _this_1;
    }
    Cursor2.prototype.setDOMFrag = function(frag) {
      this._domFrag = frag;
      return this;
    };
    Cursor2.prototype.domFrag = function() {
      return this._domFrag;
    };
    Cursor2.prototype.show = function() {
      domFrag(this.cursorElement).removeClass("mq-blink");
      this.setDOMFrag(domFrag(this.cursorElement));
      if (this.intervalId)
        clearInterval(this.intervalId);
      else {
        var right = this[R];
        if (right) {
          var selection = this.selection;
          if (selection && selection.getEnd(L)[L] === this[L])
            this.domFrag().insertBefore(selection.domFrag());
          else this.domFrag().insertBefore(right.domFrag());
        } else this.domFrag().appendTo(this.parent.domFrag().oneElement());
        this.parent.focus();
      }
      this.intervalId = setInterval(this.blink, 500);
      return this;
    };
    Cursor2.prototype.hide = function() {
      if (this.intervalId) clearInterval(this.intervalId);
      this.intervalId = 0;
      this.domFrag().detach();
      this.setDOMFrag(domFrag());
      return this;
    };
    Cursor2.prototype.withDirInsertAt = function(dir, parent, withDir, oppDir) {
      var oldParent = this.parent;
      this.parent = parent;
      this[dir] = withDir;
      this[-dir] = oppDir;
      if (oldParent !== parent && oldParent.blur) oldParent.blur(this);
    };
    Cursor2.prototype.insDirOf = function(dir, el) {
      prayDirection(dir);
      this.domFrag().insDirOf(dir, el.domFrag());
      this.withDirInsertAt(dir, el.parent, el[dir], el);
      this.parent.domFrag().addClass("mq-hasCursor");
      return this;
    };
    Cursor2.prototype.insLeftOf = function(el) {
      return this.insDirOf(L, el);
    };
    Cursor2.prototype.insRightOf = function(el) {
      return this.insDirOf(R, el);
    };
    Cursor2.prototype.insAtDirEnd = function(dir, el) {
      prayDirection(dir);
      this.domFrag().insAtDirEnd(dir, el.domFrag().oneElement());
      this.withDirInsertAt(dir, el, 0, el.getEnd(dir));
      el.focus();
      return this;
    };
    Cursor2.prototype.insAtLeftEnd = function(el) {
      return this.insAtDirEnd(L, el);
    };
    Cursor2.prototype.insAtRightEnd = function(el) {
      return this.insAtDirEnd(R, el);
    };
    Cursor2.prototype.jumpUpDown = function(from, to) {
      var self = this;
      self.upDownCache[from.id] = Point.copy(self);
      var cached = self.upDownCache[to.id];
      if (cached) {
        var cachedR = cached[R];
        if (cachedR) {
          self.insLeftOf(cachedR);
        } else {
          self.insAtRightEnd(cached.parent);
        }
      } else {
        var clientX = self.getBoundingClientRectWithoutMargin().left;
        to.seek(clientX, self);
      }
      self.controller.aria.queue(to, true);
    };
    Cursor2.prototype.getBoundingClientRectWithoutMargin = function() {
      var frag = this.domFrag();
      frag.removeClass("mq-cursor");
      var _c = getBoundingClientRect(frag.oneElement()), left = _c.left, right = _c.right;
      frag.addClass("mq-cursor");
      return {
        left,
        right
      };
    };
    Cursor2.prototype.unwrapGramp = function() {
      var gramp = this.parent.parent;
      var greatgramp = gramp.parent;
      var rightward = gramp[R];
      var cursor = this;
      var leftward = gramp[L];
      gramp.disown().eachChild(function(uncle) {
        if (uncle.isEmpty()) return true;
        uncle.children().adopt(greatgramp, leftward, rightward).each(function(cousin) {
          cousin.domFrag().insertBefore(gramp.domFrag());
          return true;
        });
        leftward = uncle.getEnd(R);
        return true;
      });
      if (!this[R]) {
        var thisL = this[L];
        if (thisL) this[R] = thisL[R];
        else {
          while (!this[R]) {
            var newParent = this.parent[R];
            if (newParent) {
              this.parent = newParent;
              this[R] = newParent.getEnd(L);
            } else {
              this[R] = gramp[R];
              this.parent = greatgramp;
              break;
            }
          }
        }
      }
      var thisR = this[R];
      if (thisR) this.insLeftOf(thisR);
      else this.insAtRightEnd(greatgramp);
      gramp.domFrag().remove();
      var grampL = gramp[L];
      var grampR = gramp[R];
      if (grampL) grampL.siblingDeleted(cursor.options, R);
      if (grampR) grampR.siblingDeleted(cursor.options, L);
    };
    Cursor2.prototype.startSelection = function() {
      var anticursor = this.anticursor = Anticursor.fromCursor(this);
      var ancestors = anticursor.ancestors;
      for (var ancestor = anticursor; ancestor.parent; ancestor = ancestor.parent) {
        ancestors[ancestor.parent.id] = ancestor;
      }
    };
    Cursor2.prototype.endSelection = function() {
      delete this.anticursor;
    };
    Cursor2.prototype.select = function() {
      var _lca;
      var anticursor = this.anticursor;
      if (this[L] === anticursor[L] && this.parent === anticursor.parent)
        return false;
      for (var ancestor = this; ancestor.parent; ancestor = ancestor.parent) {
        if (ancestor.parent.id in anticursor.ancestors) {
          _lca = ancestor.parent;
          break;
        }
      }
      pray("cursor and anticursor in the same tree", _lca);
      var lca = _lca;
      var antiAncestor = anticursor.ancestors[lca.id];
      var leftEnd, rightEnd, dir = R;
      if (ancestor[L] !== antiAncestor) {
        for (var rightward = ancestor; rightward; rightward = rightward[R]) {
          if (rightward[R] === antiAncestor[R]) {
            dir = L;
            leftEnd = ancestor;
            rightEnd = antiAncestor;
            break;
          }
        }
      }
      if (dir === R) {
        leftEnd = antiAncestor;
        rightEnd = ancestor;
      }
      if (leftEnd instanceof Point) leftEnd = leftEnd[R];
      if (rightEnd instanceof Point) rightEnd = rightEnd[L];
      this.hide().selection = lca.selectChildren(leftEnd, rightEnd);
      var insEl = this.selection.getEnd(dir);
      this.insDirOf(dir, insEl);
      this.selectionChanged();
      return true;
    };
    Cursor2.prototype.resetToEnd = function(controller) {
      this.clearSelection();
      var root = controller.root;
      this[R] = 0;
      this[L] = root.getEnd(R);
      this.parent = root;
    };
    Cursor2.prototype.clearSelection = function() {
      if (this.selection) {
        this.selection.clear();
        delete this.selection;
        this.selectionChanged();
      }
      return this;
    };
    Cursor2.prototype.deleteSelection = function() {
      var selection = this.selection;
      if (!selection) return;
      this[L] = selection.getEnd(L)[L];
      this[R] = selection.getEnd(R)[R];
      selection.remove();
      this.selectionChanged();
      delete this.selection;
    };
    Cursor2.prototype.replaceSelection = function() {
      var seln = this.selection;
      if (seln) {
        this[L] = seln.getEnd(L)[L];
        this[R] = seln.getEnd(R)[R];
        delete this.selection;
      }
      return seln;
    };
    Cursor2.prototype.depth = function() {
      var node = this;
      var depth = 0;
      while (node = node.parent) {
        depth += node instanceof MathBlock ? 1 : 0;
      }
      return depth;
    };
    Cursor2.prototype.isTooDeep = function(offset) {
      if (this.options.maxDepth !== void 0) {
        return this.depth() + (offset || 0) > this.options.maxDepth;
      } else {
        return false;
      }
    };
    Cursor2.prototype.selectionChanged = function() {
    };
    return Cursor2;
  })(Point)
);
var MQSelection = (
  /** @class */
  (function(_super) {
    __extends(MQSelection2, _super);
    function MQSelection2(withDir, oppDir, dir) {
      var _this_1 = _super.call(this, withDir, oppDir, dir) || this;
      _this_1._el = h("span", { class: "mq-selection" });
      _this_1.getDOMFragFromEnds().wrapAll(_this_1._el);
      return _this_1;
    }
    MQSelection2.prototype.isCleared = function() {
      return this._el === void 0;
    };
    MQSelection2.prototype.domFrag = function() {
      return this.isCleared() ? this.getDOMFragFromEnds() : domFrag(this._el);
    };
    MQSelection2.prototype.setEnds = function(ends) {
      pray("Selection ends are never empty", ends[L] && ends[R]);
      this.ends = ends;
    };
    MQSelection2.prototype.getEnd = function(dir) {
      return this.ends[dir];
    };
    MQSelection2.prototype.adopt = function(parent, leftward, rightward) {
      this.clear();
      return _super.prototype.adopt.call(this, parent, leftward, rightward);
    };
    MQSelection2.prototype.clear = function() {
      var childFrag = this.getDOMFragFromEnds();
      this.domFrag().replaceWith(childFrag);
      this._el = void 0;
      return this;
    };
    MQSelection2.prototype.join = function(methodName, separator) {
      if (separator === void 0) {
        separator = "";
      }
      return this.fold("", function(fold, child) {
        return fold + separator + child[methodName]();
      });
    };
    return MQSelection2;
  })(Fragment)
);
var ControllerBase = (
  /** @class */
  (function() {
    function ControllerBase2(root, container, options) {
      this.isMouseSelecting = false;
      this.textareaEventListeners = {};
      this.id = root.id;
      this.data = {};
      this.root = root;
      this.container = container;
      this.options = options;
      this.aria = new Aria(this.getControllerSelf());
      this.ariaLabel = "Math Input";
      this.ariaPostLabel = "";
      root.controller = this.getControllerSelf();
      this.cursor = root.cursor = new Cursor(
        root,
        options,
        this.getControllerSelf()
      );
    }
    ControllerBase2.isControllerRoot = function(node) {
      var ctrlr = node.controller;
      return ctrlr && ctrlr.root === node;
    };
    ControllerBase2.prototype.getControllerSelf = function() {
      return this;
    };
    ControllerBase2.prototype.handle = function(name, dir) {
      var _c;
      var handlers = this.options.handlers;
      var handler = (_c = this.options.handlers) === null || _c === void 0 ? void 0 : _c.fns[name];
      if (handler) {
        var APIClass = handlers === null || handlers === void 0 ? void 0 : handlers.APIClasses[this.KIND_OF_MQ];
        pray("APIClass is defined", APIClass);
        var mq = new APIClass(this);
        if (dir === L || dir === R) handler(dir, mq);
        else handler(mq);
      }
    };
    ControllerBase2.onNotify = function(f) {
      ControllerBase2.notifyees.push(f);
    };
    ControllerBase2.prototype.notify = function(e) {
      for (var i = 0; i < ControllerBase2.notifyees.length; i += 1) {
        ControllerBase2.notifyees[i](this.cursor, e);
      }
      return this;
    };
    ControllerBase2.prototype.setAriaLabel = function(ariaLabel) {
      var oldAriaLabel = this.getAriaLabel();
      if (!ariaLabel && this.editable) {
        this.ariaLabel = "Math Input";
      } else {
        this.ariaLabel = ariaLabel;
      }
      if (ariaLabel !== oldAriaLabel && !this.containerHasFocus()) {
        this.updateMathspeak();
      }
      return this;
    };
    ControllerBase2.prototype.getAriaLabel = function() {
      if (this.ariaLabel !== "Math Input") {
        return this.ariaLabel;
      } else if (this.editable) {
        return "Math Input";
      } else {
        return "";
      }
    };
    ControllerBase2.prototype.setAriaPostLabel = function(ariaPostLabel, timeout) {
      var _this_1 = this;
      if (ariaPostLabel && typeof ariaPostLabel === "string" && ariaPostLabel !== "") {
        if (ariaPostLabel !== this.ariaPostLabel && typeof timeout === "number") {
          if (this._ariaAlertTimeout)
            clearTimeout(this._ariaAlertTimeout);
          this._ariaAlertTimeout = setTimeout(function() {
            if (_this_1.containerHasFocus()) {
              _this_1.aria.alert(
                _this_1.root.mathspeak().trim() + " " + ariaPostLabel.trim()
              );
            } else {
              _this_1.updateMathspeak();
            }
          }, timeout);
        }
        this.ariaPostLabel = ariaPostLabel;
      } else {
        if (this._ariaAlertTimeout) clearTimeout(this._ariaAlertTimeout);
        this.ariaPostLabel = "";
      }
      return this;
    };
    ControllerBase2.prototype.getAriaPostLabel = function() {
      return this.ariaPostLabel || "";
    };
    ControllerBase2.prototype.containerHasFocus = function() {
      return document.activeElement && this.container.contains(document.activeElement);
    };
    ControllerBase2.prototype.getTextarea = function() {
      var textarea = this.textarea;
      pray("textarea initialized", textarea);
      return textarea;
    };
    ControllerBase2.prototype.getTextareaSpan = function() {
      var textareaSpan = this.textareaSpan;
      pray("textareaSpan initialized", textareaSpan);
      return textareaSpan;
    };
    ControllerBase2.prototype.addTextareaEventListeners = function(listeners) {
      if (!this.textarea) return;
      for (var key_2 in listeners) {
        var event = key_2;
        this.removeTextareaEventListener(event);
        this.textarea.addEventListener(event, listeners[event]);
      }
    };
    ControllerBase2.prototype.removeTextareaEventListener = function(event) {
      if (!this.textarea) return;
      var listener = this.textareaEventListeners[event];
      if (!listener) return;
      this.textarea.removeEventListener(event, listener);
    };
    ControllerBase2.prototype.exportMathSpeak = function() {
      return this.root.mathspeak();
    };
    ControllerBase2.prototype.updateMathspeak = function(_opts) {
    };
    ControllerBase2.prototype.scrollHoriz = function() {
    };
    ControllerBase2.prototype.selectionChanged = function() {
    };
    ControllerBase2.prototype.setOverflowClasses = function() {
    };
    ControllerBase2.notifyees = [];
    return ControllerBase2;
  })()
);
var API = {};
var EMBEDS = {};
var baseOptionProcessors = {};
var Options = (
  /** @class */
  (function() {
    function Options2(version) {
      this.version = version;
    }
    Options2.prototype.assertJquery = function() {
      pray(
        "Interface versions > 2 do not depend on JQuery",
        this.version <= 2
      );
      pray("JQuery is set for interface v < 3", this.jQuery);
      return this.jQuery;
    };
    return Options2;
  })()
);
var Progenote = (
  /** @class */
  /* @__PURE__ */ (function() {
    function Progenote2() {
    }
    return Progenote2;
  })()
);
var insistOnInterVer = function() {
  if (window.console)
    console.warn(
      'You are using the MathQuill API without specifying an interface version, which will fail in v1.0.0. Easiest fix is to do the following before doing anything else:\n\n    MathQuill = MathQuill.getInterface(1);\n    // now MathQuill.MathField() works like it used to\n\nSee also the "`dev` branch (2014–2015) → v0.10.0 Migration Guide" at\n  https://github.com/mathquill/mathquill/wiki/%60dev%60-branch-(2014%E2%80%932015)-%E2%86%92-v0.10.0-Migration-Guide'
    );
};
var MQ1;
function MathQuill(el) {
  insistOnInterVer();
  if (!MQ1) {
    MQ1 = getInterface(1);
  }
  return MQ1(el);
}
MathQuill.prototype = Progenote.prototype;
MathQuill.VERSION = "v0.10.1";
MathQuill.interfaceVersion = function(v) {
  if (v !== 1)
    throw "Only interface version 1 supported. You specified: " + v;
  insistOnInterVer = function() {
    if (window.console)
      console.warn(
        'You called MathQuill.interfaceVersion(1); to specify the interface version, which will fail in v1.0.0. You can fix this easily by doing this before doing anything else:\n\n    MathQuill = MathQuill.getInterface(1);\n    // now MathQuill.MathField() works like it used to\n\nSee also the "`dev` branch (2014–2015) → v0.10.0 Migration Guide" at\n  https://github.com/mathquill/mathquill/wiki/%60dev%60-branch-(2014%E2%80%932015)-%E2%86%92-v0.10.0-Migration-Guide'
      );
  };
  insistOnInterVer();
  return MathQuill;
};
MathQuill.getInterface = getInterface;
var MIN = getInterface.MIN = 1, MAX = getInterface.MAX = 3;
function getInterface(v) {
  if (v !== 1 && v !== 2 && v !== 3)
    throw "Only interface versions between " + MIN + " and " + MAX + " supported. You specified: " + v;
  var version = v;
  if (version < 3) {
    var jQuery = window.jQuery;
    if (!jQuery)
      throw "MathQuill interface version ".concat(
        version,
        " requires jQuery 1.5.2+ to be loaded first"
      );
    Options.prototype.jQuery = jQuery;
  }
  var optionProcessors = __assign(__assign({}, baseOptionProcessors), {
    handlers: function(handlers) {
      return {
        // casting to the v3 version of this type
        fns: handlers || {},
        APIClasses
      };
    }
  });
  function config(currentOptions, newOptions) {
    for (var name in newOptions) {
      if (newOptions.hasOwnProperty(name)) {
        if (name === "substituteKeyboardEvents" && version >= 3) {
          throw new Error(
            [
              "As of interface version 3, the 'substituteKeyboardEvents'",
              "option is no longer supported. Use 'overrideTypedText' and",
              "'overrideKeystroke' instead."
            ].join(" ")
          );
        }
        var value = newOptions[name];
        var processor = optionProcessors[name];
        currentOptions[name] = processor ? processor(value) : value;
      }
    }
  }
  var BaseOptions = version < 3 ? Options : (
    /** @class */
    (function(_super) {
      __extends(BaseOptions2, _super);
      function BaseOptions2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      return BaseOptions2;
    })(Options)
  );
  var AbstractMathQuill = (
    /** @class */
    (function(_super) {
      __extends(AbstractMathQuill2, _super);
      function AbstractMathQuill2(ctrlr) {
        var _this_1 = _super.call(this) || this;
        _this_1.__controller = ctrlr;
        _this_1.__options = ctrlr.options;
        _this_1.id = ctrlr.id;
        _this_1.data = ctrlr.data;
        return _this_1;
      }
      AbstractMathQuill2.prototype.mathquillify = function(classNames) {
        var ctrlr = this.__controller, root = ctrlr.root, el = ctrlr.container;
        ctrlr.createTextarea();
        var contents = domFrag(el).addClass(classNames).children().detach();
        root.setDOM(
          domFrag(
            h("span", {
              class: "mq-root-block",
              "aria-hidden": true
            })
          ).appendTo(el).oneElement()
        );
        NodeBase.linkElementByBlockNode(root.domFrag().oneElement(), root);
        this.latex(contents.text());
        this.revert = function() {
          ctrlr.removeMouseEventListener();
          domFrag(el).removeClass("mq-editable-field mq-math-mode mq-text-mode").empty().append(contents);
          return version < 3 ? this.__options.assertJquery()(el) : el;
        };
      };
      AbstractMathQuill2.prototype.setAriaLabel = function(ariaLabel) {
        this.__controller.setAriaLabel(ariaLabel);
        return this;
      };
      AbstractMathQuill2.prototype.getAriaLabel = function() {
        return this.__controller.getAriaLabel();
      };
      AbstractMathQuill2.prototype.config = function(opts) {
        config(this.__options, opts);
        if (opts.tabindex !== void 0) {
          this.__controller.setTabindex(opts.tabindex);
        }
        return this;
      };
      AbstractMathQuill2.prototype.el = function() {
        return this.__controller.container;
      };
      AbstractMathQuill2.prototype.text = function() {
        return this.__controller.exportText();
      };
      AbstractMathQuill2.prototype.mathspeak = function() {
        return this.__controller.exportMathSpeak();
      };
      AbstractMathQuill2.prototype.latex = function(latex) {
        if (arguments.length > 0) {
          this.__controller.renderLatexMath(latex);
          var cursor = this.__controller.cursor;
          if (this.__controller.blurred)
            cursor.hide().parent.blur(cursor);
          return this;
        }
        return this.__controller.exportLatex();
      };
      AbstractMathQuill2.prototype.selection = function(selection) {
        if (selection) {
          this.__controller.restoreLatexSelection(selection);
          return this;
        }
        return this.__controller.exportLatexSelection().selection;
      };
      AbstractMathQuill2.prototype.html = function() {
        return this.__controller.root.domFrag().oneElement().innerHTML.replace(/ jQuery\d+="(?:\d+|null)"/g, "").replace(/ mathquill-(?:command|block)-id="?\d+"?/g, "").replace(
          /<span class="?mq-cursor( mq-blink)?"?>.?<\/span>/i,
          ""
        ).replace(/ mq-hasCursor|mq-hasCursor ?/, "").replace(/ class=(""|(?= |>))/g, "");
      };
      AbstractMathQuill2.prototype.reflow = function() {
        this.__controller.root.postOrder(function(node) {
          node.reflow();
        });
        return this;
      };
      AbstractMathQuill2.prototype.focus = function() {
        this.__controller.getTextarea().focus();
        if (this.__controller.editable) this.__controller.scrollHoriz();
        return this;
      };
      AbstractMathQuill2.prototype.select = function() {
        this.__controller.selectAll();
        return this;
      };
      AbstractMathQuill2.prototype.blur = function() {
        this.__controller.getTextarea().blur();
        return this;
      };
      return AbstractMathQuill2;
    })(Progenote)
  );
  var EditableField = (
    /** @class */
    (function(_super) {
      __extends(EditableField2, _super);
      function EditableField2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      EditableField2.prototype.mathquillify = function(classNames) {
        _super.prototype.mathquillify.call(this, classNames);
        this.__controller.editable = true;
        this.__controller.addMouseEventListener();
        this.__controller.editablesTextareaEvents();
        return this;
      };
      EditableField2.prototype.clearSelection = function() {
        this.__controller.cursor.clearSelection();
        return this;
      };
      EditableField2.prototype.write = function(latex) {
        this.__controller.writeLatex(latex);
        this.__controller.scrollHoriz();
        var cursor = this.__controller.cursor;
        if (this.__controller.blurred) cursor.hide().parent.blur(cursor);
        return this;
      };
      EditableField2.prototype.empty = function() {
        var _c;
        var root = this.__controller.root, cursor = this.__controller.cursor;
        root.setEnds((_c = {}, _c[L] = 0, _c[R] = 0, _c));
        root.domFrag().empty();
        delete cursor.selection;
        cursor.insAtRightEnd(root);
        return this;
      };
      EditableField2.prototype.cmd = function(cmd) {
        var ctrlr = this.__controller.notify(void 0), cursor = ctrlr.cursor;
        if (/^\\[a-z]+$/i.test(cmd) && !cursor.isTooDeep()) {
          cmd = cmd.slice(1);
          var klass = LatexCmds[cmd];
          var node;
          if (klass) {
            if (klass.constructor) {
              node = new klass(cmd);
            } else {
              node = klass(cmd);
            }
            if (cursor.selection)
              node.replaces(cursor.replaceSelection());
            node.createLeftOf(cursor.show());
          }
        } else cursor.parent.write(cursor, cmd);
        ctrlr.scrollHoriz();
        if (ctrlr.blurred) cursor.hide().parent.blur(cursor);
        return this;
      };
      EditableField2.prototype.moveToDirEnd = function(dir) {
        this.__controller.notify("move").cursor.insAtDirEnd(dir, this.__controller.root);
        return this;
      };
      EditableField2.prototype.moveToLeftEnd = function() {
        return this.moveToDirEnd(L);
      };
      EditableField2.prototype.moveToRightEnd = function() {
        return this.moveToDirEnd(R);
      };
      EditableField2.prototype.keystroke = function(keysString, evt) {
        var keys = keysString.replace(/^\s+|\s+$/g, "").split(/\s+/);
        for (var i = 0; i < keys.length; i += 1) {
          this.__controller.keystroke(keys[i], evt);
        }
        return this;
      };
      EditableField2.prototype.typedText = function(text) {
        for (var i = 0; i < text.length; i += 1)
          this.__controller.typedText(text.charAt(i));
        return this;
      };
      EditableField2.prototype.dropEmbedded = function(pageX, pageY, options) {
        var clientX = pageX - getScrollX();
        var clientY = pageY - getScrollY();
        var el = document.elementFromPoint(clientX, clientY);
        this.__controller.seek(el, clientX, clientY);
        var cmd = new EmbedNode().setOptions(options);
        cmd.createLeftOf(this.__controller.cursor);
      };
      EditableField2.prototype.setAriaPostLabel = function(ariaPostLabel, timeout) {
        this.__controller.setAriaPostLabel(ariaPostLabel, timeout);
        return this;
      };
      EditableField2.prototype.getAriaPostLabel = function() {
        return this.__controller.getAriaPostLabel();
      };
      EditableField2.prototype.clickAt = function(clientX, clientY, target) {
        target = target || document.elementFromPoint(clientX, clientY);
        var ctrlr = this.__controller, root = ctrlr.root;
        var rootElement = root.domFrag().oneElement();
        if (!rootElement.contains(target)) target = rootElement;
        ctrlr.seek(target, clientX, clientY);
        if (ctrlr.blurred) this.focus();
        return this;
      };
      EditableField2.prototype.ignoreNextMousedown = function(fn) {
        this.__controller.cursor.options.ignoreNextMousedown = fn;
        return this;
      };
      EditableField2.prototype.isUserSelecting = function() {
        return this.__controller.isMouseSelecting;
      };
      return EditableField2;
    })(AbstractMathQuill)
  );
  var APIClasses = {
    AbstractMathQuill,
    EditableField
  };
  pray("API.StaticMath defined", API.StaticMath);
  APIClasses.StaticMath = API.StaticMath(APIClasses);
  pray("API.MathField defined", API.MathField);
  APIClasses.MathField = API.MathField(APIClasses);
  pray("API.InnerMathField defined", API.InnerMathField);
  APIClasses.InnerMathField = API.InnerMathField(APIClasses);
  if (API.TextField) {
    APIClasses.TextField = API.TextField(APIClasses);
  }
  var MQ2 = function(el) {
    if (!el || !el.nodeType) return null;
    var blockElement;
    var childArray = domFrag(el).children().toElementArray();
    for (var _i = 0, childArray_1 = childArray; _i < childArray_1.length; _i++) {
      var child = childArray_1[_i];
      if (child.classList.contains("mq-root-block")) {
        blockElement = child;
        break;
      }
    }
    var blockNode = NodeBase.getNodeOfElement(blockElement);
    var ctrlr = blockNode && blockNode.controller;
    var APIClass = ctrlr && APIClasses[ctrlr.KIND_OF_MQ];
    return ctrlr && APIClass ? new APIClass(ctrlr) : null;
  };
  MQ2.L = L;
  MQ2.R = R;
  MQ2.config = function(opts) {
    config(BaseOptions.prototype, opts);
    return this;
  };
  MQ2.registerEmbed = function(name, options) {
    if (!/^[a-z][a-z0-9]*$/i.test(name)) {
      throw "Embed name must start with letter and be only letters and digits";
    }
    EMBEDS[name] = options;
  };
  MQ2.StaticMath = createEntrypoint("StaticMath", APIClasses.StaticMath);
  MQ2.MathField = createEntrypoint("MathField", APIClasses.MathField);
  MQ2.InnerMathField = createEntrypoint(
    "InnerMathField",
    APIClasses.InnerMathField
  );
  if (APIClasses.TextField) {
    MQ2.TextField = createEntrypoint("TextField", APIClasses.TextField);
  }
  MQ2.prototype = AbstractMathQuill.prototype;
  MQ2.EditableField = function() {
    throw "wtf don't call me, I'm 'abstract'";
  };
  MQ2.EditableField.prototype = EditableField.prototype;
  if (version < 3) {
    MQ2.saneKeyboardEvents = defaultSubstituteKeyboardEvents;
  }
  function createEntrypoint(kind, APIClass) {
    pray(kind + " is defined", APIClass);
    function mqEntrypoint(el, opts) {
      if (!el || !el.nodeType) return null;
      var mq = MQ2(el);
      if (mq instanceof APIClass) return mq;
      var ctrlr = new Controller(
        new APIClass.RootBlock(),
        el,
        new BaseOptions(version)
      );
      ctrlr.KIND_OF_MQ = kind;
      return new APIClass(ctrlr).__mathquillify(opts || {}, version);
    }
    mqEntrypoint.prototype = APIClass.prototype;
    return mqEntrypoint;
  }
  return MQ2;
}
MathQuill.noConflict = function() {
  window.MathQuill = origMathQuill;
  return MathQuill;
};
var origMathQuill = window.MathQuill;
window.MathQuill = MathQuill;
function RootBlockMixin(_) {
  _.moveOutOf = function(dir) {
    pray("controller is defined", this.controller);
    this.controller.handle("moveOutOf", dir);
  };
  _.deleteOutOf = function(dir) {
    pray("controller is defined", this.controller);
    this.controller.handle("deleteOutOf", dir);
  };
  _.selectOutOf = function(dir) {
    pray("controller is defined", this.controller);
    this.controller.handle("selectOutOf", dir);
  };
  _.upOutOf = function() {
    pray("controller is defined", this.controller);
    this.controller.handle("upOutOf");
    return void 0;
  };
  _.downOutOf = function() {
    pray("controller is defined", this.controller);
    this.controller.handle("downOutOf");
    return void 0;
  };
  _.reflow = function() {
    pray("controller is defined", this.controller);
    this.controller.handle("reflow");
    this.controller.handle("edited");
    this.controller.handle("edit");
  };
}
function parseError(stream, message) {
  if (stream) {
    stream = "'" + stream + "'";
  } else {
    stream = "EOF";
  }
  throw "Parse Error: " + message + " at " + stream;
}
var Parser = (
  /** @class */
  (function() {
    function Parser2(body) {
      this._ = body;
    }
    Parser2.prototype.parse = function(stream) {
      return this.skip(Parser2.eof)._("" + stream, success, parseError);
      function success(_stream, result) {
        return result;
      }
    };
    Parser2.prototype.or = function(alternative) {
      pray("or is passed a parser", alternative instanceof Parser2);
      var self = this;
      return new Parser2(function(stream, onSuccess, onFailure) {
        return self._(stream, onSuccess, failure);
        function failure(_newStream) {
          return alternative._(stream, onSuccess, onFailure);
        }
      });
    };
    Parser2.prototype.then = function(next) {
      var self = this;
      return new Parser2(function(stream, onSuccess, onFailure) {
        return self._(stream, success, onFailure);
        function success(newStream, result) {
          var nextParser = next instanceof Parser2 ? next : next(result);
          pray("a parser is returned", nextParser instanceof Parser2);
          return nextParser._(newStream, onSuccess, onFailure);
        }
      });
    };
    Parser2.prototype.many = function() {
      var self = this;
      return new Parser2(function(stream, onSuccess, _onFailure) {
        var xs = [];
        while (self._(stream, success, failure)) ;
        return onSuccess(stream, xs);
        function success(newStream, x) {
          stream = newStream;
          xs.push(x);
          return true;
        }
        function failure() {
          return false;
        }
      });
    };
    Parser2.prototype.times = function(min2, max2) {
      if (arguments.length < 2) max2 = min2;
      var self = this;
      return new Parser2(function(stream, onSuccess, onFailure) {
        var xs = [];
        var result = true;
        var failure;
        for (var i = 0; i < min2; i += 1) {
          result = !!self._(stream, success, firstFailure);
          if (!result) return onFailure(stream, failure);
        }
        for (; i < max2 && result; i += 1) {
          self._(stream, success, secondFailure);
        }
        return onSuccess(stream, xs);
        function success(newStream, x) {
          xs.push(x);
          stream = newStream;
          return true;
        }
        function firstFailure(newStream, msg) {
          failure = msg;
          stream = newStream;
          return false;
        }
        function secondFailure(_newStream, _msg) {
          return false;
        }
      });
    };
    Parser2.prototype.result = function(res) {
      return this.then(Parser2.succeed(res));
    };
    Parser2.prototype.atMost = function(n) {
      return this.times(0, n);
    };
    Parser2.prototype.atLeast = function(n) {
      var self = this;
      return self.times(n).then(function(start) {
        return self.many().map(function(end) {
          return start.concat(end);
        });
      });
    };
    Parser2.prototype.map = function(fn) {
      return this.then(function(result) {
        return Parser2.succeed(fn(result));
      });
    };
    Parser2.prototype.skip = function(two) {
      return this.then(function(result) {
        return two.result(result);
      });
    };
    Parser2.string = function(str) {
      var len = str.length;
      var expected = "expected '" + str + "'";
      return new Parser2(function(stream, onSuccess, onFailure) {
        var head = stream.slice(0, len);
        if (head === str) {
          return onSuccess(stream.slice(len), head);
        } else {
          return onFailure(stream, expected);
        }
      });
    };
    Parser2.regex = function(re) {
      pray("regexp parser is anchored", re.toString().charAt(1) === "^");
      var expected = "expected " + re;
      return new Parser2(function(stream, onSuccess, onFailure) {
        var match = re.exec(stream);
        if (match) {
          var result = match[0];
          return onSuccess(stream.slice(result.length), result);
        } else {
          return onFailure(stream, expected);
        }
      });
    };
    Parser2.succeed = function(result) {
      return new Parser2(function(stream, onSuccess) {
        return onSuccess(stream, result);
      });
    };
    Parser2.fail = function(msg) {
      return new Parser2(function(stream, _, onFailure) {
        return onFailure(stream, msg);
      });
    };
    Parser2.letter = Parser2.regex(/^[a-z]/i);
    Parser2.letters = Parser2.regex(/^[a-z]*/i);
    Parser2.digit = Parser2.regex(/^[0-9]/);
    Parser2.digits = Parser2.regex(/^[0-9]*/);
    Parser2.whitespace = Parser2.regex(/^\s+/);
    Parser2.optWhitespace = Parser2.regex(/^\s*/);
    Parser2.any = new Parser2(function(stream, onSuccess, onFailure) {
      if (!stream) return onFailure(stream, "expected any character");
      return onSuccess(stream.slice(1), stream.charAt(0));
    });
    Parser2.all = new Parser2(function(stream, onSuccess, _onFailure) {
      return onSuccess("", stream);
    });
    Parser2.eof = new Parser2(function(stream, onSuccess, onFailure) {
      if (stream) return onFailure(stream, "expected EOF");
      return onSuccess(stream, stream);
    });
    return Parser2;
  })()
);
var EveryTick = (
  /** @class */
  (function() {
    function EveryTick2() {
      this.fn = noop;
    }
    EveryTick2.prototype.listen = function(fn) {
      this.fn = fn;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(this.fn);
    };
    EveryTick2.prototype.listenOnce = function(fn) {
      var _this_1 = this;
      this.listen(function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        _this_1.clearListener();
        fn.apply(void 0, args);
      });
    };
    EveryTick2.prototype.clearListener = function() {
      this.fn = noop;
      clearTimeout(this.timeoutId);
    };
    EveryTick2.prototype.trigger = function() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      this.fn.apply(this, args);
    };
    return EveryTick2;
  })()
);
var saneKeyboardEvents = /* @__PURE__ */ (function() {
  var WHICH_TO_MQ_KEY_STEM = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    // for Safari on iOS
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Esc",
    32: "Spacebar",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "Left",
    38: "Up",
    39: "Right",
    40: "Down",
    45: "Insert",
    46: "Del",
    144: "NumLock"
  };
  var KEY_TO_MQ_KEY_STEM = {
    ArrowRight: "Right",
    ArrowLeft: "Left",
    ArrowDown: "Down",
    ArrowUp: "Up",
    Delete: "Del",
    Escape: "Esc",
    " ": "Spacebar"
  };
  function isArrowKey(e) {
    switch (getMQKeyStem(e)) {
      case "Right":
      case "Left":
      case "Down":
      case "Up":
        return true;
    }
    return false;
  }
  function isLowercaseAlphaCharacter(s) {
    return s.length === 1 && s >= "a" && s <= "z";
  }
  function getMQKeyStem(evt) {
    var _c;
    if (evt.key === void 0) {
      var which = evt.which || evt.keyCode;
      return WHICH_TO_MQ_KEY_STEM[which] || String.fromCharCode(which);
    }
    if (isLowercaseAlphaCharacter(evt.key)) return evt.key.toUpperCase();
    return (_c = KEY_TO_MQ_KEY_STEM[evt.key]) !== null && _c !== void 0 ? _c : evt.key;
  }
  function getMQKeyName(evt) {
    var key = getMQKeyStem(evt);
    var modifiers = [];
    if (evt.ctrlKey) modifiers.push("Ctrl");
    if (evt.metaKey) modifiers.push("Meta");
    if (evt.altKey) modifiers.push("Alt");
    if (evt.shiftKey) modifiers.push("Shift");
    if (!modifiers.length) return key;
    if (key !== "Alt" && key !== "Control" && key !== "Meta" && key !== "Shift")
      modifiers.push(key);
    return modifiers.join("-");
  }
  return function saneKeyboardEvents2(textarea, controller) {
    var keydown = null;
    var keypress = null;
    var everyTick = new EveryTick();
    function guardedTextareaSelect() {
      try {
        if (textarea instanceof HTMLTextAreaElement) textarea.select();
      } catch (e) {
      }
    }
    function select(text) {
      everyTick.trigger();
      everyTick.clearListener();
      if (textarea instanceof HTMLTextAreaElement) textarea.value = text;
      if (text) guardedTextareaSelect();
      shouldBeSelected = !!text;
    }
    var shouldBeSelected = false;
    function hasSelection() {
      if (!("selectionStart" in textarea)) return false;
      if (!(textarea instanceof HTMLTextAreaElement)) return false;
      return textarea.selectionStart !== textarea.selectionEnd;
    }
    function handleKey() {
      if (controller.options && controller.options.overrideKeystroke) {
        controller.options.overrideKeystroke(
          getMQKeyName(keydown),
          keydown
        );
      } else {
        controller.keystroke(getMQKeyName(keydown), keydown);
      }
    }
    function onKeydown(e) {
      everyTick.trigger(e);
      if (e.target !== textarea) return;
      keydown = e;
      keypress = null;
      if (shouldBeSelected)
        everyTick.listenOnce(function(e2) {
          if (!(e2 && e2.type === "focusout")) {
            guardedTextareaSelect();
          }
        });
      handleKey();
    }
    function onKeypress(e) {
      everyTick.trigger(e);
      if (e.target !== textarea) return;
      if (keydown && keypress) handleKey();
      keypress = e;
      if (!isArrowKey(e)) {
        everyTick.listen(typedText);
      } else {
        everyTick.listenOnce(maybeReselect);
      }
    }
    function onKeyup(e) {
      everyTick.trigger(e);
      if (e.target !== textarea) return;
      if (!!keydown && !keypress) {
        if (!isArrowKey(e)) {
          everyTick.listen(typedText);
        } else {
          everyTick.listenOnce(maybeReselect);
        }
      }
    }
    function typedText() {
      if (hasSelection()) return;
      if (!(textarea instanceof HTMLTextAreaElement)) return;
      var text = textarea.value;
      if (keydown && (keydown.key === "Unidentified" || !keydown.altKey && keydown.ctrlKey && !keydown.metaKey && keydown.shiftKey && (keydown.key === "U" || keydown.key === "Process")))
        return;
      if (text.length === 1) {
        textarea.value = "";
        if (controller.options && controller.options.overrideTypedText) {
          controller.options.overrideTypedText(text);
        } else {
          controller.typedText(text);
        }
      } else maybeReselect();
    }
    function maybeReselect() {
      if (!(textarea instanceof HTMLTextAreaElement)) return;
      if (textarea.value.length > 1) {
        guardedTextareaSelect();
      }
    }
    function onBlur() {
      keydown = null;
      keypress = null;
      everyTick.clearListener();
      if (textarea instanceof HTMLTextAreaElement) textarea.value = "";
    }
    function onPaste(e) {
      everyTick.trigger();
      if (e.target !== textarea) return;
      if (document.activeElement !== textarea) {
        textarea.focus();
      }
      everyTick.listen(function pastedText() {
        if (!(textarea instanceof HTMLTextAreaElement)) return;
        var text = textarea.value;
        textarea.value = "";
        if (text) controller.paste(text);
      });
    }
    function onInput(e) {
      everyTick.trigger(e);
    }
    if (controller.KIND_OF_MQ === "StaticMath") {
      controller.addTextareaEventListeners({
        keydown: function(evt) {
          var _c, _d;
          (_d = (_c = controller.options).overrideKeystroke) === null || _d === void 0 ? void 0 : _d.call(_c, getMQKeyName(evt), evt);
        }
      });
      return { select };
    }
    if (controller.options && controller.options.disableCopyPaste) {
      controller.addTextareaEventListeners({
        keydown: onKeydown,
        keypress: onKeypress,
        keyup: onKeyup,
        focusout: onBlur,
        copy: function(e) {
          e.preventDefault();
        },
        cut: function(e) {
          e.preventDefault();
        },
        paste: function(e) {
          everyTick.trigger();
          e.preventDefault();
        },
        input: onInput
      });
    } else {
      controller.addTextareaEventListeners({
        keydown: onKeydown,
        keypress: onKeypress,
        keyup: onKeyup,
        focusout: onBlur,
        cut: function() {
          everyTick.listenOnce(function() {
            controller.cut();
          });
        },
        copy: function() {
          everyTick.listenOnce(function() {
            controller.copy();
          });
        },
        paste: onPaste,
        input: onInput
      });
    }
    return { select };
  };
})();
var Controller_exportText = (
  /** @class */
  (function(_super) {
    __extends(Controller_exportText2, _super);
    function Controller_exportText2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Controller_exportText2.prototype.exportText = function() {
      return this.root.foldChildren("", function(text, child) {
        return text + child.text();
      });
    };
    return Controller_exportText2;
  })(ControllerBase)
);
ControllerBase.onNotify(function(cursor, e) {
  if (e === "edit" || e === "replace" || e === void 0) {
    var controller = cursor.controller;
    if (!controller) return;
    if (!controller.options.enableDigitGrouping) return;
    if (controller.blurred !== false) return;
    controller.disableGroupingForSeconds(1);
  }
});
var Controller_focusBlur = (
  /** @class */
  (function(_super) {
    __extends(Controller_focusBlur2, _super);
    function Controller_focusBlur2() {
      var _this_1 = _super !== null && _super.apply(this, arguments) || this;
      _this_1.handleTextareaFocusEditable = function() {
        var cursor = _this_1.cursor;
        _this_1.updateMathspeak();
        _this_1.blurred = false;
        clearTimeout(_this_1.blurTimeout);
        domFrag(_this_1.container).addClass("mq-focused");
        if (!cursor.parent) cursor.insAtRightEnd(_this_1.root);
        if (cursor.selection) {
          cursor.selection.domFrag().removeClass("mq-blur");
          _this_1.selectionChanged();
        } else {
          cursor.show();
        }
        _this_1.setOverflowClasses();
      };
      _this_1.handleTextareaBlurEditable = function() {
        if (_this_1.textareaSelectionTimeout) {
          clearTimeout(_this_1.textareaSelectionTimeout);
          _this_1.textareaSelectionTimeout = 0;
        }
        _this_1.disableGroupingForSeconds(0);
        _this_1.blurred = true;
        _this_1.blurTimeout = setTimeout(function() {
          _this_1.root.postOrder(function(node) {
            node.intentionalBlur();
          });
          _this_1.cursor.clearSelection().endSelection();
          _this_1.blur();
          _this_1.updateMathspeak({ emptyContent: true });
          _this_1.scrollHoriz();
        });
        window.addEventListener("blur", _this_1.handleWindowBlur);
      };
      _this_1.handleTextareaFocusStatic = function() {
        if (!_this_1.cursor.selection) {
          _this_1.cursor.controller.selectAll();
        }
        _this_1.blurred = false;
      };
      _this_1.handleTextareaBlurStatic = function() {
        _this_1.cursor.clearSelection();
        _this_1.updateMathspeak({ emptyContent: true });
      };
      _this_1.handleWindowBlur = function() {
        clearTimeout(_this_1.blurTimeout);
        if (_this_1.cursor.selection)
          _this_1.cursor.selection.domFrag().addClass("mq-blur");
        _this_1.blurWithoutResettingCursor();
        _this_1.updateMathspeak({ emptyContent: true });
      };
      return _this_1;
    }
    Controller_focusBlur2.prototype.disableGroupingForSeconds = function(seconds) {
      var _this_1 = this;
      clearTimeout(this.__disableGroupingTimeout);
      if (seconds === 0) {
        this.root.domFrag().removeClass("mq-suppress-grouping");
      } else {
        this.root.domFrag().addClass("mq-suppress-grouping");
        this.__disableGroupingTimeout = setTimeout(function() {
          _this_1.root.domFrag().removeClass("mq-suppress-grouping");
        }, seconds * 1e3);
      }
    };
    Controller_focusBlur2.prototype.blur = function() {
      this.blurWithoutResettingCursor();
      if (this.options && this.options.resetCursorOnBlur) {
        this.cursor.resetToEnd(this);
      }
    };
    Controller_focusBlur2.prototype.blurWithoutResettingCursor = function() {
      this.cursor.hide().parent.blur(this.cursor);
      domFrag(this.container).removeClass("mq-focused");
      window.removeEventListener("blur", this.handleWindowBlur);
    };
    Controller_focusBlur2.prototype.addEditableFocusBlurListeners = function() {
      var ctrlr = this, cursor = ctrlr.cursor;
      this.addTextareaEventListeners({
        focus: this.handleTextareaFocusEditable,
        blur: this.handleTextareaBlurEditable
      });
      ctrlr.blurred = true;
      cursor.hide().parent.blur(cursor);
    };
    Controller_focusBlur2.prototype.addStaticFocusBlurListeners = function() {
      this.addTextareaEventListeners({
        focus: this.handleTextareaFocusStatic,
        blur: this.handleTextareaBlurStatic
      });
    };
    return Controller_focusBlur2;
  })(Controller_exportText)
);
var INCREMENTAL_SELECTION_OPEN = false;
var MQNode = (
  /** @class */
  (function(_super) {
    __extends(MQNode2, _super);
    function MQNode2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    MQNode2.prototype.keystroke = function(key, e, ctrlr) {
      var cursor = ctrlr.cursor;
      switch (key) {
        case "Ctrl-Shift-Backspace":
        case "Ctrl-Backspace":
          ctrlr.ctrlDeleteDir(L);
          break;
        case "Shift-Backspace":
        case "Backspace":
          ctrlr.backspace();
          break;
        // Tab or Esc -> go one block right if it exists, else escape right.
        case "Esc":
        case "Tab":
          ctrlr.escapeDir(R, key, e);
          return;
        // Shift-Tab -> go one block left if it exists, else escape left.
        case "Shift-Tab":
        case "Shift-Esc":
          ctrlr.escapeDir(L, key, e);
          return;
        // End -> move to the end of the current block.
        case "End":
          ctrlr.notify("move").cursor.insAtRightEnd(cursor.parent);
          ctrlr.aria.queue("end of").queue(cursor.parent, true);
          break;
        // Ctrl-End -> move all the way to the end of the root block.
        case "Ctrl-End":
          ctrlr.notify("move").cursor.insAtRightEnd(ctrlr.root);
          ctrlr.aria.queue("end of").queue(ctrlr.ariaLabel).queue(ctrlr.root).queue(ctrlr.ariaPostLabel);
          break;
        // Shift-End -> select to the end of the current block.
        case "Shift-End":
          ctrlr.selectToBlockEndInDir(R);
          break;
        // Ctrl-Shift-End -> select all the way to the end of the root block.
        case "Ctrl-Shift-End":
          ctrlr.selectToRootEndInDir(R);
          break;
        // Home -> move to the start of the current block.
        case "Home":
          ctrlr.notify("move").cursor.insAtLeftEnd(cursor.parent);
          ctrlr.aria.queue("beginning of").queue(cursor.parent, true);
          break;
        // Ctrl-Home -> move all the way to the start of the root block.
        case "Ctrl-Home":
          ctrlr.notify("move").cursor.insAtLeftEnd(ctrlr.root);
          ctrlr.aria.queue("beginning of").queue(ctrlr.ariaLabel).queue(ctrlr.root).queue(ctrlr.ariaPostLabel);
          break;
        // Shift-Home -> select to the start of the current block.
        case "Shift-Home":
          ctrlr.selectToBlockEndInDir(L);
          break;
        // Ctrl-Shift-Home -> select all the way to the start of the root block.
        case "Ctrl-Shift-Home":
          ctrlr.selectToRootEndInDir(L);
          break;
        case "Left":
          ctrlr.moveLeft();
          break;
        case "Shift-Left":
          ctrlr.selectLeft();
          break;
        case "Ctrl-Left":
          break;
        case "Right":
          ctrlr.moveRight();
          break;
        case "Shift-Right":
          ctrlr.selectRight();
          break;
        case "Ctrl-Right":
          break;
        case "Up":
          ctrlr.moveUp();
          break;
        case "Down":
          ctrlr.moveDown();
          break;
        case "Shift-Up":
          ctrlr.withIncrementalSelection(function(selectDir) {
            if (cursor[L]) {
              while (cursor[L]) selectDir(L);
            } else {
              selectDir(L);
            }
          });
          break;
        case "Shift-Down":
          ctrlr.withIncrementalSelection(function(selectDir) {
            if (cursor[R]) {
              while (cursor[R]) selectDir(R);
            } else {
              selectDir(R);
            }
          });
          break;
        case "Ctrl-Up":
          break;
        case "Ctrl-Down":
          break;
        case "Ctrl-Shift-Del":
        case "Ctrl-Del":
          ctrlr.ctrlDeleteDir(R);
          break;
        case "Shift-Del":
        case "Del":
          ctrlr.deleteForward();
          break;
        case "Meta-A":
        case "Ctrl-A":
          ctrlr.selectAll();
          break;
        // These remaining hotkeys are only of benefit to people running screen readers.
        case "Ctrl-Alt-Up":
          if (cursor.parent.parent && cursor.parent.parent instanceof MQNode2)
            ctrlr.aria.queue(cursor.parent.parent);
          else ctrlr.aria.queue("nothing above");
          break;
        case "Ctrl-Alt-Down":
          if (cursor.parent && cursor.parent instanceof MQNode2)
            ctrlr.aria.queue(cursor.parent);
          else ctrlr.aria.queue("block is empty");
          break;
        case "Ctrl-Alt-Left":
          if (cursor.parent.parent && cursor.parent.parent.getEnd(L)) {
            ctrlr.aria.queue(cursor.parent.parent.getEnd(L));
          } else {
            ctrlr.aria.queue("nothing to the left");
          }
          break;
        case "Ctrl-Alt-Right":
          if (cursor.parent.parent && cursor.parent.parent.getEnd(R)) {
            ctrlr.aria.queue(cursor.parent.parent.getEnd(R));
          } else {
            ctrlr.aria.queue("nothing to the right");
          }
          break;
        case "Ctrl-Alt-Shift-Down":
          if (cursor.selection)
            ctrlr.aria.queue(
              cursor.selection.join("mathspeak", " ").trim() + " selected"
            );
          else ctrlr.aria.queue("nothing selected");
          break;
        case "Ctrl-Alt-=":
        case "Ctrl-Alt-Shift-Right":
          if (ctrlr.ariaPostLabel.length)
            ctrlr.aria.queue(ctrlr.ariaPostLabel);
          else ctrlr.aria.queue("no answer");
          break;
        default:
          return;
      }
      ctrlr.aria.alert();
      e === null || e === void 0 ? void 0 : e.preventDefault();
      ctrlr.scrollHoriz();
    };
    MQNode2.prototype.moveOutOf = function(_dir, _cursor, _updown) {
      pray("overridden or never called on this node", false);
    };
    MQNode2.prototype.moveTowards = function(_dir, _cursor, _updown) {
      pray("overridden or never called on this node", false);
    };
    MQNode2.prototype.deleteOutOf = function(_dir, _cursor) {
      pray("overridden or never called on this node", false);
    };
    MQNode2.prototype.deleteTowards = function(_dir, _cursor) {
      pray("overridden or never called on this node", false);
    };
    MQNode2.prototype.unselectInto = function(_dir, _cursor) {
      pray("overridden or never called on this node", false);
    };
    MQNode2.prototype.selectOutOf = function(_dir, _cursor) {
      pray("overridden or never called on this node", false);
    };
    MQNode2.prototype.selectTowards = function(_dir, _cursor) {
      pray("overridden or never called on this node", false);
    };
    return MQNode2;
  })(NodeBase)
);
ControllerBase.onNotify(function(cursor, e) {
  if (e === "move" || e === "upDown") cursor.show().clearSelection();
});
baseOptionProcessors.leftRightIntoCmdGoes = function(updown) {
  if (updown && updown !== "up" && updown !== "down") {
    throw '"up" or "down" required for leftRightIntoCmdGoes option, got "' + updown + '"';
  }
  return updown;
};
ControllerBase.onNotify(function(cursor, e) {
  if (e !== "upDown") cursor.upDownCache = {};
});
ControllerBase.onNotify(function(cursor, e) {
  if (e === "edit") cursor.show().deleteSelection();
});
ControllerBase.onNotify(function(cursor, e) {
  if (e !== "select") cursor.endSelection();
});
var Controller_keystroke = (
  /** @class */
  (function(_super) {
    __extends(Controller_keystroke2, _super);
    function Controller_keystroke2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Controller_keystroke2.prototype.keystroke = function(key, evt) {
      this.cursor.parent.keystroke(key, evt, this.getControllerSelf());
    };
    Controller_keystroke2.prototype.escapeDir = function(dir, _key, e) {
      prayDirection(dir);
      var cursor = this.cursor;
      if (cursor.parent !== this.root)
        e === null || e === void 0 ? void 0 : e.preventDefault();
      if (cursor.parent === this.root) return;
      cursor.clearSelection();
      cursor.parent.moveOutOf(dir, cursor);
      cursor.controller.aria.alert();
      return this.notify("move");
    };
    Controller_keystroke2.prototype.moveDir = function(dir) {
      prayDirection(dir);
      var cursor = this.cursor, updown = cursor.options.leftRightIntoCmdGoes;
      var cursorDir = cursor[dir];
      if (cursor.selection) {
        cursor.insDirOf(dir, cursor.selection.getEnd(dir));
      } else if (cursorDir) cursorDir.moveTowards(dir, cursor, updown);
      else cursor.parent.moveOutOf(dir, cursor, updown);
      return this.notify("move");
    };
    Controller_keystroke2.prototype.moveLeft = function() {
      return this.moveDir(L);
    };
    Controller_keystroke2.prototype.moveRight = function() {
      return this.moveDir(R);
    };
    Controller_keystroke2.prototype.moveUp = function() {
      return this.moveUpDown("up");
    };
    Controller_keystroke2.prototype.moveDown = function() {
      return this.moveUpDown("down");
    };
    Controller_keystroke2.prototype.moveUpDown = function(dir) {
      var self = this;
      var cursor = self.notify("upDown").cursor;
      var dirInto;
      var dirOutOf;
      if (dir === "up") {
        dirInto = "upInto";
        dirOutOf = "upOutOf";
      } else {
        dirInto = "downInto";
        dirOutOf = "downOutOf";
      }
      var cursorL = cursor[L];
      var cursorR = cursor[R];
      var cursorR_dirInto = cursorR && cursorR[dirInto];
      var cursorL_dirInto = cursorL && cursorL[dirInto];
      if (cursorR_dirInto) cursor.insAtLeftEnd(cursorR_dirInto);
      else if (cursorL_dirInto) cursor.insAtRightEnd(cursorL_dirInto);
      else {
        cursor.parent.bubble(function(ancestor) {
          var prop = ancestor[dirOutOf];
          if (prop) {
            if (typeof prop === "function")
              prop = prop.call(ancestor, cursor);
            if (prop instanceof MQNode)
              cursor.jumpUpDown(ancestor, prop);
            if (prop !== true) return false;
          }
          return void 0;
        });
      }
      return self;
    };
    Controller_keystroke2.prototype.deleteDir = function(dir) {
      prayDirection(dir);
      var cursor = this.cursor;
      var cursorEl = cursor[dir];
      var cursorElParent = cursor.parent.parent;
      var ctrlr = cursor.controller;
      if (cursorEl && cursorEl instanceof MQNode) {
        if (cursorEl.sides) {
          ctrlr.aria.queue(
            cursorEl.parent.chToCmd(cursorEl.sides[-dir].ch).mathspeak({ createdLeftOf: cursor })
          );
        } else if (!cursorEl.blocks && cursorEl.parent.ctrlSeq !== "\\text") {
          ctrlr.aria.queue(cursorEl);
        }
      } else if (cursorElParent && cursorElParent instanceof MQNode) {
        if (cursorElParent.sides) {
          ctrlr.aria.queue(
            cursorElParent.parent.chToCmd(cursorElParent.sides[dir].ch).mathspeak({ createdLeftOf: cursor })
          );
        } else if (cursorElParent.blocks && cursorElParent.mathspeakTemplate) {
          if (cursorElParent.upInto && cursorElParent.downInto) {
            ctrlr.aria.queue(cursorElParent.mathspeakTemplate[1]);
          } else {
            var mst = cursorElParent.mathspeakTemplate;
            var textToQueue = dir === L ? mst[0] : mst[mst.length - 1];
            ctrlr.aria.queue(textToQueue);
          }
        } else {
          ctrlr.aria.queue(cursorElParent);
        }
      }
      var hadSelection = cursor.selection;
      this.notify("edit");
      if (!hadSelection) {
        var cursorDir = cursor[dir];
        if (cursorDir) cursorDir.deleteTowards(dir, cursor);
        else cursor.parent.deleteOutOf(dir, cursor);
      }
      var cursorL = cursor[L];
      var cursorR = cursor[R];
      if (cursorL.siblingDeleted) cursorL.siblingDeleted(cursor.options, R);
      if (cursorR.siblingDeleted) cursorR.siblingDeleted(cursor.options, L);
      cursor.parent.bubble(function(node) {
        node.reflow();
        return void 0;
      });
      return this;
    };
    Controller_keystroke2.prototype.ctrlDeleteDir = function(dir) {
      prayDirection(dir);
      var cursor = this.cursor;
      if (!cursor[dir] || cursor.selection) return this.deleteDir(dir);
      this.notify("edit");
      var fragRemoved;
      if (dir === L) {
        fragRemoved = new Fragment(cursor.parent.getEnd(L), cursor[L]);
      } else {
        fragRemoved = new Fragment(cursor[R], cursor.parent.getEnd(R));
      }
      cursor.controller.aria.queue(fragRemoved);
      fragRemoved.remove();
      cursor.insAtDirEnd(dir, cursor.parent);
      var cursorL = cursor[L];
      var cursorR = cursor[R];
      if (cursorL) cursorL.siblingDeleted(cursor.options, R);
      if (cursorR) cursorR.siblingDeleted(cursor.options, L);
      cursor.parent.bubble(function(node) {
        node.reflow();
        return void 0;
      });
      return this;
    };
    Controller_keystroke2.prototype.backspace = function() {
      return this.deleteDir(L);
    };
    Controller_keystroke2.prototype.deleteForward = function() {
      return this.deleteDir(R);
    };
    Controller_keystroke2.prototype.startIncrementalSelection = function() {
      pray(
        "Multiple selections can't be simultaneously open",
        !INCREMENTAL_SELECTION_OPEN
      );
      INCREMENTAL_SELECTION_OPEN = true;
      this.notify("select");
      var cursor = this.cursor;
      if (!cursor.anticursor) cursor.startSelection();
    };
    Controller_keystroke2.prototype.selectDirIncremental = function(dir) {
      pray("A selection is open", INCREMENTAL_SELECTION_OPEN);
      INCREMENTAL_SELECTION_OPEN = true;
      var cursor = this.cursor, seln = cursor.selection;
      prayDirection(dir);
      var node = cursor[dir];
      if (node) {
        if (seln && seln.getEnd(dir) === node && cursor.anticursor[-dir] !== node) {
          node.unselectInto(dir, cursor);
        } else node.selectTowards(dir, cursor);
      } else cursor.parent.selectOutOf(dir, cursor);
    };
    Controller_keystroke2.prototype.finishIncrementalSelection = function() {
      pray("A selection is open", INCREMENTAL_SELECTION_OPEN);
      var cursor = this.cursor;
      cursor.clearSelection();
      cursor.select() || cursor.show();
      var selection = cursor.selection;
      if (selection) {
        cursor.controller.aria.clear().queue(selection.join("mathspeak", " ").trim() + " selected");
      }
      INCREMENTAL_SELECTION_OPEN = false;
    };
    Controller_keystroke2.prototype.withIncrementalSelection = function(cb) {
      var _this_1 = this;
      try {
        this.startIncrementalSelection();
        try {
          cb(function(dir) {
            return _this_1.selectDirIncremental(dir);
          });
        } finally {
          this.finishIncrementalSelection();
        }
      } finally {
        INCREMENTAL_SELECTION_OPEN = false;
      }
    };
    Controller_keystroke2.prototype.selectDir = function(dir) {
      this.withIncrementalSelection(function(selectDir) {
        return selectDir(dir);
      });
    };
    Controller_keystroke2.prototype.selectLeft = function() {
      return this.selectDir(L);
    };
    Controller_keystroke2.prototype.selectRight = function() {
      return this.selectDir(R);
    };
    Controller_keystroke2.prototype.selectAll = function() {
      this.notify("move");
      var cursor = this.cursor;
      cursor.insAtRightEnd(this.root);
      this.withIncrementalSelection(function(selectDir) {
        while (cursor[L]) selectDir(L);
      });
    };
    Controller_keystroke2.prototype.selectToBlockEndInDir = function(dir) {
      var cursor = this.cursor;
      this.withIncrementalSelection(function(selectDir) {
        while (cursor[dir]) selectDir(dir);
      });
    };
    Controller_keystroke2.prototype.selectToRootEndInDir = function(dir) {
      var _this_1 = this;
      var cursor = this.cursor;
      this.withIncrementalSelection(function(selectDir) {
        while (cursor[dir] || cursor.parent !== _this_1.root) {
          selectDir(dir);
        }
      });
    };
    return Controller_keystroke2;
  })(Controller_focusBlur)
);
(function(_super) {
  __extends(TempSingleCharNode, _super);
  function TempSingleCharNode(_char) {
    return _super.call(this) || this;
  }
  return TempSingleCharNode;
})(MQNode);
var latexMathParser = (function() {
  function commandToBlock(cmd) {
    var block = new MathBlock();
    cmd.adopt(block, 0, 0);
    return block;
  }
  function joinBlocks(blocks) {
    var firstBlock = blocks[0] || new MathBlock();
    for (var i = 1; i < blocks.length; i += 1) {
      blocks[i].children().adopt(firstBlock, firstBlock.getEnd(R), 0);
    }
    return firstBlock;
  }
  var string = Parser.string;
  var regex = Parser.regex;
  var letter = Parser.letter;
  var digit = Parser.digit;
  var any = Parser.any;
  var optWhitespace = Parser.optWhitespace;
  var succeed = Parser.succeed;
  var fail = Parser.fail;
  var variable = letter.map(function(c) {
    return new Letter(c);
  });
  var number = digit.map(function(c) {
    return new Digit(c);
  });
  var symbol = regex(/^[^${}\\_^]/).map(function(c) {
    return new VanillaSymbol(c);
  });
  var controlSequence = regex(/^[^\\a-eg-zA-Z]/).or(
    string("\\").then(
      regex(/^[a-z]+/i).or(regex(/^\s+/).result(" ")).or(any)
    )
  ).then(function(ctrlSeq) {
    var cmdKlass = LatexCmds[ctrlSeq];
    if (cmdKlass) {
      if (cmdKlass.constructor) {
        var actualClass = cmdKlass;
        return new actualClass(ctrlSeq).parser();
      } else {
        var builder = cmdKlass;
        return builder(ctrlSeq).parser();
      }
    } else {
      return fail("unknown command: \\" + ctrlSeq);
    }
  });
  var command = controlSequence.or(variable).or(number).or(symbol);
  var mathGroup = string("{").then(function() {
    return mathSequence;
  }).skip(string("}"));
  var mathBlock = optWhitespace.then(
    mathGroup.or(command.map(commandToBlock))
  );
  var mathSequence = mathBlock.many().map(joinBlocks).skip(optWhitespace);
  var optMathBlock = string("[").then(
    mathBlock.then(function(block) {
      return block.join("latex") !== "]" ? succeed(block) : fail("");
    }).many().map(joinBlocks).skip(optWhitespace)
  ).skip(string("]"));
  var latexMath = mathSequence;
  latexMath.block = mathBlock;
  latexMath.optBlock = optMathBlock;
  return latexMath;
})();
baseOptionProcessors.maxDepth = function(depth) {
  return typeof depth === "number" ? depth : void 0;
};
var Controller_latex = (
  /** @class */
  (function(_super) {
    __extends(Controller_latex2, _super);
    function Controller_latex2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Controller_latex2.prototype.cleanLatex = function(latex) {
      return latex.replace(/(\\[a-z]+) (?![a-z])/gi, "$1");
    };
    Controller_latex2.prototype.exportLatex = function() {
      return this.cleanLatex(this.root.latex());
    };
    Controller_latex2.prototype.writeLatex = function(latex) {
      var cursor = this.notify("edit").cursor;
      cursor.parent.writeLatex(cursor, latex);
      return this;
    };
    Controller_latex2.prototype.prepareCursorForRestoration = function() {
      this.cursor.clearSelection().endSelection();
      return this.notify("move").cursor;
    };
    Controller_latex2.prototype.restoreLatexSelection = function(newSelection) {
      var _this_1 = this;
      var oldSelectionInfo = this.exportLatexSelection();
      var oldSelection = oldSelectionInfo.selection;
      var oldLatex = oldSelection.latex;
      var newLatex = newSelection.latex;
      if (newLatex !== oldLatex) return;
      if (newSelection.startIndex === oldSelection.startIndex && newSelection.endIndex === oldSelection.endIndex)
        return;
      if (newSelection.endIndex === 0) {
        this.prepareCursorForRestoration().insAtDirEnd(L, this.root);
      } else if (newSelection.startIndex === newLatex.length) {
        this.prepareCursorForRestoration().insAtDirEnd(R, this.root);
      } else {
        var mappedIndices = mapFromCleanedToUncleanedIndices(
          oldLatex,
          oldSelectionInfo.ctx.uncleanedLatex,
          newSelection
        );
        var restoreInfo_1 = this.exportLatexSelection(mappedIndices).ctx.restoreInfo;
        if (newSelection.startIndex === newSelection.endIndex) {
          if (restoreInfo_1 === null || restoreInfo_1 === void 0 ? void 0 : restoreInfo_1.cursorL) {
            this.prepareCursorForRestoration().insRightOf(
              restoreInfo_1.cursorL
            );
          } else if (restoreInfo_1 === null || restoreInfo_1 === void 0 ? void 0 : restoreInfo_1.cursorParent) {
            this.prepareCursorForRestoration().insAtLeftEnd(
              restoreInfo_1.cursorParent
            );
          }
        } else {
          if ((restoreInfo_1 === null || restoreInfo_1 === void 0 ? void 0 : restoreInfo_1.selectionL) && restoreInfo_1.selectionR) {
            this.prepareCursorForRestoration().insRightOf(
              restoreInfo_1.selectionR
            );
            var root_1 = this.cursor.controller.root;
            this.withIncrementalSelection(function(selectDir) {
              do {
                selectDir(L);
                if (!_this_1.cursor[L] && _this_1.cursor.parent === root_1) {
                  break;
                }
              } while (_this_1.cursor[R] !== restoreInfo_1.selectionL);
            });
          }
        }
      }
    };
    Controller_latex2.prototype.exportLatexSelection = function(restoreInfo) {
      var ctx = {
        uncleanedLatex: "",
        uncleanedStartIndex: -1,
        uncleanedEndIndex: -1
      };
      if (restoreInfo) {
        ctx.restoreInfo = {
          uncleanedStartIndex: restoreInfo.uncleanStartIndex,
          uncleanedEndIndex: restoreInfo.uncleanEndIndex
        };
      }
      var selection = this.cursor.selection;
      if (selection && this.cursor.anticursor) {
        ctx.startSelectionBefore = selection.getEnd(L);
        ctx.endSelectionAfter = selection.getEnd(R);
      } else {
        var cursorL = this.cursor[L];
        if (cursorL) {
          ctx.startSelectionAfter = cursorL;
        } else {
          ctx.startSelectionBefore = this.cursor.parent;
        }
        var cursorR = this.cursor[R];
        if (cursorR) {
          ctx.endSelectionBefore = cursorR;
        } else {
          ctx.endSelectionAfter = this.cursor.parent;
        }
      }
      this.root.latexRecursive(ctx);
      var uncleanedLatex = ctx.uncleanedLatex;
      var cleanLatex = this.cleanLatex(uncleanedLatex);
      var _c = mapFromUncleanedToCleanedIndices(
        uncleanedLatex,
        cleanLatex,
        ctx
      ), startIndex = _c.startIndex, endIndex = _c.endIndex;
      return {
        selection: {
          latex: cleanLatex,
          startIndex,
          endIndex
        },
        ctx
      };
    };
    Controller_latex2.prototype.classifyLatexForEfficientUpdate = function(latex) {
      if (typeof latex !== "string") return;
      var matches = latex.match(/-?[0-9.]+$/g);
      if (matches && matches.length === 1) {
        return {
          latex,
          prefix: latex.substr(0, latex.length - matches[0].length),
          digits: matches[0]
        };
      }
      return;
    };
    Controller_latex2.prototype.updateLatexMathEfficiently = function(latex, oldLatex) {
      var _c, _d, _e, _f;
      var root = this.root;
      var oldClassification;
      var classification = this.classifyLatexForEfficientUpdate(latex);
      if (classification) {
        oldClassification = this.classifyLatexForEfficientUpdate(oldLatex);
        if (!oldClassification || oldClassification.prefix !== classification.prefix) {
          return false;
        }
      } else {
        return false;
      }
      var oldDigits = oldClassification.digits;
      var newDigits = classification.digits;
      var oldMinusSign = false;
      var newMinusSign = false;
      if (oldDigits[0] === "-") {
        oldMinusSign = true;
        oldDigits = oldDigits.substr(1);
      }
      if (newDigits[0] === "-") {
        newMinusSign = true;
        newDigits = newDigits.substr(1);
      }
      var charNode = this.root.getEnd(R);
      var oldCharNodes = [];
      for (var i = oldDigits.length - 1; i >= 0; i--) {
        if (!charNode || charNode.ctrlSeq !== oldDigits[i]) {
          return false;
        }
        if (charNode.parent !== root) {
          return false;
        }
        oldCharNodes.unshift(charNode);
        charNode = charNode[L];
      }
      if (oldMinusSign && !newMinusSign) {
        var oldMinusNode = charNode;
        if (!oldMinusNode) return false;
        if (oldMinusNode.ctrlSeq !== "-") return false;
        if (oldMinusNode[R] !== oldCharNodes[0]) return false;
        if (oldMinusNode.parent !== root) return false;
        var oldMinusNodeL = oldMinusNode[L];
        if (oldMinusNodeL && oldMinusNodeL.parent !== root) return false;
        oldCharNodes[0][L] = oldMinusNode[L];
        if (root.getEnd(L) === oldMinusNode) {
          root.setEnds(
            (_c = {}, _c[L] = oldCharNodes[0], _c[R] = root.getEnd(R), _c)
          );
        }
        if (oldMinusNodeL) oldMinusNodeL[R] = oldCharNodes[0];
        oldMinusNode.domFrag().remove();
      }
      if (!oldMinusSign && newMinusSign) {
        var newMinusNode = new PlusMinus("-");
        var minusSpan = document.createElement("span");
        minusSpan.textContent = "-";
        newMinusNode.setDOM(minusSpan);
        var oldCharNodes0L = oldCharNodes[0][L];
        if (oldCharNodes0L) oldCharNodes0L[R] = newMinusNode;
        if (root.getEnd(L) === oldCharNodes[0]) {
          root.setEnds(
            (_d = {}, _d[L] = newMinusNode, _d[R] = root.getEnd(R), _d)
          );
        }
        newMinusNode.parent = root;
        newMinusNode[L] = oldCharNodes[0][L];
        newMinusNode[R] = oldCharNodes[0];
        oldCharNodes[0][L] = newMinusNode;
        newMinusNode.contactWeld(this.cursor);
        newMinusNode.domFrag().insertBefore(oldCharNodes[0].domFrag());
      }
      var commonLength = Math.min(oldDigits.length, newDigits.length);
      for (i = 0; i < commonLength; i++) {
        var newText = newDigits[i];
        charNode = oldCharNodes[i];
        if (charNode.ctrlSeq !== newText) {
          charNode.ctrlSeq = newText;
          charNode.domFrag().oneElement().textContent = newText;
          charNode.mathspeakName = newText;
        }
      }
      if (oldDigits.length > newDigits.length) {
        charNode = oldCharNodes[newDigits.length - 1];
        root.setEnds(
          (_e = {}, _e[L] = root.getEnd(L), _e[R] = charNode, _e)
        );
        charNode[R] = 0;
        for (i = oldDigits.length - 1; i >= commonLength; i--) {
          oldCharNodes[i].domFrag().remove();
        }
      }
      if (newDigits.length > oldDigits.length) {
        var frag = document.createDocumentFragment();
        for (i = commonLength; i < newDigits.length; i++) {
          var span = document.createElement("span");
          span.className = "mq-digit";
          span.textContent = newDigits[i];
          var newNode = new Digit(newDigits[i]);
          newNode.parent = root;
          newNode.setDOM(span);
          frag.appendChild(span);
          newNode[L] = root.getEnd(R);
          newNode[R] = 0;
          var newNodeL = newNode[L];
          newNodeL[R] = newNode;
          root.setEnds(
            (_f = {}, _f[L] = root.getEnd(L), _f[R] = newNode, _f)
          );
        }
        root.domFrag().oneElement().appendChild(frag);
      }
      var currentLatex = this.exportLatex();
      if (currentLatex !== latex) {
        console.warn(
          "tried updating latex efficiently but did not work. Attempted: " + latex + " but wrote: " + currentLatex
        );
        return false;
      }
      var rightMost = root.getEnd(R);
      if (rightMost) {
        rightMost.fixDigitGrouping(this.cursor.options);
      }
      return true;
    };
    Controller_latex2.prototype.renderLatexMathFromScratch = function(latex) {
      var _c;
      var root = this.root, cursor = this.cursor;
      var all = Parser.all;
      var eof = Parser.eof;
      var block = latexMathParser.skip(eof).or(all.result(false)).parse(latex);
      root.setEnds((_c = {}, _c[L] = 0, _c[R] = 0, _c));
      if (block) {
        block.children().adopt(root, 0, 0);
      }
      if (block) {
        var frag = root.domFrag();
        frag.children().remove();
        frag.oneElement().appendChild(block.html());
        root.finalizeInsert(cursor.options, cursor);
      } else {
        root.domFrag().empty();
      }
    };
    Controller_latex2.prototype.renderLatexMath = function(latex) {
      var cursor = this.cursor;
      var root = this.root;
      this.notify("replace");
      cursor.clearSelection();
      var oldLatex = this.exportLatex();
      if (!root.getEnd(L) || !root.getEnd(R) || oldLatex !== latex) {
        this.updateLatexMathEfficiently(latex, oldLatex) || this.renderLatexMathFromScratch(latex);
        this.updateMathspeak();
      }
      cursor.insAtRightEnd(root);
    };
    Controller_latex2.prototype.renderLatexText = function(latex) {
      var _c;
      var root = this.root, cursor = this.cursor;
      root.domFrag().children().slice(1).remove();
      root.setEnds((_c = {}, _c[L] = 0, _c[R] = 0, _c));
      delete cursor.selection;
      cursor.show().insAtRightEnd(root);
      var regex = Parser.regex;
      var string = Parser.string;
      var eof = Parser.eof;
      var all = Parser.all;
      var mathMode = string("$").then(latexMathParser).skip(string("$").or(eof)).map(function(block) {
        var rootMathCommand = new RootMathCommand(cursor);
        rootMathCommand.createBlocks();
        var rootMathBlock = rootMathCommand.getEnd(L);
        block.children().adopt(rootMathBlock, 0, 0);
        return rootMathCommand;
      });
      var escapedDollar = string("\\$").result("$");
      var textChar = escapedDollar.or(regex(/^[^$]/)).map(function(ch) {
        return new VanillaSymbol(ch);
      });
      var latexText = mathMode.or(textChar).many();
      var commands = latexText.skip(eof).or(all.result(false)).parse(latex);
      if (commands) {
        for (var i = 0; i < commands.length; i += 1) {
          commands[i].adopt(root, root.getEnd(R), 0);
        }
        domFrag(root.html()).appendTo(root.domFrag().oneElement());
        root.finalizeInsert(cursor.options, cursor);
      }
    };
    return Controller_latex2;
  })(Controller_keystroke)
);
function mapFromUncleanedToCleanedIndices(uncleanedLatex, cleanedLatex, indices) {
  var startIndex = indices.uncleanedStartIndex;
  var endIndex = indices.uncleanedEndIndex;
  for (var uncleanIdx = 0, cleanIdx = 0; uncleanIdx < indices.uncleanedEndIndex; uncleanIdx++) {
    if (uncleanedLatex[uncleanIdx] !== cleanedLatex[cleanIdx]) {
      if (uncleanIdx < indices.uncleanedStartIndex) {
        startIndex -= 1;
      }
      endIndex -= 1;
    } else {
      cleanIdx += 1;
    }
  }
  return {
    startIndex,
    endIndex
  };
}
function mapFromCleanedToUncleanedIndices(cleanedLatex, uncleanedLatex, indices) {
  var cleanStartIdx = indices.startIndex;
  var cleanEndIdx = indices.endIndex;
  var uncleanStartIndex = cleanStartIdx;
  var uncleanEndIndex = cleanEndIdx;
  for (var uncleanIdx = 0, cleanIdx = 0; uncleanIdx < uncleanedLatex.length; uncleanIdx++) {
    if (uncleanedLatex[uncleanIdx] !== cleanedLatex[cleanIdx]) {
      if (cleanIdx <= cleanStartIdx) {
        uncleanStartIndex += 1;
      }
      if (cleanIdx <= cleanEndIdx) {
        uncleanEndIndex += 1;
      }
    } else {
      cleanIdx += 1;
    }
  }
  return {
    uncleanStartIndex,
    uncleanEndIndex
  };
}
var ignoreNextMouseDownNoop = function(_el) {
  return false;
};
Options.prototype.ignoreNextMousedown = ignoreNextMouseDownNoop;
var cancelSelectionOnEdit;
(function() {
  ControllerBase.onNotify(function(cursor, e) {
    if (e === "edit" || e === "replace") {
      if (cancelSelectionOnEdit && cancelSelectionOnEdit.cursor === cursor) {
        cancelSelectionOnEdit.cb();
      }
    }
  });
})();
var Controller_mouse = (
  /** @class */
  (function(_super) {
    __extends(Controller_mouse2, _super);
    function Controller_mouse2() {
      var _this_1 = _super !== null && _super.apply(this, arguments) || this;
      _this_1.handleMouseDown = function(e) {
        var rootElement = closest(e.target, ".mq-root-block");
        var root = rootElement && NodeBase.getNodeOfElement(rootElement) || NodeBase.getNodeOfElement(_this_1.root.domFrag().oneElement());
        var ownerDocument = root.domFrag().firstNode().ownerDocument;
        var ctrlr = root.controller, cursor = ctrlr.cursor, blink = cursor.blink;
        var textarea = ctrlr.getTextarea();
        e.preventDefault();
        e.target.unselectable = true;
        if (cursor.options.ignoreNextMousedown(e)) return;
        if (closest(e.target, ".mq-ignore-mousedown")) {
          return;
        }
        var lastMousemoveTarget = null;
        function mousemove(e2) {
          lastMousemoveTarget = e2.target;
        }
        function onDocumentMouseMove(e2) {
          if (!cursor.anticursor) cursor.startSelection();
          ctrlr.seek(lastMousemoveTarget, e2.clientX, e2.clientY).cursor.select();
          if (cursor.selection)
            cursor.controller.aria.clear().queue(cursor.selection.join("mathspeak") + " selected").alert();
          lastMousemoveTarget = null;
        }
        function unbindListeners() {
          rootElement === null || rootElement === void 0 ? void 0 : rootElement.removeEventListener("mousemove", mousemove);
          ownerDocument === null || ownerDocument === void 0 ? void 0 : ownerDocument.removeEventListener(
            "mousemove",
            onDocumentMouseMove
          );
          ownerDocument === null || ownerDocument === void 0 ? void 0 : ownerDocument.removeEventListener(
            "mouseup",
            onDocumentMouseUp
          );
          cancelSelectionOnEdit = void 0;
          ctrlr.isMouseSelecting = false;
        }
        function updateCursor() {
          if (ctrlr.editable) {
            cursor.show();
            cursor.controller.aria.queue(cursor.parent).alert();
          }
        }
        function onDocumentMouseUp() {
          cursor.blink = blink;
          if (!cursor.selection) updateCursor();
          unbindListeners();
        }
        var wasEdited;
        cancelSelectionOnEdit = {
          cursor,
          cb: function() {
            wasEdited = true;
            cursor.blink = blink;
            cursor.clearSelection();
            updateCursor();
            unbindListeners();
          }
        };
        if (ctrlr.blurred) {
          if (_this_1.editable) textarea.focus();
          if (wasEdited) return;
        }
        cursor.blink = noop;
        ctrlr.isMouseSelecting = true;
        ctrlr.seek(e.target, e.clientX, e.clientY).cursor.startSelection();
        rootElement === null || rootElement === void 0 ? void 0 : rootElement.addEventListener("mousemove", mousemove);
        ownerDocument === null || ownerDocument === void 0 ? void 0 : ownerDocument.addEventListener(
          "mousemove",
          onDocumentMouseMove
        );
        ownerDocument === null || ownerDocument === void 0 ? void 0 : ownerDocument.addEventListener("mouseup", onDocumentMouseUp);
      };
      return _this_1;
    }
    Controller_mouse2.prototype.addMouseEventListener = function() {
      this.container.addEventListener("mousedown", this.handleMouseDown);
    };
    Controller_mouse2.prototype.removeMouseEventListener = function() {
      this.container.removeEventListener("mousedown", this.handleMouseDown);
    };
    Controller_mouse2.prototype.seek = function(targetElm, clientX, _clientY) {
      var cursor = this.notify("select").cursor;
      var node;
      while (targetElm) {
        node = NodeBase.getNodeOfElement(targetElm);
        if (node) {
          var root = findControllerRoot(node);
          if (root && root !== this.root) {
            targetElm = root.controller.container;
          } else {
            break;
          }
        }
        targetElm = targetElm.parentElement;
      }
      if (!node) {
        node = this.root;
      }
      cursor.clearSelection().show();
      node.seek(clientX, cursor);
      this.scrollHoriz();
      return this;
    };
    return Controller_mouse2;
  })(Controller_latex)
);
function findControllerRoot(node) {
  while (node) {
    if (ControllerBase.isControllerRoot(node)) {
      return node;
    }
    node = node.parent;
  }
  return void 0;
}
var Controller_scrollHoriz = (
  /** @class */
  (function(_super) {
    __extends(Controller_scrollHoriz2, _super);
    function Controller_scrollHoriz2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Controller_scrollHoriz2.prototype.setOverflowClasses = function() {
      var root = this.root.domFrag().oneElement();
      var shouldHaveOverflowRight = false;
      var shouldHaveOverflowLeft = false;
      if (!this.blurred) {
        var width = getBoundingClientRect(root).width;
        var scrollWidth = root.scrollWidth;
        var scroll = root.scrollLeft;
        shouldHaveOverflowRight = scrollWidth > width + scroll;
        shouldHaveOverflowLeft = scroll > 0;
      }
      if (root.classList.contains("mq-editing-overflow-right") !== shouldHaveOverflowRight)
        root.classList.toggle("mq-editing-overflow-right");
      if (root.classList.contains("mq-editing-overflow-left") !== shouldHaveOverflowLeft)
        root.classList.toggle("mq-editing-overflow-left");
    };
    Controller_scrollHoriz2.prototype.scrollHoriz = function() {
      var _this_1 = this;
      var cursor = this.cursor, seln = cursor.selection;
      var rootRect = getBoundingClientRect(this.root.domFrag().oneElement());
      if (cursor.domFrag().isEmpty() && !seln) {
        if (this.cancelScrollHoriz) {
          this.cancelScrollHoriz();
          this.cancelScrollHoriz = void 0;
        }
        var rootElt_1 = this.root.domFrag().oneElement();
        var start_1 = rootElt_1.scrollLeft;
        animate(
          this.getScrollAnimationDuration(),
          function(progress, scheduleNext, cancel) {
            if (progress >= 1) {
              _this_1.cancelScrollHoriz = void 0;
              rootElt_1.scrollLeft = 0;
              _this_1.setOverflowClasses();
            } else {
              _this_1.cancelScrollHoriz = cancel;
              scheduleNext();
              rootElt_1.scrollLeft = Math.round(
                (1 - progress) * start_1
              );
            }
          }
        );
        return;
      } else if (!seln) {
        var x = getBoundingClientRect(cursor.domFrag().oneElement()).left;
        if (x > rootRect.right - 20)
          var scrollBy = x - (rootRect.right - 20);
        else if (x < rootRect.left + 20)
          var scrollBy = x - (rootRect.left + 20);
        else return;
      } else {
        var rect = getBoundingClientRect(seln.domFrag().oneElement());
        var overLeft = rect.left - (rootRect.left + 20);
        var overRight = rect.right - (rootRect.right - 20);
        if (seln.getEnd(L) === cursor[R]) {
          if (overLeft < 0) var scrollBy = overLeft;
          else if (overRight > 0) {
            if (rect.left - overRight < rootRect.left + 20)
              var scrollBy = overLeft;
            else var scrollBy = overRight;
          } else return;
        } else {
          if (overRight > 0) var scrollBy = overRight;
          else if (overLeft < 0) {
            if (rect.right - overLeft > rootRect.right - 20)
              var scrollBy = overRight;
            else var scrollBy = overLeft;
          } else return;
        }
      }
      var root = this.root.domFrag().oneElement();
      if (scrollBy < 0 && root.scrollLeft === 0) return;
      if (scrollBy > 0 && root.scrollWidth <= root.scrollLeft + rootRect.width)
        return;
      if (this.cancelScrollHoriz) {
        this.cancelScrollHoriz();
        this.cancelScrollHoriz = void 0;
      }
      var rootElt = this.root.domFrag().oneElement();
      var start = rootElt.scrollLeft;
      animate(
        this.getScrollAnimationDuration(),
        function(progress, scheduleNext, cancel) {
          if (progress >= 1) {
            _this_1.cancelScrollHoriz = void 0;
            rootElt.scrollLeft = Math.round(start + scrollBy);
            _this_1.setOverflowClasses();
          } else {
            _this_1.cancelScrollHoriz = cancel;
            scheduleNext();
            rootElt.scrollLeft = Math.round(
              start + progress * scrollBy
            );
          }
        }
      );
    };
    Controller_scrollHoriz2.prototype.getScrollAnimationDuration = function() {
      var _c;
      return (_c = this.options.scrollAnimationDuration) !== null && _c !== void 0 ? _c : 100;
    };
    return Controller_scrollHoriz2;
  })(Controller_mouse)
);
Options.prototype.substituteTextarea = function() {
  return h("textarea", {
    autocapitalize: "off",
    autocomplete: "off",
    autocorrect: "off",
    spellcheck: false,
    "x-palm-disable-ste-all": true
  });
};
function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function(c) {
      var r = Math.random() * 16 | 0;
      var v = c === "x" ? r : r & 3 | 8;
      return v.toString(16);
    }
  );
}
function defaultSubstituteKeyboardEvents(jq, controller) {
  return saneKeyboardEvents(jq[0], controller);
}
Options.prototype.substituteKeyboardEvents = defaultSubstituteKeyboardEvents;
var Controller = (
  /** @class */
  (function(_super) {
    __extends(Controller2, _super);
    function Controller2() {
      var _this_1 = _super !== null && _super.apply(this, arguments) || this;
      _this_1.selectFn = noop;
      return _this_1;
    }
    Controller2.prototype.createTextarea = function() {
      this.textareaSpan = h("span", { class: "mq-textarea" });
      var textarea = this.options.substituteTextarea();
      if (!textarea.nodeType) {
        throw "substituteTextarea() must return a DOM element, got " + textarea;
      }
      this.textarea = domFrag(textarea).appendTo(this.textareaSpan).oneElement();
      if (!this.mathspeakSpan) {
        this.mathspeakId = generateUUID();
        this.mathspeakSpan = h("span", {
          class: "mq-mathspeak",
          id: this.mathspeakId
        });
        domFrag(this.textareaSpan).prepend(domFrag(this.mathspeakSpan));
      }
      if (this.mathspeakId) {
        textarea === null || textarea === void 0 ? void 0 : textarea.setAttribute("aria-labelledby", this.mathspeakId);
      }
      var ctrlr = this;
      ctrlr.cursor.selectionChanged = function() {
        ctrlr.selectionChanged();
      };
      var tabindex = this.options.tabindex !== void 0 ? this.options.tabindex : this.KIND_OF_MQ === "StaticMath" ? -1 : 0;
      this.setTabindex(tabindex);
    };
    Controller2.prototype.setTabindex = function(tabindex) {
      var _c, _d, _e, _f, _g;
      if (tabindex === this.previousTabindex || !this.textarea) return;
      this.previousTabindex = tabindex;
      (_c = this.textarea) === null || _c === void 0 ? void 0 : _c.setAttribute("tabindex", "" + tabindex);
      if (tabindex < 0 && this.KIND_OF_MQ === "StaticMath") {
        (_d = this.textarea) === null || _d === void 0 ? void 0 : _d.setAttribute("aria-hidden", "true");
      } else {
        (_e = this.textarea) === null || _e === void 0 ? void 0 : _e.removeAttribute("aria-hidden");
      }
      if (tabindex >= 0) {
        (_f = this.mathspeakSpan) === null || _f === void 0 ? void 0 : _f.setAttribute("aria-hidden", "true");
      } else {
        (_g = this.mathspeakSpan) === null || _g === void 0 ? void 0 : _g.removeAttribute("aria-hidden");
      }
    };
    Controller2.prototype.selectionChanged = function() {
      var ctrlr = this;
      if (!ctrlr.textareaSelectionTimeout) {
        ctrlr.textareaSelectionTimeout = setTimeout(function() {
          ctrlr.setTextareaSelection();
        });
      }
    };
    Controller2.prototype.setTextareaSelection = function() {
      this.textareaSelectionTimeout = 0;
      var latex = "";
      if (this.cursor.selection) {
        latex = this.cleanLatex(this.cursor.selection.join("latex"));
        if (this.options.statelessClipboard) {
          latex = "$" + latex + "$";
        }
      }
      this.selectFn(latex);
    };
    Controller2.prototype.staticMathTextareaEvents = function() {
      var ctrlr = this;
      this.removeTextareaEventListener("cut");
      this.removeTextareaEventListener("paste");
      if (ctrlr.options.disableCopyPaste) {
        this.removeTextareaEventListener("copy");
      } else {
        this.addTextareaEventListeners({
          copy: function() {
            ctrlr.setTextareaSelection();
          }
        });
      }
      this.addStaticFocusBlurListeners();
      var textarea = this.getTextarea();
      var select = saneKeyboardEvents(textarea, this).select;
      this.selectFn = select;
      var textareaSpan = this.getTextareaSpan();
      domFrag(this.container).prepend(domFrag(textareaSpan));
    };
    Controller2.prototype.editablesTextareaEvents = function() {
      var ctrlr = this;
      var textarea = ctrlr.getTextarea();
      var textareaSpan = ctrlr.getTextareaSpan();
      if (this.options.version < 3) {
        var $ = this.options.assertJquery();
        var keyboardEventsShim = this.options.substituteKeyboardEvents(
          $(textarea),
          this
        );
        this.selectFn = function(text) {
          keyboardEventsShim.select(text);
        };
      } else {
        var select = saneKeyboardEvents(textarea, this).select;
        this.selectFn = select;
      }
      domFrag(this.container).prepend(domFrag(textareaSpan));
      this.addEditableFocusBlurListeners();
      this.updateMathspeak();
    };
    Controller2.prototype.unbindEditablesEvents = function() {
      var ctrlr = this;
      var textarea = ctrlr.getTextarea();
      var textareaSpan = ctrlr.getTextareaSpan();
      this.selectFn = function(text) {
        if (!(textarea instanceof HTMLTextAreaElement)) return;
        textarea.value = text;
        if (text) textarea.select();
      };
      domFrag(textareaSpan).remove();
      this.removeTextareaEventListener("focus");
      this.removeTextareaEventListener("blur");
      ctrlr.blurred = true;
      this.removeTextareaEventListener("cut");
      this.removeTextareaEventListener("paste");
    };
    Controller2.prototype.typedText = function(ch) {
      if (ch === "\n") return this.handle("enter");
      var cursor = this.notify(void 0).cursor;
      cursor.parent.write(cursor, ch);
      this.scrollHoriz();
    };
    Controller2.prototype.cut = function() {
      var ctrlr = this, cursor = ctrlr.cursor;
      if (cursor.selection) {
        setTimeout(function() {
          ctrlr.notify("edit");
          cursor.parent.bubble(function(node) {
            node.reflow();
            return void 0;
          });
          if (ctrlr.options && ctrlr.options.onCut) {
            ctrlr.options.onCut();
          }
        });
      }
    };
    Controller2.prototype.copy = function() {
      this.setTextareaSelection();
    };
    Controller2.prototype.paste = function(text) {
      if (this.options.statelessClipboard) {
        if (text.slice(0, 1) === "$" && text.slice(-1) === "$") {
          text = text.slice(1, -1);
        } else {
          text = "\\text{" + text + "}";
        }
      }
      this.writeLatex(text).cursor.show();
      this.scrollHoriz();
      if (this.options && this.options.onPaste) {
        this.options.onPaste();
      }
    };
    Controller2.prototype.setupStaticField = function() {
      this.updateMathspeak();
      this.blurred = true;
      this.cursor.hide().parent.blur(this.cursor);
    };
    Controller2.prototype.updateMathspeak = function(opts) {
      var ctrlr = this;
      var ariaLabel = ctrlr.getAriaLabel();
      var labelWithSuffix = /[A-Za-z0-9]$/.test(ariaLabel) ? ariaLabel + ":" : ariaLabel;
      var mathspeak = ctrlr.root.mathspeak().trim();
      var emptyContent = !!(opts === null || opts === void 0 ? void 0 : opts.emptyContent);
      this.aria.clear({ emptyContent });
      if (!!ctrlr.mathspeakSpan) {
        ctrlr.mathspeakSpan.textContent = (labelWithSuffix + " " + mathspeak + " " + ctrlr.ariaPostLabel).trim();
      }
    };
    return Controller2;
  })(Controller_scrollHoriz)
);
var MathElement = (
  /** @class */
  (function(_super) {
    __extends(MathElement2, _super);
    function MathElement2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    MathElement2.prototype.finalizeInsert = function(options, cursor) {
      var self = this;
      self.postOrder(function(node) {
        node.finalizeTree(options);
      });
      self.postOrder(function(node) {
        node.contactWeld(cursor);
      });
      self.postOrder(function(node) {
        node.blur(cursor);
      });
      self.postOrder(function(node) {
        node.reflow();
      });
      var selfR = self[R];
      var selfL = self[L];
      if (selfR) selfR.siblingCreated(options, L);
      if (selfL) selfL.siblingCreated(options, R);
      self.bubble(function(node) {
        node.reflow();
        return void 0;
      });
    };
    MathElement2.prototype.prepareInsertionAt = function(cursor) {
      var maxDepth = cursor.options.maxDepth;
      if (maxDepth !== void 0) {
        var cursorDepth = cursor.depth();
        if (cursorDepth > maxDepth) {
          return false;
        }
        this.removeNodesDeeperThan(maxDepth - cursorDepth);
      }
      return true;
    };
    MathElement2.prototype.removeNodesDeeperThan = function(cutoff) {
      var depth = 0;
      var queue = [[this, depth]];
      var current;
      while (current = queue.shift()) {
        var c = current;
        c[0].children().each(function(child) {
          var i = child instanceof MathBlock ? 1 : 0;
          depth = c[1] + i;
          if (depth <= cutoff) {
            queue.push([child, depth]);
          } else {
            (i ? child.children() : child).remove();
          }
          return void 0;
        });
      }
    };
    return MathElement2;
  })(MQNode)
);
var DOMView = (
  /** @class */
  /* @__PURE__ */ (function() {
    function DOMView2(childCount, render) {
      this.childCount = childCount;
      this.render = render;
    }
    return DOMView2;
  })()
);
var MathCommand = (
  /** @class */
  (function(_super) {
    __extends(MathCommand2, _super);
    function MathCommand2(ctrlSeq, domView, textTemplate) {
      var _this_1 = _super.call(this) || this;
      _this_1.textTemplate = [""];
      _this_1.mathspeakTemplate = [""];
      _this_1.setCtrlSeqHtmlAndText(ctrlSeq, domView, textTemplate);
      return _this_1;
    }
    MathCommand2.prototype.setEnds = function(ends) {
      pray("MathCommand ends are never empty", ends[L] && ends[R]);
      this.ends = ends;
    };
    MathCommand2.prototype.getEnd = function(dir) {
      return this.ends[dir];
    };
    MathCommand2.prototype.setCtrlSeqHtmlAndText = function(ctrlSeq, domView, textTemplate) {
      if (!this.ctrlSeq) this.ctrlSeq = ctrlSeq;
      if (domView) this.domView = domView;
      if (textTemplate) this.textTemplate = textTemplate;
    };
    MathCommand2.prototype.replaces = function(replacedFragment) {
      replacedFragment.disown();
      this.replacedFragment = replacedFragment;
    };
    MathCommand2.prototype.isEmpty = function() {
      return this.foldChildren(true, function(isEmpty, child) {
        return isEmpty && child.isEmpty();
      });
    };
    MathCommand2.prototype.parser = function() {
      var _this_1 = this;
      var block = latexMathParser.block;
      return block.times(this.numBlocks()).map(function(blocks) {
        _this_1.blocks = blocks;
        for (var i = 0; i < blocks.length; i += 1) {
          blocks[i].adopt(_this_1, _this_1.getEnd(R), 0);
        }
        return _this_1;
      });
    };
    MathCommand2.prototype.createLeftOf = function(cursor) {
      var cmd = this;
      var replacedFragment = cmd.replacedFragment;
      cmd.createBlocks();
      _super.prototype.createLeftOf.call(this, cursor);
      if (replacedFragment) {
        var cmdEndsL = cmd.getEnd(L);
        replacedFragment.adopt(cmdEndsL, 0, 0);
        replacedFragment.domFrag().appendTo(cmdEndsL.domFrag().oneElement());
        cmd.placeCursor(cursor);
        cmd.prepareInsertionAt(cursor);
      }
      cmd.finalizeInsert(cursor.options, cursor);
      cmd.placeCursor(cursor);
    };
    MathCommand2.prototype.createBlocks = function() {
      var cmd = this, numBlocks = cmd.numBlocks(), blocks = cmd.blocks = Array(numBlocks);
      for (var i = 0; i < numBlocks; i += 1) {
        var newBlock = blocks[i] = new MathBlock();
        newBlock.adopt(cmd, cmd.getEnd(R), 0);
      }
    };
    MathCommand2.prototype.placeCursor = function(cursor) {
      cursor.insAtRightEnd(
        this.foldChildren(this.getEnd(L), function(leftward, child) {
          return leftward.isEmpty() ? leftward : child;
        })
      );
    };
    MathCommand2.prototype.moveTowards = function(dir, cursor, updown) {
      var updownInto;
      if (updown === "up") {
        updownInto = this.upInto;
      } else if (updown === "down") {
        updownInto = this.downInto;
      }
      var el = updownInto || this.getEnd(-dir);
      cursor.insAtDirEnd(-dir, el);
      cursor.controller.aria.queueDirEndOf(-dir).queue(cursor.parent, true);
    };
    MathCommand2.prototype.deleteTowards = function(dir, cursor) {
      if (this.isEmpty()) cursor[dir] = this.remove()[dir];
      else this.moveTowards(dir, cursor);
    };
    MathCommand2.prototype.selectTowards = function(dir, cursor) {
      cursor[-dir] = this;
      cursor[dir] = this[dir];
    };
    MathCommand2.prototype.selectChildren = function() {
      return new MQSelection(this, this);
    };
    MathCommand2.prototype.unselectInto = function(dir, cursor) {
      var antiCursor = cursor.anticursor;
      var ancestor = antiCursor.ancestors[this.id];
      cursor.insAtDirEnd(-dir, ancestor);
    };
    MathCommand2.prototype.seek = function(clientX, cursor) {
      function getBounds(node) {
        var _c;
        var el = node.domFrag().oneElement();
        var l = getBoundingClientRect(el).left;
        var r = l + el.offsetWidth;
        return _c = {}, _c[L] = l, _c[R] = r, _c;
      }
      var cmd = this;
      var cmdBounds = getBounds(cmd);
      if (clientX < cmdBounds[L]) return cursor.insLeftOf(cmd);
      if (clientX > cmdBounds[R]) return cursor.insRightOf(cmd);
      var leftLeftBound = cmdBounds[L];
      cmd.eachChild(function(block) {
        var blockBounds = getBounds(block);
        if (clientX < blockBounds[L]) {
          if (clientX - leftLeftBound < blockBounds[L] - clientX) {
            if (block[L]) cursor.insAtRightEnd(block[L]);
            else cursor.insLeftOf(cmd);
          } else cursor.insAtLeftEnd(block);
          return false;
        } else if (clientX > blockBounds[R]) {
          if (block[R]) leftLeftBound = blockBounds[R];
          else {
            if (cmdBounds[R] - clientX < clientX - blockBounds[R]) {
              cursor.insRightOf(cmd);
            } else cursor.insAtRightEnd(block);
          }
          return void 0;
        } else {
          block.seek(clientX, cursor);
          return false;
        }
      });
      return void 0;
    };
    MathCommand2.prototype.numBlocks = function() {
      return this.domView.childCount;
    };
    MathCommand2.prototype.html = function() {
      var blocks = this.blocks;
      pray("domView is defined", this.domView);
      var template = this.domView;
      var dom = template.render(blocks || []);
      this.setDOM(dom);
      NodeBase.linkElementByCmdNode(dom, this);
      return dom;
    };
    MathCommand2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      ctx.uncleanedLatex += this.ctrlSeq || "";
      this.eachChild(function(child) {
        ctx.uncleanedLatex += "{";
        var beforeLength = ctx.uncleanedLatex.length;
        child.latexRecursive(ctx);
        var afterLength = ctx.uncleanedLatex.length;
        if (beforeLength === afterLength) {
          ctx.uncleanedLatex += " ";
        }
        ctx.uncleanedLatex += "}";
      });
      this.checkCursorContextClose(ctx);
    };
    MathCommand2.prototype.text = function() {
      var cmd = this, i = 0;
      return cmd.foldChildren(cmd.textTemplate[i], function(text, child) {
        i += 1;
        var child_text = child.text();
        if (text && cmd.textTemplate[i] === "(" && child_text[0] === "(" && child_text.slice(-1) === ")")
          return text + child_text.slice(1, -1) + cmd.textTemplate[i];
        return text + child_text + (cmd.textTemplate[i] || "");
      });
    };
    MathCommand2.prototype.mathspeak = function() {
      var cmd = this, i = 0;
      return cmd.foldChildren(
        cmd.mathspeakTemplate[i] || "Start" + cmd.ctrlSeq + " ",
        function(speech, block) {
          i += 1;
          return speech + " " + block.mathspeak() + " " + (cmd.mathspeakTemplate[i] + " " || "End" + cmd.ctrlSeq + " ");
        }
      );
    };
    return MathCommand2;
  })(MathElement)
);
var MQSymbol = (
  /** @class */
  (function(_super) {
    __extends(MQSymbol2, _super);
    function MQSymbol2(ctrlSeq, html, text, mathspeak) {
      var _this_1 = _super.call(this) || this;
      _this_1.setCtrlSeqHtmlTextAndMathspeak(
        ctrlSeq,
        html ? new DOMView(0, function() {
          return html.cloneNode(true);
        }) : void 0,
        text,
        mathspeak
      );
      return _this_1;
    }
    MQSymbol2.prototype.setCtrlSeqHtmlTextAndMathspeak = function(ctrlSeq, html, text, mathspeak) {
      if (!text && !!ctrlSeq) {
        text = ctrlSeq.replace(/^\\/, "");
      }
      this.mathspeakName = mathspeak || text;
      _super.prototype.setCtrlSeqHtmlAndText.call(this, ctrlSeq, html, [
        text || ""
      ]);
    };
    MQSymbol2.prototype.parser = function() {
      return Parser.succeed(this);
    };
    MQSymbol2.prototype.numBlocks = function() {
      return 0;
    };
    MQSymbol2.prototype.replaces = function(replacedFragment) {
      replacedFragment.remove();
    };
    MQSymbol2.prototype.createBlocks = function() {
    };
    MQSymbol2.prototype.moveTowards = function(dir, cursor) {
      cursor.domFrag().insDirOf(dir, this.domFrag());
      cursor[-dir] = this;
      cursor[dir] = this[dir];
      cursor.controller.aria.queue(this);
    };
    MQSymbol2.prototype.deleteTowards = function(dir, cursor) {
      cursor[dir] = this.remove()[dir];
    };
    MQSymbol2.prototype.seek = function(clientX, cursor) {
      var el = this.domFrag().oneElement();
      var left = getBoundingClientRect(el).left;
      if (clientX - left < el.offsetWidth / 2) cursor.insLeftOf(this);
      else cursor.insRightOf(this);
      return cursor;
    };
    MQSymbol2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      ctx.uncleanedLatex += this.ctrlSeq || "";
      this.checkCursorContextClose(ctx);
    };
    MQSymbol2.prototype.text = function() {
      return this.textTemplate.join("");
    };
    MQSymbol2.prototype.mathspeak = function(_opts) {
      return this.mathspeakName || "";
    };
    MQSymbol2.prototype.placeCursor = function() {
    };
    MQSymbol2.prototype.isEmpty = function() {
      return true;
    };
    return MQSymbol2;
  })(MathCommand)
);
var VanillaSymbol = (
  /** @class */
  (function(_super) {
    __extends(VanillaSymbol2, _super);
    function VanillaSymbol2(ch, html, mathspeak) {
      return _super.call(
        this,
        ch,
        h("span", {}, [html || h.text(ch)]),
        void 0,
        mathspeak
      ) || this;
    }
    return VanillaSymbol2;
  })(MQSymbol)
);
function bindVanillaSymbol(ch, htmlEntity, mathspeak) {
  return function() {
    return new VanillaSymbol(
      ch,
      htmlEntity ? h.entityText(htmlEntity) : void 0,
      mathspeak
    );
  };
}
var BinaryOperator = (
  /** @class */
  (function(_super) {
    __extends(BinaryOperator2, _super);
    function BinaryOperator2(ctrlSeq, html, text, mathspeak, treatLikeSymbol) {
      var _this_1 = this;
      if (treatLikeSymbol) {
        _this_1 = _super.call(
          this,
          ctrlSeq,
          h("span", {}, [html || h.text(ctrlSeq || "")]),
          void 0,
          mathspeak
        ) || this;
      } else {
        _this_1 = _super.call(
          this,
          ctrlSeq,
          h(
            "span",
            { class: "mq-binary-operator" },
            html ? [html] : []
          ),
          text,
          mathspeak
        ) || this;
      }
      return _this_1;
    }
    BinaryOperator2.prototype.isBinaryOperator = function() {
      return true;
    };
    return BinaryOperator2;
  })(MQSymbol)
);
function bindBinaryOperator(ctrlSeq, htmlEntity, text, mathspeak) {
  return function() {
    return new BinaryOperator(
      ctrlSeq,
      htmlEntity ? h.entityText(htmlEntity) : void 0,
      text,
      mathspeak
    );
  };
}
var MathBlock = (
  /** @class */
  (function(_super) {
    __extends(MathBlock2, _super);
    function MathBlock2() {
      var _this_1 = _super !== null && _super.apply(this, arguments) || this;
      _this_1.ariaLabel = "block";
      return _this_1;
    }
    MathBlock2.prototype.join = function(methodName) {
      return this.foldChildren("", function(fold, child) {
        return fold + child[methodName]();
      });
    };
    MathBlock2.prototype.html = function() {
      var fragment = document.createDocumentFragment();
      this.eachChild(function(el) {
        var childHtml = el.html();
        fragment.appendChild(childHtml);
        return void 0;
      });
      return fragment;
    };
    MathBlock2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      this.eachChild(function(child) {
        return child.latexRecursive(ctx);
      });
      this.checkCursorContextClose(ctx);
    };
    MathBlock2.prototype.text = function() {
      var endsL = this.getEnd(L);
      var endsR = this.getEnd(R);
      return endsL === endsR && endsL !== 0 ? endsL.text() : this.join("text");
    };
    MathBlock2.prototype.mathspeak = function() {
      var tempOp = "";
      var autoOps = {};
      if (this.controller)
        autoOps = this.controller.options.autoOperatorNames;
      return this.foldChildren([], function(speechArray, cmd) {
        if (cmd.isPartOfOperator) {
          tempOp += cmd.mathspeak();
        } else {
          if (tempOp !== "") {
            if (autoOps._maxLength > 0) {
              var x = autoOps[tempOp.toLowerCase()];
              if (typeof x === "string") tempOp = x;
            }
            speechArray.push(tempOp + " ");
            tempOp = "";
          }
          var mathspeakText = cmd.mathspeak();
          var cmdText = cmd.ctrlSeq;
          if (isNaN(cmdText) && // TODO - revisit this to improve the isNumber() check
          cmdText !== "." && (!cmd.parent || !cmd.parent.parent || !cmd.parent.parent.isTextBlock())) {
            mathspeakText = " " + mathspeakText + " ";
          }
          speechArray.push(mathspeakText);
        }
        return speechArray;
      }).join("").replace(/ +(?= )/g, "").replace(/(\.)([0-9]+)/g, function(_match, p1, p2) {
        return p1 + p2.split("").join(" ").trim();
      });
    };
    MathBlock2.prototype.keystroke = function(key, e, ctrlr) {
      if (ctrlr.options.spaceBehavesLikeTab && (key === "Spacebar" || key === "Shift-Spacebar")) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        ctrlr.escapeDir(key === "Shift-Spacebar" ? L : R, key, e);
        return;
      }
      return _super.prototype.keystroke.call(this, key, e, ctrlr);
    };
    MathBlock2.prototype.moveOutOf = function(dir, cursor, updown) {
      var updownInto;
      if (updown === "up") {
        updownInto = this.parent.upInto;
      } else if (updown === "down") {
        updownInto = this.parent.downInto;
      }
      if (!updownInto && this[dir]) {
        var otherDir = -dir;
        cursor.insAtDirEnd(otherDir, this[dir]);
        cursor.controller.aria.queueDirEndOf(otherDir).queue(cursor.parent, true);
      } else {
        cursor.insDirOf(dir, this.parent);
        cursor.controller.aria.queueDirOf(dir).queue(this.parent);
      }
    };
    MathBlock2.prototype.selectOutOf = function(dir, cursor) {
      cursor.insDirOf(dir, this.parent);
    };
    MathBlock2.prototype.deleteOutOf = function(_dir, cursor) {
      cursor.unwrapGramp();
    };
    MathBlock2.prototype.seek = function(clientX, cursor) {
      var node = this.getEnd(R);
      if (!node) return cursor.insAtRightEnd(this);
      var el = node.domFrag().oneElement();
      var left = getBoundingClientRect(el).left;
      if (left + el.offsetWidth < clientX) {
        return cursor.insAtRightEnd(this);
      }
      var endsL = this.getEnd(L);
      if (clientX < getBoundingClientRect(endsL.domFrag().oneElement()).left)
        return cursor.insAtLeftEnd(this);
      while (clientX < getBoundingClientRect(node.domFrag().oneElement()).left)
        node = node[L];
      return node.seek(clientX, cursor);
    };
    MathBlock2.prototype.chToCmd = function(ch, options) {
      var cons;
      if (ch.match(/^[a-eg-zA-Z]$/)) return new Letter(ch);
      else if (/^\d$/.test(ch)) return new Digit(ch);
      else if (options && options.typingSlashWritesDivisionSymbol && ch === "/")
        return LatexCmds["÷"](ch);
      else if (options && options.typingAsteriskWritesTimesSymbol && ch === "*")
        return LatexCmds["×"](ch);
      else if (options && options.typingPercentWritesPercentOf && ch === "%")
        return LatexCmds.percentof(ch);
      else if (cons = CharCmds[ch] || LatexCmds[ch]) {
        if (cons.constructor) {
          return new cons(ch);
        } else {
          return cons(ch);
        }
      } else return new VanillaSymbol(ch);
    };
    MathBlock2.prototype.write = function(cursor, ch) {
      var cmd = this.chToCmd(ch, cursor.options);
      if (cursor.selection) cmd.replaces(cursor.replaceSelection());
      if (!cursor.isTooDeep()) {
        cmd.createLeftOf(cursor.show());
        if (ch === "/") {
          cursor.controller.aria.alert("over");
        } else {
          cursor.controller.aria.alert(
            cmd.mathspeak({ createdLeftOf: cursor })
          );
        }
      }
    };
    MathBlock2.prototype.writeLatex = function(cursor, latex) {
      var all = Parser.all;
      var eof = Parser.eof;
      var block = latexMathParser.skip(eof).or(all.result(false)).parse(latex);
      if (block && !block.isEmpty() && block.prepareInsertionAt(cursor)) {
        block.children().adopt(cursor.parent, cursor[L], cursor[R]);
        domFrag(block.html()).insertBefore(cursor.domFrag());
        cursor[L] = block.getEnd(R);
        block.finalizeInsert(cursor.options, cursor);
        var blockEndsR = block.getEnd(R);
        var blockEndsL = block.getEnd(L);
        var blockEndsRR = blockEndsR[R];
        var blockEndsLL = blockEndsL[L];
        if (blockEndsRR) blockEndsRR.siblingCreated(cursor.options, L);
        if (blockEndsLL) blockEndsLL.siblingCreated(cursor.options, R);
        cursor.parent.bubble(function(node) {
          node.reflow();
          return void 0;
        });
      }
    };
    MathBlock2.prototype.focus = function() {
      this.domFrag().addClass("mq-hasCursor");
      this.domFrag().removeClass("mq-empty");
      return this;
    };
    MathBlock2.prototype.blur = function(cursor) {
      this.domFrag().removeClass("mq-hasCursor");
      if (this.isEmpty()) {
        this.domFrag().addClass("mq-empty");
        if (cursor && this.isQuietEmptyDelimiter(cursor.options.quietEmptyDelimiters)) {
          this.domFrag().addClass("mq-quiet-delimiter");
        }
      }
      return this;
    };
    return MathBlock2;
  })(MathElement)
);
Options.prototype.mouseEvents = true;
API.StaticMath = function(APIClasses) {
  var _c;
  return _c = /** @class */
  (function(_super) {
    __extends(StaticMath, _super);
    function StaticMath(el) {
      var _this_1 = _super.call(this, el) || this;
      var innerFields = _this_1.innerFields = [];
      _this_1.__controller.root.postOrder(function(node) {
        node.registerInnerField(
          innerFields,
          APIClasses.InnerMathField
        );
      });
      return _this_1;
    }
    StaticMath.prototype.__mathquillify = function(opts, _interfaceVersion) {
      this.config(opts);
      _super.prototype.mathquillify.call(this, "mq-math-mode");
      this.__controller.setupStaticField();
      if (this.__options.mouseEvents) {
        this.__controller.addMouseEventListener();
      }
      this.__controller.staticMathTextareaEvents();
      return this;
    };
    StaticMath.prototype.latex = function(_latex) {
      var returned = _super.prototype.latex.apply(this, arguments);
      if (arguments.length > 0) {
        var innerFields = this.innerFields = [];
        this.__controller.root.postOrder(function(node) {
          node.registerInnerField(
            innerFields,
            APIClasses.InnerMathField
          );
        });
        this.__controller.updateMathspeak();
      }
      return returned;
    };
    StaticMath.prototype.setAriaLabel = function(ariaLabel) {
      this.__controller.setAriaLabel(ariaLabel);
      return this;
    };
    StaticMath.prototype.getAriaLabel = function() {
      return this.__controller.getAriaLabel();
    };
    return StaticMath;
  })(APIClasses.AbstractMathQuill), _c.RootBlock = MathBlock, _c;
};
var RootMathBlock = (
  /** @class */
  (function(_super) {
    __extends(RootMathBlock2, _super);
    function RootMathBlock2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    return RootMathBlock2;
  })(MathBlock)
);
RootBlockMixin(RootMathBlock.prototype);
API.MathField = function(APIClasses) {
  var _c;
  return _c = /** @class */
  (function(_super) {
    __extends(MathField, _super);
    function MathField() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    MathField.prototype.__mathquillify = function(opts, interfaceVersion) {
      this.config(opts);
      if (interfaceVersion > 1) this.__controller.root.reflow = noop;
      _super.prototype.mathquillify.call(
        this,
        "mq-editable-field mq-math-mode"
      );
      delete this.__controller.root.reflow;
      return this;
    };
    return MathField;
  })(APIClasses.EditableField), _c.RootBlock = RootMathBlock, _c;
};
API.InnerMathField = function(APIClasses) {
  pray("MathField class is defined", APIClasses.MathField);
  return (
    /** @class */
    (function(_super) {
      __extends(class_1, _super);
      function class_1() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      class_1.prototype.makeStatic = function() {
        this.__controller.editable = false;
        this.__controller.root.blur();
        this.__controller.unbindEditablesEvents();
        domFrag(this.__controller.container).removeClass(
          "mq-editable-field"
        );
      };
      class_1.prototype.makeEditable = function() {
        this.__controller.editable = true;
        this.__controller.editablesTextareaEvents();
        this.__controller.cursor.insAtRightEnd(this.__controller.root);
        domFrag(this.__controller.container).addClass("mq-editable-field");
      };
      return class_1;
    })(APIClasses.MathField)
  );
};
var TextBlock = (
  /** @class */
  (function(_super) {
    __extends(TextBlock2, _super);
    function TextBlock2() {
      var _this_1 = _super !== null && _super.apply(this, arguments) || this;
      _this_1.ctrlSeq = "\\text";
      _this_1.ariaLabel = "Text";
      _this_1.mathspeakTemplate = ["StartText", "EndText"];
      return _this_1;
    }
    TextBlock2.prototype.replaces = function(replacedText) {
      if (replacedText instanceof Fragment) {
        this.replacedText = replacedText.remove().domFrag().text();
      } else if (typeof replacedText === "string")
        this.replacedText = replacedText;
    };
    TextBlock2.prototype.setDOMFrag = function(el) {
      _super.prototype.setDOM.call(this, el);
      var endsL = this.getEnd(L);
      if (endsL) {
        var children = this.domFrag().children();
        if (!children.isEmpty()) {
          endsL.setDOM(children.oneText());
        }
      }
      return this;
    };
    TextBlock2.prototype.createLeftOf = function(cursor) {
      var textBlock = this;
      _super.prototype.createLeftOf.call(this, cursor);
      cursor.insAtRightEnd(textBlock);
      if (textBlock.replacedText)
        for (var i = 0; i < textBlock.replacedText.length; i += 1)
          textBlock.write(cursor, textBlock.replacedText.charAt(i));
      var textBlockR = textBlock[R];
      if (textBlockR) textBlockR.siblingCreated(cursor.options, L);
      var textBlockL = textBlock[L];
      if (textBlockL) textBlockL.siblingCreated(cursor.options, R);
      textBlock.bubble(function(node) {
        node.reflow();
        return void 0;
      });
    };
    TextBlock2.prototype.parser = function() {
      var textBlock = this;
      var string = Parser.string;
      var regex = Parser.regex;
      var optWhitespace = Parser.optWhitespace;
      return optWhitespace.then(string("{")).then(regex(/^[^}]*/)).skip(string("}")).map(function(text) {
        if (text.length === 0) return new Fragment(0, 0);
        new TextPiece(text).adopt(textBlock, 0, 0);
        return textBlock;
      });
    };
    TextBlock2.prototype.textContents = function() {
      return this.foldChildren("", function(text, child) {
        return text + child.textStr;
      });
    };
    TextBlock2.prototype.text = function() {
      return '"' + this.textContents() + '"';
    };
    TextBlock2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      var contents = this.textContents();
      if (contents.length > 0) {
        ctx.uncleanedLatex += this.ctrlSeq + "{";
        ctx.uncleanedLatex += contents.replace(/\\/g, "\\backslash ").replace(/[{}]/g, "\\$&");
        ctx.uncleanedLatex += "}";
      }
      this.checkCursorContextClose(ctx);
    };
    TextBlock2.prototype.html = function() {
      var out = h("span", { class: "mq-text-mode" }, [
        h.text(this.textContents())
      ]);
      this.setDOM(out);
      NodeBase.linkElementByCmdNode(out, this);
      return out;
    };
    TextBlock2.prototype.mathspeak = function(opts) {
      if (opts && opts.ignoreShorthand) {
        return this.mathspeakTemplate[0] + ", " + this.textContents() + ", " + this.mathspeakTemplate[1];
      } else {
        return this.textContents();
      }
    };
    TextBlock2.prototype.isTextBlock = function() {
      return true;
    };
    TextBlock2.prototype.moveTowards = function(dir, cursor) {
      cursor.insAtDirEnd(-dir, this);
      cursor.controller.aria.queueDirEndOf(-dir).queue(cursor.parent, true);
    };
    TextBlock2.prototype.moveOutOf = function(dir, cursor) {
      cursor.insDirOf(dir, this);
      cursor.controller.aria.queueDirOf(dir).queue(this);
    };
    TextBlock2.prototype.unselectInto = function(dir, cursor) {
      this.moveTowards(dir, cursor);
    };
    TextBlock2.prototype.selectTowards = function(dir, cursor) {
      MathCommand.prototype.selectTowards.call(this, dir, cursor);
    };
    TextBlock2.prototype.deleteTowards = function(dir, cursor) {
      MathCommand.prototype.deleteTowards.call(this, dir, cursor);
    };
    TextBlock2.prototype.selectOutOf = function(dir, cursor) {
      cursor.insDirOf(dir, this);
    };
    TextBlock2.prototype.deleteOutOf = function(_dir, cursor) {
      if (this.isEmpty()) cursor.insRightOf(this);
    };
    TextBlock2.prototype.write = function(cursor, ch) {
      cursor.show().deleteSelection();
      if (ch !== "$") {
        var cursorL = cursor[L];
        if (!cursorL) new TextPiece(ch).createLeftOf(cursor);
        else if (cursorL instanceof TextPiece) cursorL.appendText(ch);
      } else if (this.isEmpty()) {
        cursor.insRightOf(this);
        new VanillaSymbol("\\$", h.text("$")).createLeftOf(cursor);
      } else if (!cursor[R]) cursor.insRightOf(this);
      else if (!cursor[L]) cursor.insLeftOf(this);
      else {
        var leftBlock = new TextBlock2();
        var leftPc = this.getEnd(L);
        if (leftPc) {
          leftPc.disown().domFrag().detach();
          leftPc.adopt(leftBlock, 0, 0);
        }
        cursor.insLeftOf(this);
        _super.prototype.createLeftOf.call(leftBlock, cursor);
      }
      this.bubble(function(node) {
        node.reflow();
        return void 0;
      });
      cursor.controller.aria.alert(ch);
    };
    TextBlock2.prototype.writeLatex = function(cursor, latex) {
      var cursorL = cursor[L];
      if (!cursorL) new TextPiece(latex).createLeftOf(cursor);
      else if (cursorL instanceof TextPiece) cursorL.appendText(latex);
      this.bubble(function(node) {
        node.reflow();
        return void 0;
      });
    };
    TextBlock2.prototype.seek = function(clientX, cursor) {
      cursor.hide();
      var textPc = TextBlockFuseChildren(this);
      if (!textPc) return;
      var textNode = this.domFrag().children().oneText();
      var range = document.createRange();
      range.selectNodeContents(textNode);
      var rects = range.getClientRects();
      if (rects.length === 1) {
        var _c = rects[0], width = _c.width, left = _c.left;
        var avgChWidth = width / this.textContents().length;
        var approxPosition = Math.round((clientX - left) / avgChWidth);
        if (approxPosition <= 0) {
          cursor.insAtLeftEnd(this);
        } else if (approxPosition >= textPc.textStr.length) {
          cursor.insAtRightEnd(this);
        } else {
          cursor.insLeftOf(textPc.splitRight(approxPosition));
        }
      } else {
        cursor.insAtLeftEnd(this);
      }
      var displ = clientX - cursor.show().getBoundingClientRectWithoutMargin().left;
      var dir = displ && displ < 0 ? L : R;
      var prevDispl = dir;
      while (cursor[dir] && displ * prevDispl > 0) {
        cursor[dir].moveTowards(dir, cursor);
        prevDispl = displ;
        displ = clientX - cursor.getBoundingClientRectWithoutMargin().left;
      }
      if (dir * displ < -dir * prevDispl)
        cursor[-dir].moveTowards(-dir, cursor);
      if (!cursor.anticursor) {
        var cursorL = cursor[L];
        this.anticursorPosition = cursorL && cursorL.textStr.length;
      } else if (cursor.anticursor.parent === this) {
        var cursorL = cursor[L];
        var cursorPosition = cursorL && cursorL.textStr.length;
        if (this.anticursorPosition === cursorPosition) {
          cursor.anticursor = Anticursor.fromCursor(cursor);
        } else {
          if (this.anticursorPosition < cursorPosition) {
            var newTextPc = cursorL.splitRight(this.anticursorPosition);
            cursor[L] = newTextPc;
          } else {
            var cursorR = cursor[R];
            var newTextPc = cursorR.splitRight(
              this.anticursorPosition - cursorPosition
            );
          }
          cursor.anticursor = new Anticursor(
            this,
            newTextPc[L],
            newTextPc
          );
        }
      }
    };
    TextBlock2.prototype.blur = function(cursor) {
      MathBlock.prototype.blur.call(this, cursor);
      if (!cursor) return;
      if (this.textContents() === "") {
        this.remove();
        if (cursor[L] === this) cursor[L] = this[L];
        else if (cursor[R] === this) cursor[R] = this[R];
      } else TextBlockFuseChildren(this);
    };
    TextBlock2.prototype.focus = function() {
      MathBlock.prototype.focus.call(this);
    };
    return TextBlock2;
  })(MQNode)
);
function TextBlockFuseChildren(self) {
  self.domFrag().oneElement().normalize();
  var children = self.domFrag().children();
  if (children.isEmpty()) return;
  var textPcDom = children.oneText();
  pray("only node in TextBlock span is Text node", textPcDom.nodeType === 3);
  var textPc = new TextPiece(textPcDom.data);
  textPc.setDOM(textPcDom);
  self.children().disown();
  textPc.adopt(self, 0, 0);
  return textPc;
}
var TextPiece = (
  /** @class */
  (function(_super) {
    __extends(TextPiece2, _super);
    function TextPiece2(text) {
      var _this_1 = _super.call(this) || this;
      _this_1.textStr = text;
      return _this_1;
    }
    TextPiece2.prototype.html = function() {
      var out = h.text(this.textStr);
      this.setDOM(out);
      return out;
    };
    TextPiece2.prototype.appendText = function(text) {
      this.textStr += text;
      this.domFrag().oneText().appendData(text);
    };
    TextPiece2.prototype.prependText = function(text) {
      this.textStr = text + this.textStr;
      this.domFrag().oneText().insertData(0, text);
    };
    TextPiece2.prototype.insTextAtDirEnd = function(text, dir) {
      prayDirection(dir);
      if (dir === R) this.appendText(text);
      else this.prependText(text);
    };
    TextPiece2.prototype.splitRight = function(i) {
      var newPc = new TextPiece2(this.textStr.slice(i)).adopt(
        this.parent,
        this,
        this[R]
      );
      newPc.setDOM(this.domFrag().oneText().splitText(i));
      this.textStr = this.textStr.slice(0, i);
      return newPc;
    };
    TextPiece2.prototype.endChar = function(dir, text) {
      return text.charAt(dir === L ? 0 : -1 + text.length);
    };
    TextPiece2.prototype.moveTowards = function(dir, cursor) {
      prayDirection(dir);
      var ch = this.endChar(-dir, this.textStr);
      var from = this[-dir];
      if (from instanceof TextPiece2) from.insTextAtDirEnd(ch, dir);
      else new TextPiece2(ch).createDir(-dir, cursor);
      return this.deleteTowards(dir, cursor);
    };
    TextPiece2.prototype.mathspeak = function() {
      return this.textStr;
    };
    TextPiece2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      ctx.uncleanedLatex += this.textStr;
      this.checkCursorContextClose(ctx);
    };
    TextPiece2.prototype.deleteTowards = function(dir, cursor) {
      if (this.textStr.length > 1) {
        var deletedChar;
        if (dir === R) {
          this.domFrag().oneText().deleteData(0, 1);
          deletedChar = this.textStr[0];
          this.textStr = this.textStr.slice(1);
        } else {
          this.domFrag().oneText().deleteData(-1 + this.textStr.length, 1);
          deletedChar = this.textStr[this.textStr.length - 1];
          this.textStr = this.textStr.slice(0, -1);
        }
        cursor.controller.aria.queue(deletedChar);
      } else {
        this.remove();
        cursor[dir] = this[dir];
        cursor.controller.aria.queue(this.textStr);
      }
    };
    TextPiece2.prototype.selectTowards = function(dir, cursor) {
      prayDirection(dir);
      var anticursor = cursor.anticursor;
      if (!anticursor) return;
      var ch = this.endChar(-dir, this.textStr);
      if (anticursor[dir] === this) {
        var newPc = new TextPiece2(ch).createDir(dir, cursor);
        anticursor[dir] = newPc;
        cursor.insDirOf(dir, newPc);
      } else {
        var from = this[-dir];
        if (from instanceof TextPiece2) from.insTextAtDirEnd(ch, dir);
        else {
          var newPc = new TextPiece2(ch).createDir(-dir, cursor);
          var selection = cursor.selection;
          if (selection) {
            newPc.domFrag().insDirOf(-dir, selection.domFrag());
          }
        }
        if (this.textStr.length === 1 && anticursor[-dir] === this) {
          anticursor[-dir] = this[-dir];
        }
      }
      return this.deleteTowards(dir, cursor);
    };
    return TextPiece2;
  })(MQNode)
);
LatexCmds.text = LatexCmds.textnormal = LatexCmds.textrm = LatexCmds.textup = LatexCmds.textmd = TextBlock;
function makeTextBlock(latex, ariaLabel, tagName, attrs) {
  return (
    /** @class */
    (function(_super) {
      __extends(class_2, _super);
      function class_2() {
        var _this_1 = _super !== null && _super.apply(this, arguments) || this;
        _this_1.ctrlSeq = latex;
        _this_1.mathspeakTemplate = [
          "Start" + ariaLabel,
          "End" + ariaLabel
        ];
        _this_1.ariaLabel = ariaLabel;
        return _this_1;
      }
      class_2.prototype.html = function() {
        var out = h(tagName, attrs, [h.text(this.textContents())]);
        this.setDOM(out);
        NodeBase.linkElementByCmdNode(out, this);
        return out;
      };
      return class_2;
    })(TextBlock)
  );
}
LatexCmds.em = LatexCmds.italic = LatexCmds.italics = LatexCmds.emph = LatexCmds.textit = LatexCmds.textsl = makeTextBlock("\\textit", "Italic", "i", { class: "mq-text-mode" });
LatexCmds.strong = LatexCmds.bold = LatexCmds.textbf = makeTextBlock("\\textbf", "Bold", "b", { class: "mq-text-mode" });
LatexCmds.sf = LatexCmds.textsf = makeTextBlock(
  "\\textsf",
  "Sans serif font",
  "span",
  { class: "mq-sans-serif mq-text-mode" }
);
LatexCmds.tt = LatexCmds.texttt = makeTextBlock(
  "\\texttt",
  "Mono space font",
  "span",
  { class: "mq-monospace mq-text-mode" }
);
LatexCmds.textsc = makeTextBlock("\\textsc", "Variable font", "span", {
  style: "font-variant:small-caps",
  class: "mq-text-mode"
});
LatexCmds.uppercase = makeTextBlock("\\uppercase", "Uppercase", "span", {
  style: "text-transform:uppercase",
  class: "mq-text-mode"
});
LatexCmds.lowercase = makeTextBlock("\\lowercase", "Lowercase", "span", {
  style: "text-transform:lowercase",
  class: "mq-text-mode"
});
var RootMathCommand = (
  /** @class */
  (function(_super) {
    __extends(RootMathCommand2, _super);
    function RootMathCommand2(cursor) {
      var _this_1 = _super.call(this, "$") || this;
      _this_1.domView = new DOMView(1, function(blocks) {
        return h.block("span", { class: "mq-math-mode" }, blocks[0]);
      });
      _this_1.cursor = cursor;
      return _this_1;
    }
    RootMathCommand2.prototype.createBlocks = function() {
      _super.prototype.createBlocks.call(this);
      var endsL = this.getEnd(L);
      endsL.cursor = this.cursor;
      endsL.write = function(cursor, ch) {
        if (ch !== "$") MathBlock.prototype.write.call(this, cursor, ch);
        else if (this.isEmpty()) {
          cursor.insRightOf(this.parent);
          this.parent.deleteTowards(void 0, cursor);
          new VanillaSymbol("\\$", h.text("$")).createLeftOf(
            cursor.show()
          );
        } else if (!cursor[R]) cursor.insRightOf(this.parent);
        else if (!cursor[L]) cursor.insLeftOf(this.parent);
        else MathBlock.prototype.write.call(this, cursor, ch);
      };
    };
    RootMathCommand2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      ctx.uncleanedLatex += "$";
      this.getEnd(L).latexRecursive(ctx);
      ctx.uncleanedLatex += "$";
      this.checkCursorContextClose(ctx);
    };
    return RootMathCommand2;
  })(MathCommand)
);
var RootTextBlock = (
  /** @class */
  (function(_super) {
    __extends(RootTextBlock2, _super);
    function RootTextBlock2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    RootTextBlock2.prototype.keystroke = function(key, e, ctrlr) {
      if (key === "Spacebar" || key === "Shift-Spacebar") return;
      return _super.prototype.keystroke.call(this, key, e, ctrlr);
    };
    RootTextBlock2.prototype.write = function(cursor, ch) {
      cursor.show().deleteSelection();
      if (ch === "$") new RootMathCommand(cursor).createLeftOf(cursor);
      else {
        var html;
        if (ch === "<") html = h.entityText("&lt;");
        else if (ch === ">") html = h.entityText("&gt;");
        new VanillaSymbol(ch, html).createLeftOf(cursor);
      }
    };
    return RootTextBlock2;
  })(RootMathBlock)
);
API.TextField = function(APIClasses) {
  var _c;
  return _c = /** @class */
  (function(_super) {
    __extends(TextField, _super);
    function TextField() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    TextField.prototype.__mathquillify = function() {
      _super.prototype.mathquillify.call(
        this,
        "mq-editable-field mq-text-mode"
      );
      return this;
    };
    TextField.prototype.latex = function(latex) {
      if (latex) {
        this.__controller.renderLatexText(latex);
        if (this.__controller.blurred)
          this.__controller.cursor.hide().parent.blur();
        var _this = this;
        return _this;
      }
      return this.__controller.exportLatex();
    };
    return TextField;
  })(APIClasses.EditableField), _c.RootBlock = RootTextBlock, _c;
};
function bindSimpleBinop(latex) {
  return bindBinaryOperator("\\" + latex + " ", "&" + latex + ";", latex);
}
LatexCmds["∉"] = LatexCmds.notin = bindSimpleBinop("notin");
LatexCmds["≡"] = LatexCmds.equiv = bindSimpleBinop("equiv");
LatexCmds["⊕"] = LatexCmds.oplus = bindSimpleBinop("oplus");
LatexCmds["⊗"] = LatexCmds.otimes = bindSimpleBinop("otimes");
LatexCmds["∗"] = LatexCmds.ast = LatexCmds.star = LatexCmds.loast = LatexCmds.lowast = bindBinaryOperator("\\ast ", "&lowast;", "low asterisk");
LatexCmds["∴"] = LatexCmds.therefor = LatexCmds.therefore = bindBinaryOperator("\\therefore ", "&there4;", "therefore");
LatexCmds["∵"] = LatexCmds.cuz = LatexCmds.because = bindBinaryOperator(
  // l33t
  "\\because ",
  "&#8757;",
  "because"
);
LatexCmds["∝"] = LatexCmds.prop = LatexCmds.propto = bindBinaryOperator("\\propto ", "&prop;", "proportional to");
LatexCmds["≈"] = LatexCmds.asymp = LatexCmds.approx = bindBinaryOperator("\\approx ", "&asymp;", "approximately equal to");
LatexCmds["∈"] = LatexCmds.isin = LatexCmds["in"] = bindBinaryOperator("\\in ", "&isin;", "is in");
LatexCmds["∋"] = LatexCmds.ni = LatexCmds.contains = bindBinaryOperator("\\ni ", "&ni;", "contains");
LatexCmds["∌"] = LatexCmds.notni = LatexCmds.niton = LatexCmds.notcontains = LatexCmds.doesnotcontain = bindBinaryOperator("\\not\\ni ", "&#8716;", "does not contain");
LatexCmds["⊂"] = LatexCmds.sub = LatexCmds.subset = bindBinaryOperator("\\subset ", "&sub;", "subset");
LatexCmds["⊃"] = LatexCmds.sup = LatexCmds.supset = LatexCmds.superset = bindBinaryOperator("\\supset ", "&sup;", "superset");
LatexCmds["⊄"] = LatexCmds.nsub = LatexCmds.notsub = LatexCmds.nsubset = LatexCmds.notsubset = bindBinaryOperator("\\not\\subset ", "&#8836;", "not a subset");
LatexCmds["⊅"] = LatexCmds.nsup = LatexCmds.notsup = LatexCmds.nsupset = LatexCmds.notsupset = LatexCmds.nsuperset = LatexCmds.notsuperset = bindBinaryOperator("\\not\\supset ", "&#8837;", "not a superset");
LatexCmds["⊆"] = LatexCmds.sube = LatexCmds.subeq = LatexCmds.subsete = LatexCmds.subseteq = bindBinaryOperator("\\subseteq ", "&sube;", "subset or equal to");
LatexCmds["⊇"] = LatexCmds.supe = LatexCmds.supeq = LatexCmds.supsete = LatexCmds.supseteq = LatexCmds.supersete = LatexCmds.superseteq = bindBinaryOperator("\\supseteq ", "&supe;", "superset or equal to");
LatexCmds["⊊"] = LatexCmds.nsube = LatexCmds.nsubeq = LatexCmds.notsube = LatexCmds.notsubeq = LatexCmds.nsubsete = LatexCmds.nsubseteq = LatexCmds.notsubsete = LatexCmds.notsubseteq = bindBinaryOperator(
  "\\not\\subseteq ",
  "&#8840;",
  "not subset or equal to"
);
LatexCmds["⊋"] = LatexCmds.nsupe = LatexCmds.nsupeq = LatexCmds.notsupe = LatexCmds.notsupeq = LatexCmds.nsupsete = LatexCmds.nsupseteq = LatexCmds.notsupsete = LatexCmds.notsupseteq = LatexCmds.nsupersete = LatexCmds.nsuperseteq = LatexCmds.notsupersete = LatexCmds.notsuperseteq = bindBinaryOperator(
  "\\not\\supseteq ",
  "&#8841;",
  "not superset or equal to"
);
LatexCmds.mathbb = /** @class */
(function(_super) {
  __extends(class_3, _super);
  function class_3() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  class_3.prototype.createLeftOf = function(_cursor) {
  };
  class_3.prototype.numBlocks = function() {
    return 1;
  };
  class_3.prototype.parser = function() {
    var string = Parser.string;
    var regex = Parser.regex;
    var optWhitespace = Parser.optWhitespace;
    return optWhitespace.then(string("{")).then(optWhitespace).then(regex(/^[NPZQRCH]/)).skip(optWhitespace).skip(string("}")).map(function(c) {
      var cmd = LatexCmds[c];
      if (isMQNodeClass(cmd)) {
        return new cmd();
      } else {
        return cmd();
      }
    });
  };
  return class_3;
})(MathCommand);
LatexCmds["ℕ"] = LatexCmds.N = LatexCmds.naturals = LatexCmds.Naturals = bindVanillaSymbol("\\mathbb{N}", "&#8469;", "naturals");
LatexCmds["ℙ"] = LatexCmds.P = LatexCmds.primes = LatexCmds.Primes = LatexCmds.projective = LatexCmds.Projective = LatexCmds.probability = LatexCmds.Probability = bindVanillaSymbol("\\mathbb{P}", "&#8473;", "P");
LatexCmds["ℤ"] = LatexCmds.Z = LatexCmds.integers = LatexCmds.Integers = bindVanillaSymbol("\\mathbb{Z}", "&#8484;", "integers");
LatexCmds["ℚ"] = LatexCmds.Q = LatexCmds.rationals = LatexCmds.Rationals = bindVanillaSymbol("\\mathbb{Q}", "&#8474;", "rationals");
LatexCmds["ℝ"] = LatexCmds.R = LatexCmds.reals = LatexCmds.Reals = bindVanillaSymbol("\\mathbb{R}", "&#8477;", "reals");
LatexCmds["ℂ"] = LatexCmds.C = LatexCmds.complex = LatexCmds.Complex = LatexCmds.complexes = LatexCmds.Complexes = LatexCmds.complexplane = LatexCmds.Complexplane = LatexCmds.ComplexPlane = bindVanillaSymbol("\\mathbb{C}", "&#8450;", "complexes");
LatexCmds["ℍ"] = LatexCmds.H = LatexCmds.Hamiltonian = LatexCmds.quaternions = LatexCmds.Quaternions = bindVanillaSymbol("\\mathbb{H}", "&#8461;", "quaternions");
LatexCmds.quad = LatexCmds.emsp = bindVanillaSymbol(
  "\\quad ",
  "    ",
  "4 spaces"
);
LatexCmds.qquad = bindVanillaSymbol("\\qquad ", "        ", "8 spaces");
LatexCmds["◇"] = LatexCmds.diamond = bindVanillaSymbol(
  "\\diamond ",
  "&#9671;",
  "diamond"
);
LatexCmds.bigtriangleup = bindVanillaSymbol(
  "\\bigtriangleup ",
  "&#9651;",
  "triangle up"
);
LatexCmds["⊖"] = LatexCmds.ominus = bindVanillaSymbol(
  "\\ominus ",
  "&#8854;",
  "o minus"
);
LatexCmds["⊎"] = LatexCmds.uplus = bindVanillaSymbol(
  "\\uplus ",
  "&#8846;",
  "disjoint union"
);
LatexCmds.bigtriangledown = bindVanillaSymbol(
  "\\bigtriangledown ",
  "&#9661;",
  "triangle down"
);
LatexCmds["⊓"] = LatexCmds.sqcap = bindVanillaSymbol(
  "\\sqcap ",
  "&#8851;",
  "greatest lower bound"
);
LatexCmds["⊲"] = LatexCmds.triangleleft = bindVanillaSymbol(
  "\\triangleleft ",
  "&#8882;",
  "triangle left"
);
LatexCmds["⊔"] = LatexCmds.sqcup = bindVanillaSymbol(
  "\\sqcup ",
  "&#8852;",
  "least upper bound"
);
LatexCmds["⊳"] = LatexCmds.triangleright = bindVanillaSymbol(
  "\\triangleright ",
  "&#8883;",
  "triangle right"
);
LatexCmds["⊙"] = LatexCmds.odot = LatexCmds.circledot = bindVanillaSymbol("\\odot ", "&#8857;", "circle dot");
LatexCmds["†"] = LatexCmds.dagger = bindVanillaSymbol(
  "\\dagger ",
  "&#0134;",
  "dagger"
);
LatexCmds["‡"] = LatexCmds.ddagger = bindVanillaSymbol(
  "\\ddagger ",
  "&#135;",
  "big dagger"
);
LatexCmds["≀"] = LatexCmds.wr = bindVanillaSymbol(
  "\\wr ",
  "&#8768;",
  "wreath"
);
LatexCmds["∐"] = LatexCmds.amalg = bindVanillaSymbol(
  "\\amalg ",
  "&#8720;",
  "amalgam"
);
LatexCmds["⊨"] = LatexCmds.models = bindVanillaSymbol(
  "\\models ",
  "&#8872;",
  "models"
);
LatexCmds["≺"] = LatexCmds.prec = bindVanillaSymbol(
  "\\prec ",
  "&#8826;",
  "precedes"
);
LatexCmds["≻"] = LatexCmds.succ = bindVanillaSymbol(
  "\\succ ",
  "&#8827;",
  "succeeds"
);
LatexCmds["≼"] = LatexCmds.preceq = bindVanillaSymbol(
  "\\preceq ",
  "&#8828;",
  "precedes or equals"
);
LatexCmds["≽"] = LatexCmds.succeq = bindVanillaSymbol(
  "\\succeq ",
  "&#8829;",
  "succeeds or equals"
);
LatexCmds["≃"] = LatexCmds.simeq = bindVanillaSymbol(
  "\\simeq ",
  "&#8771;",
  "similar or equal to"
);
LatexCmds["∣"] = LatexCmds.mid = bindVanillaSymbol(
  "\\mid ",
  "&#8739;",
  "divides"
);
LatexCmds["≪"] = LatexCmds.ll = bindVanillaSymbol(
  "\\ll ",
  "&#8810;",
  "ll"
);
LatexCmds["≫"] = LatexCmds.gg = bindVanillaSymbol(
  "\\gg ",
  "&#8811;",
  "gg"
);
LatexCmds.parallel = bindVanillaSymbol(
  "\\parallel ",
  "&#8741;",
  "parallel with"
);
LatexCmds.nparallel = bindVanillaSymbol(
  "\\nparallel ",
  "&#8742;",
  "not parallel with"
);
LatexCmds["⋈"] = LatexCmds.bowtie = bindVanillaSymbol(
  "\\bowtie ",
  "&#8904;",
  "bowtie"
);
LatexCmds["⊏"] = LatexCmds.sqsubset = bindVanillaSymbol(
  "\\sqsubset ",
  "&#8847;",
  "square subset"
);
LatexCmds["⊐"] = LatexCmds.sqsupset = bindVanillaSymbol(
  "\\sqsupset ",
  "&#8848;",
  "square superset"
);
LatexCmds["⌣"] = LatexCmds.smile = bindVanillaSymbol(
  "\\smile ",
  "&#8995;",
  "smile"
);
LatexCmds["⊑"] = LatexCmds.sqsubseteq = bindVanillaSymbol(
  "\\sqsubseteq ",
  "&#8849;",
  "square subset or equal to"
);
LatexCmds["⊒"] = LatexCmds.sqsupseteq = bindVanillaSymbol(
  "\\sqsupseteq ",
  "&#8850;",
  "square superset or equal to"
);
LatexCmds["≐"] = LatexCmds.doteq = bindVanillaSymbol(
  "\\doteq ",
  "&#8784;",
  "dotted equals"
);
LatexCmds["⌢"] = LatexCmds.frown = bindVanillaSymbol(
  "\\frown ",
  "&#8994;",
  "frown"
);
LatexCmds["⊦"] = LatexCmds.vdash = bindVanillaSymbol(
  "\\vdash ",
  "&#8870;",
  "v dash"
);
LatexCmds["⊣"] = LatexCmds.dashv = bindVanillaSymbol(
  "\\dashv ",
  "&#8867;",
  "dash v"
);
LatexCmds["≮"] = LatexCmds.nless = bindVanillaSymbol(
  "\\nless ",
  "&#8814;",
  "not less than"
);
LatexCmds["≯"] = LatexCmds.ngtr = bindVanillaSymbol(
  "\\ngtr ",
  "&#8815;",
  "not greater than"
);
LatexCmds.longleftarrow = bindVanillaSymbol(
  "\\longleftarrow ",
  "&#8592;",
  "left arrow"
);
LatexCmds.longrightarrow = bindVanillaSymbol(
  "\\longrightarrow ",
  "&#8594;",
  "right arrow"
);
LatexCmds.Longleftarrow = bindVanillaSymbol(
  "\\Longleftarrow ",
  "&#8656;",
  "left arrow"
);
LatexCmds.Longrightarrow = bindVanillaSymbol(
  "\\Longrightarrow ",
  "&#8658;",
  "right arrow"
);
LatexCmds.longleftrightarrow = bindVanillaSymbol(
  "\\longleftrightarrow ",
  "&#8596;",
  "left and right arrow"
);
LatexCmds["↕"] = LatexCmds.updownarrow = bindVanillaSymbol(
  "\\updownarrow ",
  "&#8597;",
  "up and down arrow"
);
LatexCmds.Longleftrightarrow = bindVanillaSymbol(
  "\\Longleftrightarrow ",
  "&#8660;",
  "left and right arrow"
);
LatexCmds["⇕"] = LatexCmds.Updownarrow = bindVanillaSymbol(
  "\\Updownarrow ",
  "&#8661;",
  "up and down arrow"
);
LatexCmds["↦"] = LatexCmds.mapsto = bindVanillaSymbol(
  "\\mapsto ",
  "&#8614;",
  "maps to"
);
LatexCmds["↗"] = LatexCmds.nearrow = bindVanillaSymbol(
  "\\nearrow ",
  "&#8599;",
  "northeast arrow"
);
LatexCmds["↩"] = LatexCmds.hookleftarrow = bindVanillaSymbol(
  "\\hookleftarrow ",
  "&#8617;",
  "hook left arrow"
);
LatexCmds["↪"] = LatexCmds.hookrightarrow = bindVanillaSymbol(
  "\\hookrightarrow ",
  "&#8618;",
  "hook right arrow"
);
LatexCmds["↘"] = LatexCmds.searrow = bindVanillaSymbol(
  "\\searrow ",
  "&#8600;",
  "southeast arrow"
);
LatexCmds["↼"] = LatexCmds.leftharpoonup = bindVanillaSymbol(
  "\\leftharpoonup ",
  "&#8636;",
  "left harpoon up"
);
LatexCmds["⇀"] = LatexCmds.rightharpoonup = bindVanillaSymbol(
  "\\rightharpoonup ",
  "&#8640;",
  "right harpoon up"
);
LatexCmds["↙"] = LatexCmds.swarrow = bindVanillaSymbol(
  "\\swarrow ",
  "&#8601;",
  "southwest arrow"
);
LatexCmds["↽"] = LatexCmds.leftharpoondown = bindVanillaSymbol(
  "\\leftharpoondown ",
  "&#8637;",
  "left harpoon down"
);
LatexCmds["⇁"] = LatexCmds.rightharpoondown = bindVanillaSymbol(
  "\\rightharpoondown ",
  "&#8641;",
  "right harpoon down"
);
LatexCmds["↖"] = LatexCmds.nwarrow = bindVanillaSymbol(
  "\\nwarrow ",
  "&#8598;",
  "northwest arrow"
);
LatexCmds.ldots = bindVanillaSymbol("\\ldots ", "&#8230;", "l dots");
LatexCmds["⋯"] = LatexCmds.cdots = bindVanillaSymbol(
  "\\cdots ",
  "&#8943;",
  "c dots"
);
LatexCmds["⋮"] = LatexCmds.vdots = bindVanillaSymbol(
  "\\vdots ",
  "&#8942;",
  "v dots"
);
LatexCmds["⋱"] = LatexCmds.ddots = bindVanillaSymbol(
  "\\ddots ",
  "&#8945;",
  "d dots"
);
LatexCmds.surd = bindVanillaSymbol("\\surd ", "&#8730;", "unresolved root");
LatexCmds["ℓ"] = LatexCmds.ell = bindVanillaSymbol(
  "\\ell ",
  "&#8467;",
  "ell"
);
LatexCmds["⊤"] = LatexCmds.top = bindVanillaSymbol(
  "\\top ",
  "&#8868;",
  "top"
);
LatexCmds["♭"] = LatexCmds.flat = bindVanillaSymbol(
  "\\flat ",
  "&#9837;",
  "flat"
);
LatexCmds["♮"] = LatexCmds.natural = bindVanillaSymbol(
  "\\natural ",
  "&#9838;",
  "natural"
);
LatexCmds["♯"] = LatexCmds.sharp = bindVanillaSymbol(
  "\\sharp ",
  "&#9839;",
  "sharp"
);
LatexCmds["℘"] = LatexCmds.wp = bindVanillaSymbol(
  "\\wp ",
  "&#8472;",
  "wp"
);
LatexCmds["⊥"] = LatexCmds.bot = bindVanillaSymbol(
  "\\bot ",
  "&#8869;",
  "bot"
);
LatexCmds["♣"] = LatexCmds.clubsuit = bindVanillaSymbol(
  "\\clubsuit ",
  "&#9827;",
  "club suit"
);
LatexCmds["♢"] = LatexCmds.diamondsuit = bindVanillaSymbol(
  "\\diamondsuit ",
  "&#9826;",
  "diamond suit"
);
LatexCmds["♡"] = LatexCmds.heartsuit = bindVanillaSymbol(
  "\\heartsuit ",
  "&#9825;",
  "heart suit"
);
LatexCmds["♠"] = LatexCmds.spadesuit = bindVanillaSymbol(
  "\\spadesuit ",
  "&#9824;",
  "spade suit"
);
LatexCmds["⬜"] = LatexCmds.square = bindVanillaSymbol(
  "\\square ",
  "&#11036;",
  "square"
);
LatexCmds["∮"] = LatexCmds.oint = bindVanillaSymbol(
  "\\oint ",
  "&#8750;",
  "o int"
);
LatexCmds.bigcap = bindVanillaSymbol("\\bigcap ", "&#8745;", "big cap");
LatexCmds.bigcup = bindVanillaSymbol("\\bigcup ", "&#8746;", "big cup");
LatexCmds.bigsqcup = bindVanillaSymbol(
  "\\bigsqcup ",
  "&#8852;",
  "big square cup"
);
LatexCmds.bigvee = bindVanillaSymbol("\\bigvee ", "&#8744;", "big vee");
LatexCmds.bigwedge = bindVanillaSymbol("\\bigwedge ", "&#8743;", "big wedge");
LatexCmds.bigodot = bindVanillaSymbol("\\bigodot ", "&#8857;", "big o dot");
LatexCmds.bigotimes = bindVanillaSymbol(
  "\\bigotimes ",
  "&#8855;",
  "big o times"
);
LatexCmds.bigoplus = bindVanillaSymbol("\\bigoplus ", "&#8853;", "big o plus");
LatexCmds.biguplus = bindVanillaSymbol("\\biguplus ", "&#8846;", "big u plus");
LatexCmds["⌊"] = LatexCmds.lfloor = bindVanillaSymbol(
  "\\lfloor ",
  "&#8970;",
  "left floor"
);
LatexCmds["⌋"] = LatexCmds.rfloor = bindVanillaSymbol(
  "\\rfloor ",
  "&#8971;",
  "right floor"
);
LatexCmds["⌈"] = LatexCmds.lceil = bindVanillaSymbol(
  "\\lceil ",
  "&#8968;",
  "left ceiling"
);
LatexCmds["⌉"] = LatexCmds.rceil = bindVanillaSymbol(
  "\\rceil ",
  "&#8969;",
  "right ceiling"
);
LatexCmds.opencurlybrace = LatexCmds.lbrace = bindVanillaSymbol(
  "\\lbrace ",
  "{",
  "left brace"
);
LatexCmds.closecurlybrace = LatexCmds.rbrace = bindVanillaSymbol(
  "\\rbrace ",
  "}",
  "right brace"
);
LatexCmds.lbrack = bindVanillaSymbol("[", "left bracket");
LatexCmds.rbrack = bindVanillaSymbol("]", "right bracket");
LatexCmds.slash = bindVanillaSymbol("/", "slash");
LatexCmds.vert = bindVanillaSymbol("|", "vertical bar");
LatexCmds.perp = LatexCmds.perpendicular = bindVanillaSymbol(
  "\\perp ",
  "&perp;",
  "perpendicular"
);
LatexCmds["∇"] = LatexCmds.nabla = LatexCmds.del = bindVanillaSymbol("\\nabla ", "&nabla;");
LatexCmds["ℏ"] = LatexCmds.hbar = bindVanillaSymbol(
  "\\hbar ",
  "&#8463;",
  "horizontal bar"
);
LatexCmds["Å"] = LatexCmds.AA = LatexCmds.Angstrom = LatexCmds.angstrom = bindVanillaSymbol("\\text\\AA ", "&#8491;", "AA");
LatexCmds["∘"] = LatexCmds.ring = LatexCmds.circ = LatexCmds.circle = bindVanillaSymbol("\\circ ", "&#8728;", "circle");
LatexCmds["•"] = LatexCmds.bull = LatexCmds.bullet = bindVanillaSymbol("\\bullet ", "&bull;", "bullet");
LatexCmds["∖"] = LatexCmds.setminus = LatexCmds.smallsetminus = bindVanillaSymbol("\\setminus ", "&#8726;", "set minus");
LatexCmds.not = //bind(MQSymbol,'\\not ','<span class="not">/</span>', 'not');
LatexCmds["¬"] = LatexCmds.neg = bindVanillaSymbol("\\neg ", "&not;", "not");
LatexCmds["…"] = LatexCmds.dots = LatexCmds.ellip = LatexCmds.hellip = LatexCmds.ellipsis = LatexCmds.hellipsis = bindVanillaSymbol("\\dots ", "&hellip;", "ellipsis");
LatexCmds["↓"] = LatexCmds.converges = LatexCmds.darr = LatexCmds.dnarr = LatexCmds.dnarrow = LatexCmds.downarrow = bindVanillaSymbol("\\downarrow ", "&darr;", "converges with");
LatexCmds["⇓"] = LatexCmds.dArr = LatexCmds.dnArr = LatexCmds.dnArrow = LatexCmds.Downarrow = bindVanillaSymbol("\\Downarrow ", "&dArr;", "down arrow");
LatexCmds["↑"] = LatexCmds.diverges = LatexCmds.uarr = LatexCmds.uparrow = bindVanillaSymbol("\\uparrow ", "&uarr;", "diverges from");
LatexCmds["⇑"] = LatexCmds.uArr = LatexCmds.Uparrow = bindVanillaSymbol("\\Uparrow ", "&uArr;", "up arrow");
LatexCmds.rarr = LatexCmds.rightarrow = bindVanillaSymbol(
  "\\rightarrow ",
  "&rarr;",
  "right arrow"
);
LatexCmds.implies = bindBinaryOperator("\\Rightarrow ", "&rArr;", "implies");
LatexCmds["⇒"] = LatexCmds.rArr = LatexCmds.Rightarrow = bindVanillaSymbol("\\Rightarrow ", "&rArr;", "right arrow");
LatexCmds.gets = bindBinaryOperator("\\gets ", "&larr;", "gets");
LatexCmds["←"] = LatexCmds.larr = LatexCmds.leftarrow = bindVanillaSymbol("\\leftarrow ", "&larr;", "left arrow");
LatexCmds.impliedby = bindBinaryOperator(
  "\\Leftarrow ",
  "&lArr;",
  "implied by"
);
LatexCmds["⇐"] = LatexCmds.lArr = LatexCmds.Leftarrow = bindVanillaSymbol("\\Leftarrow ", "&lArr;", "left arrow");
LatexCmds["↔"] = LatexCmds.harr = LatexCmds.lrarr = LatexCmds.leftrightarrow = bindVanillaSymbol(
  "\\leftrightarrow ",
  "&harr;",
  "left and right arrow"
);
LatexCmds.iff = bindBinaryOperator(
  "\\Leftrightarrow ",
  "&hArr;",
  "if and only if"
);
LatexCmds["⇔"];
LatexCmds.hArr = LatexCmds.lrArr = LatexCmds.Leftrightarrow = bindVanillaSymbol(
  "\\Leftrightarrow ",
  "&hArr;",
  "left and right arrow"
);
LatexCmds.Re = LatexCmds.Real = LatexCmds.real = bindVanillaSymbol("\\Re ", "&real;", "real");
LatexCmds.Im = LatexCmds.imag = LatexCmds.image = LatexCmds.imagin = LatexCmds.imaginary = LatexCmds.Imaginary = bindVanillaSymbol("\\Im ", "&image;", "imaginary");
LatexCmds["∂"] = LatexCmds.part = LatexCmds.partial = bindVanillaSymbol("\\partial ", "&part;", "partial");
LatexCmds["£"] = LatexCmds.pounds = bindVanillaSymbol(
  "\\pounds ",
  "&pound;"
);
LatexCmds["ℵ"] = LatexCmds.alef = LatexCmds.alefsym = LatexCmds.aleph = LatexCmds.alephsym = bindVanillaSymbol("\\aleph ", "&alefsym;", "alef sym");
LatexCmds["∃"] = LatexCmds.xist = //LOL
LatexCmds.xists = LatexCmds.exist = LatexCmds.exists = bindVanillaSymbol("\\exists ", "&exist;", "there exists at least 1");
LatexCmds["∄"] = LatexCmds.nexists = LatexCmds.nexist = bindVanillaSymbol("\\nexists ", "&#8708;", "there is no");
LatexCmds["∧"] = LatexCmds.and = LatexCmds.land = LatexCmds.wedge = bindBinaryOperator("\\wedge ", "&and;", "and");
LatexCmds["∨"] = LatexCmds.or = LatexCmds.lor = LatexCmds.vee = bindBinaryOperator("\\vee ", "&or;", "or");
LatexCmds["∅"] = LatexCmds.o = LatexCmds.O = LatexCmds.empty = LatexCmds.emptyset = LatexCmds.oslash = LatexCmds.Oslash = LatexCmds.nothing = LatexCmds.varnothing = bindBinaryOperator("\\varnothing ", "&empty;", "nothing");
LatexCmds["∪"] = LatexCmds.cup = LatexCmds.union = bindBinaryOperator("\\cup ", "&cup;", "union");
LatexCmds["∩"] = LatexCmds.cap = LatexCmds.intersect = LatexCmds.intersection = bindBinaryOperator("\\cap ", "&cap;", "intersection");
var SPACE = "\\ ";
var DOT = ".";
var DigitGroupingChar = (
  /** @class */
  (function(_super) {
    __extends(DigitGroupingChar2, _super);
    function DigitGroupingChar2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    DigitGroupingChar2.prototype.finalizeTree = function(opts, dir) {
      this.sharedSiblingMethod(opts, dir);
    };
    DigitGroupingChar2.prototype.siblingDeleted = function(opts, dir) {
      this.sharedSiblingMethod(opts, dir);
    };
    DigitGroupingChar2.prototype.siblingCreated = function(opts, dir) {
      this.sharedSiblingMethod(opts, dir);
    };
    DigitGroupingChar2.prototype.sharedSiblingMethod = function(opts, dir) {
      if (dir !== L && this[R] instanceof DigitGroupingChar2) return;
      this.fixDigitGrouping(opts);
    };
    DigitGroupingChar2.prototype.fixDigitGrouping = function(opts) {
      if (!opts.enableDigitGrouping) return;
      var left = this;
      var node = left;
      do {
        if (/^[0-9]$/.test(node.ctrlSeq)) {
          left = node;
        } else if (node.ctrlSeq === SPACE) {
          left = node;
        } else if (node.ctrlSeq === DOT) {
          left = node;
        } else {
          break;
        }
      } while (node = left[L]);
      DigitGroupingChar2.fixDigitGroupingFromLeft(opts, left);
    };
    DigitGroupingChar2.fixDigitGroupingFromLeft = function(opts, left) {
      while (left && left.ctrlSeq === SPACE) {
        if (!left[R]) return;
        left = left[R];
      }
      if (!(left instanceof DigitGroupingChar2)) {
        return;
      }
      var node = left;
      pray("node", node);
      var right = left;
      var spacesFound = 0;
      var dotStreak = 0;
      var dots = [];
      do {
        if (/^[0-9]$/.test(node.ctrlSeq)) {
          right = node;
          dotStreak = 0;
        } else if (node.ctrlSeq === SPACE) {
          right = node;
          spacesFound += 1;
          dotStreak = 0;
        } else if (node.ctrlSeq === DOT && node instanceof DigitGroupingChar2) {
          right = node;
          dots.push(node);
          if (opts.tripleDotsAreEllipsis) {
            dotStreak += 1;
          }
        } else {
          break;
        }
        if (dotStreak == 3) {
          break;
        }
      } while (node = right[R]);
      if (dotStreak === 3) {
        var rightDot = dots.pop();
        var middleDot = dots.pop();
        var leftDot = dots.pop();
        if (rightDot[R] instanceof DigitGroupingChar2) {
          DigitGroupingChar2.fixDigitGroupingFromLeft(opts, rightDot[R]);
        }
        rightDot.setGroupingClass("mq-ellipsis-end");
        middleDot.setGroupingClass("mq-ellipsis-middle");
        leftDot.setGroupingClass("mq-ellipsis-start");
        right = leftDot[L];
        if (left === leftDot) {
          return;
        }
      }
      while (right !== left && right && right.ctrlSeq === SPACE) {
        right = right[L];
        spacesFound -= 1;
      }
      if (left === right && left && left.ctrlSeq === SPACE) return;
      var disableFormatting = spacesFound > 0 || dots.length > 1;
      if (disableFormatting) {
        DigitGroupingChar2.removeGroupingBetween(left, right);
      } else if (dots[0]) {
        if (dots[0] !== left) {
          DigitGroupingChar2.addGroupingBetween(dots[0][L], left);
        }
        if (dots[0] !== right) {
          DigitGroupingChar2.removeGroupingBetween(dots[0], right);
        }
      } else {
        DigitGroupingChar2.addGroupingBetween(right, left);
      }
    };
    DigitGroupingChar2.removeGroupingBetween = function(left, right) {
      var node = left;
      do {
        if (node instanceof DigitGroupingChar2) {
          node.setGroupingClass(void 0);
        }
        if (!node || node === right) break;
      } while (node = node[R]);
    };
    DigitGroupingChar2.addGroupingBetween = function(start, end) {
      var node = start;
      var count = 0;
      var totalDigits = 0;
      while (node) {
        totalDigits += 1;
        pray("digit", node instanceof DigitGroupingChar2);
        if (node === end) break;
        node = node[L];
      }
      var numDigitsInFirstGroup = totalDigits % 3;
      if (numDigitsInFirstGroup === 0) numDigitsInFirstGroup = 3;
      var node = start;
      while (node) {
        count += 1;
        var cls = void 0;
        if (totalDigits >= 4) {
          if (count === totalDigits) {
            cls = "mq-group-leading-" + numDigitsInFirstGroup;
          } else if (count % 3 === 0) {
            if (count !== totalDigits) {
              cls = "mq-group-start";
            }
          }
          if (!cls) {
            cls = "mq-group-other";
          }
        }
        if (node instanceof DigitGroupingChar2) {
          node.setGroupingClass(cls);
        }
        if (node === end) break;
        node = node[L];
      }
    };
    DigitGroupingChar2.prototype.setGroupingClass = function(cls) {
      if (this._groupingClass === cls) return;
      if (this._groupingClass)
        this.domFrag().removeClass(this._groupingClass);
      if (cls) this.domFrag().addClass(cls);
      this._groupingClass = cls;
    };
    return DigitGroupingChar2;
  })(MQSymbol)
);
var Digit = (
  /** @class */
  (function(_super) {
    __extends(Digit2, _super);
    function Digit2(ch, mathspeak) {
      return _super.call(
        this,
        ch,
        h("span", { class: "mq-digit" }, [h.text(ch)]),
        void 0,
        mathspeak
      ) || this;
    }
    Digit2.prototype.createLeftOf = function(cursor) {
      var cursorL = cursor[L];
      var cursorLL = cursorL && cursorL[L];
      var cursorParentParentSub = cursor.parent.parent instanceof SupSub ? cursor.parent.parent.sub : void 0;
      if (cursor.options.autoSubscriptNumerals && cursor.parent !== cursorParentParentSub && (cursorL instanceof Variable && cursorL.isItalic !== false || cursorL instanceof SupSub && cursorLL instanceof Variable && cursorLL.isItalic !== false)) {
        new SupSub("sub").createLeftOf(cursor);
        _super.prototype.createLeftOf.call(this, cursor);
        cursor.insRightOf(cursor.parent.parent);
      } else _super.prototype.createLeftOf.call(this, cursor);
    };
    Digit2.prototype.mathspeak = function(opts) {
      if (opts && opts.createdLeftOf) {
        var cursor = opts.createdLeftOf;
        var cursorL = cursor[L];
        var cursorLL = cursorL && cursorL[L];
        var cursorParentParentSub = cursor.parent.parent instanceof SupSub ? cursor.parent.parent.sub : void 0;
        if (cursor.options.autoSubscriptNumerals && cursor.parent !== cursorParentParentSub && (cursorL instanceof Variable && cursorL.isItalic !== false || cursor[L] instanceof SupSub && cursorLL instanceof Variable && cursorLL.isItalic !== false)) {
          return "Subscript " + _super.prototype.mathspeak.call(this) + " Baseline";
        }
      }
      return _super.prototype.mathspeak.call(this);
    };
    return Digit2;
  })(DigitGroupingChar)
);
var Variable = (
  /** @class */
  (function(_super) {
    __extends(Variable2, _super);
    function Variable2(chOrCtrlSeq, html) {
      return _super.call(
        this,
        chOrCtrlSeq,
        h("var", {}, [html || h.text(chOrCtrlSeq)])
      ) || this;
    }
    Variable2.prototype.text = function() {
      var text = this.ctrlSeq || "";
      if (this.isPartOfOperator) {
        if (text[0] == "\\") {
          text = text.slice(1, text.length);
        } else if (text[text.length - 1] == " ") {
          text = text.slice(0, -1);
        }
      } else {
        if (this[L] && !(this[L] instanceof Variable2) && !(this[L] instanceof BinaryOperator) && this[L].ctrlSeq !== "\\ ")
          text = "*" + text;
        if (this[R] && !(this[R] instanceof BinaryOperator) && !(this[R] instanceof SupSub))
          text += "*";
      }
      return text;
    };
    Variable2.prototype.mathspeak = function() {
      var text = this.ctrlSeq || "";
      if (this.isPartOfOperator || text.length > 1 || this.parent && this.parent.parent && this.parent.parent.isTextBlock()) {
        return _super.prototype.mathspeak.call(this);
      } else {
        return '"' + text + '"';
      }
    };
    return Variable2;
  })(MQSymbol)
);
function bindVariable(ch, htmlEntity, _unusedMathspeak) {
  return function() {
    return new Variable(ch, h.entityText(htmlEntity));
  };
}
Options.prototype.autoCommands = {
  _maxLength: 0
};
baseOptionProcessors.autoCommands = function(cmds) {
  if (typeof cmds !== "string" || !/^[a-z]+(?: [a-z]+)*$/i.test(cmds)) {
    throw '"' + cmds + '" not a space-delimited list of only letters';
  }
  var list = cmds.split(" ");
  var dict = {};
  var maxLength = 0;
  for (var i = 0; i < list.length; i += 1) {
    var cmd = list[i];
    if (cmd.length < 2) {
      throw 'autocommand "' + cmd + '" not minimum length of 2';
    }
    if (LatexCmds[cmd] === OperatorName) {
      throw '"' + cmd + '" is a built-in operator name';
    }
    dict[cmd] = 1;
    maxLength = max(maxLength, cmd.length);
  }
  dict._maxLength = maxLength;
  return dict;
};
Options.prototype.quietEmptyDelimiters = {};
baseOptionProcessors.quietEmptyDelimiters = function(dlms) {
  if (dlms === void 0) {
    dlms = "";
  }
  var list = dlms.split(" ");
  var dict = {};
  for (var i = 0; i < list.length; i += 1) {
    var dlm = list[i];
    dict[dlm] = 1;
  }
  return dict;
};
Options.prototype.autoParenthesizedFunctions = { _maxLength: 0 };
baseOptionProcessors.autoParenthesizedFunctions = function(cmds) {
  if (typeof cmds !== "string" || !/^[a-z]+(?: [a-z]+)*$/i.test(cmds)) {
    throw '"' + cmds + '" not a space-delimited list of only letters';
  }
  var list = cmds.split(" ");
  var dict = {};
  var maxLength = 0;
  for (var i = 0; i < list.length; i += 1) {
    var cmd = list[i];
    if (cmd.length < 2) {
      throw 'autocommand "' + cmd + '" not minimum length of 2';
    }
    dict[cmd] = 1;
    maxLength = max(maxLength, cmd.length);
  }
  dict._maxLength = maxLength;
  return dict;
};
function letterSequenceEndingAtNode(node, maxLength) {
  var str = "";
  var i = 0;
  while (node instanceof Letter && node.ctrlSeq === node.letter && i < maxLength) {
    str = node.letter + str;
    node = node[L];
    i += 1;
  }
  return str;
}
var Letter = (
  /** @class */
  (function(_super) {
    __extends(Letter2, _super);
    function Letter2(ch) {
      var _this_1 = _super.call(this, ch) || this;
      _this_1.letter = ch;
      return _this_1;
    }
    Letter2.prototype.checkAutoCmds = function(cursor) {
      var _c;
      if (this.shouldIgnoreSubstitutionInSimpleSubscript(cursor.options)) {
        return;
      }
      var autoCmds = cursor.options.autoCommands;
      var maxLength = autoCmds._maxLength || 0;
      if (maxLength > 0) {
        var str = (_c = letterSequenceEndingAtNode(this, maxLength)) !== null && _c !== void 0 ? _c : "";
        while (str.length) {
          if (autoCmds.hasOwnProperty(str)) {
            var l = this;
            for (var i = 1; l && i < str.length; i += 1, l = l[L]) ;
            new Fragment(l, this).remove();
            cursor[L] = l[L];
            var cmd = LatexCmds[str];
            var node;
            if (isMQNodeClass(cmd)) {
              node = new cmd(str);
            } else {
              node = cmd(str);
            }
            return node.createLeftOf(cursor);
          }
          str = str.slice(1);
        }
      }
    };
    Letter2.prototype.autoParenthesize = function(cursor) {
      var right = cursor.parent.getEnd(R);
      if (right && right instanceof Bracket && right.ctrlSeq === "\\left(") {
        return;
      }
      if (this.shouldIgnoreSubstitutionInSimpleSubscript(cursor.options)) {
        return;
      }
      var str = "";
      var l = this;
      var i = 0;
      var autoParenthesizedFunctions = cursor.options.autoParenthesizedFunctions;
      var maxLength = autoParenthesizedFunctions._maxLength || 0;
      var autoOperatorNames = cursor.options.autoOperatorNames;
      while (l instanceof Letter2 && i < maxLength) {
        str = l.letter + str, l = l[L], i += 1;
      }
      while (str.length) {
        if (autoParenthesizedFunctions.hasOwnProperty(str) && autoOperatorNames.hasOwnProperty(str)) {
          return cursor.parent.write(cursor, "(");
        }
        str = str.slice(1);
      }
    };
    Letter2.prototype.createLeftOf = function(cursor) {
      _super.prototype.createLeftOf.call(this, cursor);
      this.checkAutoCmds(cursor);
      this.autoParenthesize(cursor);
    };
    Letter2.prototype.italicize = function(bool) {
      this.isItalic = bool;
      this.isPartOfOperator = !bool;
      if (bool) {
        delete this.endsCategory;
        delete this.endsWord;
      }
      this.domFrag().toggleClass("mq-operator-name", !bool);
      return this;
    };
    Letter2.prototype.finalizeTree = function(opts, dir) {
      this.sharedSiblingMethod(opts, dir);
    };
    Letter2.prototype.siblingDeleted = function(opts, dir) {
      this.sharedSiblingMethod(opts, dir);
    };
    Letter2.prototype.siblingCreated = function(opts, dir) {
      this.sharedSiblingMethod(opts, dir);
    };
    Letter2.prototype.sharedSiblingMethod = function(opts, dir) {
      if (dir !== L && this[R] instanceof Letter2) return;
      this.autoUnItalicize(opts);
    };
    Letter2.prototype.autoUnItalicize = function(opts) {
      var autoOps = opts.autoOperatorNames;
      if (autoOps._maxLength === 0) return;
      if (this.shouldIgnoreSubstitutionInSimpleSubscript(opts)) {
        return;
      }
      var str = this.letter;
      for (var l = this[L]; l instanceof Letter2; l = l[L])
        str = l.letter + str;
      for (var r = this[R]; r instanceof Letter2; r = r[R]) str += r.letter;
      var lR = l && l[R];
      var rL = r && r[L];
      new Fragment(
        lR || this.parent.getEnd(L),
        rL || this.parent.getEnd(R)
      ).each(function(el) {
        if (el instanceof Letter2) {
          el.italicize(true).domFrag().removeClass("mq-first mq-last mq-followed-by-supsub");
          el.ctrlSeq = el.letter;
        }
        return void 0;
      });
      var autoOpsLength = autoOps._maxLength || 0;
      outer: for (var i = 0, first = l[R] || this.parent.getEnd(L); first && i < str.length; i += 1, first = first[R]) {
        for (var len = min(autoOpsLength, str.length - i); len > 0; len -= 1) {
          var word = str.slice(i, i + len);
          var last = void 0;
          if (autoOps.hasOwnProperty(word)) {
            for (var j = 0, letter = first; j < len; j += 1, letter = letter[R]) {
              if (letter instanceof Letter2) {
                letter.italicize(false);
                last = letter;
              }
            }
            var isBuiltIn = BuiltInOpNames.hasOwnProperty(word);
            first.ctrlSeq = (isBuiltIn ? "\\" : "\\operatorname{") + first.ctrlSeq;
            last.ctrlSeq += isBuiltIn ? " " : "}";
            last.endsWord = word;
            if (opts.infixOperatorNames[word]) {
              last.endsCategory = "infix";
            } else if (opts.prefixOperatorNames[word]) {
              last.endsCategory = "prefix";
            }
            if (TwoWordOpNames.hasOwnProperty(word)) {
              var lastL = last[L];
              var lastLL = lastL && lastL[L];
              var lastLLL = lastLL && lastLL[L];
              lastLLL.domFrag().addClass("mq-last");
            }
            if (!this.shouldOmitPadding(first[L]))
              first.domFrag().addClass("mq-first");
            if (!this.shouldOmitPadding(last[R])) {
              if (last[R] instanceof SupSub) {
                var supsub = last[R];
                var respace = supsub.siblingCreated = supsub.siblingDeleted = function() {
                  supsub.domFrag().toggleClass(
                    "mq-after-operator-name",
                    !(supsub[R] instanceof Bracket)
                  );
                };
                respace();
              } else {
                last.domFrag().toggleClass(
                  "mq-last",
                  !(last[R] instanceof Bracket)
                );
              }
            }
            i += len - 1;
            first = last;
            continue outer;
          }
        }
      }
    };
    Letter2.prototype.shouldOmitPadding = function(node) {
      if (!node) return true;
      if (node.ctrlSeq === ".") return true;
      if (node instanceof BinaryOperator && node.isBinaryOperator())
        return true;
      if (node instanceof SummationNotation) return true;
      return false;
    };
    return Letter2;
  })(Variable)
);
var BuiltInOpNames = {};
Options.prototype.autoOperatorNames = defaultAutoOpNames();
var TwoWordOpNames = { limsup: 1, liminf: 1, projlim: 1, injlim: 1 };
function defaultAutoOpNames() {
  var AutoOpNames = {
    _maxLength: 9
  };
  var mostOps = "arg deg det dim exp gcd hom inf ker lg lim ln log max min sup limsup liminf injlim projlim Pr".split(" ");
  for (var i = 0; i < mostOps.length; i += 1) {
    BuiltInOpNames[mostOps[i]] = AutoOpNames[mostOps[i]] = 1;
  }
  var builtInTrigs = "sin cos tan arcsin arccos arctan sinh cosh tanh sec csc cot coth".split(
    // why coth but not sech and csch, LaTeX?
    " "
  );
  for (var i = 0; i < builtInTrigs.length; i += 1) {
    BuiltInOpNames[builtInTrigs[i]] = 1;
  }
  var autoTrigs = "sin cos tan sec cosec csc cotan cot ctg".split(" ");
  for (var i = 0; i < autoTrigs.length; i += 1) {
    AutoOpNames[autoTrigs[i]] = AutoOpNames["arc" + autoTrigs[i]] = AutoOpNames[autoTrigs[i] + "h"] = AutoOpNames["ar" + autoTrigs[i] + "h"] = AutoOpNames["arc" + autoTrigs[i] + "h"] = 1;
  }
  var moreNonstandardOps = "gcf hcf lcm proj span".split(" ");
  for (var i = 0; i < moreNonstandardOps.length; i += 1) {
    AutoOpNames[moreNonstandardOps[i]] = 1;
  }
  return AutoOpNames;
}
baseOptionProcessors.autoOperatorNames = function(cmds) {
  if (typeof cmds !== "string") {
    throw '"' + cmds + '" not a space-delimited list';
  }
  if (!/^[a-z\|\-]+(?: [a-z\|\-]+)*$/i.test(cmds)) {
    throw '"' + cmds + '" not a space-delimited list of letters or "|"';
  }
  var list = cmds.split(" ");
  var dict = {};
  var maxLength = 0;
  for (var i = 0; i < list.length; i += 1) {
    var cmd = list[i];
    if (cmd.length < 2) {
      throw '"' + cmd + '" not minimum length of 2';
    }
    if (cmd.indexOf("|") < 0) {
      dict[cmd] = cmd;
      maxLength = max(maxLength, cmd.length);
    } else {
      var cmdArray = cmd.split("|");
      if (cmdArray.length > 2) {
        throw '"' + cmd + '" has more than 1 mathspeak delimiter';
      }
      if (cmdArray[0].length < 2) {
        throw '"' + cmd[0] + '" not minimum length of 2';
      }
      dict[cmdArray[0]] = cmdArray[1].replace(/-/g, " ");
      maxLength = max(maxLength, cmdArray[0].length);
    }
  }
  dict._maxLength = maxLength;
  return dict;
};
Options.prototype.infixOperatorNames = {};
baseOptionProcessors.infixOperatorNames = splitWordsIntoDict;
Options.prototype.prefixOperatorNames = {};
baseOptionProcessors.prefixOperatorNames = splitWordsIntoDict;
Options.prototype.disableAutoSubstitutionInSubscripts = false;
baseOptionProcessors.disableAutoSubstitutionInSubscripts = function(opt) {
  if (typeof opt === "boolean") return opt;
  if (typeof opt !== "object" || opt === null || !("except" in opt)) {
    throw '"' + opt + '" not an object with property "except"';
  }
  return { except: splitWordsIntoDict(opt.except) };
};
function splitWordsIntoDict(cmds) {
  if (typeof cmds !== "string") {
    throw '"' + cmds + '" not a space-delimited list';
  }
  if (!/^[a-z]+(?: [a-z]+)*$/i.test(cmds)) {
    throw '"' + cmds + '" not a space-delimited list of letters';
  }
  var list = cmds.split(" ");
  var dict = {};
  for (var i = 0; i < list.length; i += 1) {
    var cmd = list[i];
    if (cmd.length < 2) {
      throw '"' + cmd + '" not minimum length of 2';
    }
    dict[cmd] = true;
  }
  return dict;
}
var OperatorName = (
  /** @class */
  (function(_super) {
    __extends(OperatorName2, _super);
    function OperatorName2(fn) {
      return _super.call(this, fn || "") || this;
    }
    OperatorName2.prototype.createLeftOf = function(cursor) {
      var fn = this.ctrlSeq;
      for (var i = 0; i < fn.length; i += 1) {
        new Letter(fn.charAt(i)).createLeftOf(cursor);
      }
    };
    OperatorName2.prototype.parser = function() {
      var fn = this.ctrlSeq;
      var block = new MathBlock();
      for (var i = 0; i < fn.length; i += 1) {
        new Letter(fn.charAt(i)).adopt(block, block.getEnd(R), 0);
      }
      return Parser.succeed(block.children());
    };
    return OperatorName2;
  })(MQSymbol)
);
for (var fn in Options.prototype.autoOperatorNames)
  if (Options.prototype.autoOperatorNames.hasOwnProperty(fn)) {
    LatexCmds[fn] = OperatorName;
  }
LatexCmds.operatorname = /** @class */
(function(_super) {
  __extends(class_4, _super);
  function class_4() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  class_4.prototype.createLeftOf = function() {
  };
  class_4.prototype.numBlocks = function() {
    return 1;
  };
  class_4.prototype.parser = function() {
    return latexMathParser.block.map(function(b) {
      var isAllLetters = true;
      var str = "";
      var children = b.children();
      children.each(function(child) {
        if (child instanceof Letter) {
          str += child.letter;
        } else {
          isAllLetters = false;
        }
        return void 0;
      });
      if (isAllLetters && str === "ans") {
        return AnsBuilder();
      }
      return children;
    });
  };
  return class_4;
})(MathCommand);
LatexCmds.f = /** @class */
(function(_super) {
  __extends(class_5, _super);
  function class_5() {
    var _this_1 = this;
    var letter = "f";
    _this_1 = _super.call(this, letter) || this;
    _this_1.letter = letter;
    _this_1.domView = new DOMView(0, function() {
      return h("var", { class: "mq-f" }, [h.text("f")]);
    });
    return _this_1;
  }
  class_5.prototype.italicize = function(bool) {
    this.domFrag().eachElement(function(el) {
      return el.textContent = "f";
    });
    this.domFrag().toggleClass("mq-f", bool);
    return _super.prototype.italicize.call(this, bool);
  };
  return class_5;
})(Letter);
LatexCmds[" "] = LatexCmds.space = function() {
  return new DigitGroupingChar(
    "\\ ",
    h("span", {}, [h.text(U_NO_BREAK_SPACE)]),
    " "
  );
};
LatexCmds["."] = function() {
  return new DigitGroupingChar(
    ".",
    h("span", { class: "mq-digit" }, [h.text(".")]),
    "."
  );
};
LatexCmds["'"] = LatexCmds.prime = bindVanillaSymbol("'", "&prime;", "prime");
LatexCmds["″"] = LatexCmds.dprime = bindVanillaSymbol(
  "″",
  "&Prime;",
  "double prime"
);
LatexCmds.backslash = bindVanillaSymbol("\\backslash ", "\\", "backslash");
if (!CharCmds["\\"]) CharCmds["\\"] = LatexCmds.backslash;
LatexCmds.$ = bindVanillaSymbol("\\$", "$", "dollar");
LatexCmds["?"] = bindVanillaSymbol("?", "?", "question mark");
LatexCmds["□"] = LatexCmds.square = bindVanillaSymbol(
  "\\square ",
  "□",
  "square"
);
LatexCmds.mid = bindVanillaSymbol("\\mid ", "∣", "mid");
var SymbolWithCustomClass = (
  /** @class */
  (function(_super) {
    __extends(SymbolWithCustomClass2, _super);
    function SymbolWithCustomClass2(ch, customClass) {
      return _super.call(
        this,
        ch,
        h("span", { class: customClass }, [h.text(ch)])
      ) || this;
    }
    return SymbolWithCustomClass2;
  })(MQSymbol)
);
LatexCmds[","] = function() {
  return new SymbolWithCustomClass(",", "mq-comma");
};
var NonSymbolaSymbol = (
  /** @class */
  (function(_super) {
    __extends(NonSymbolaSymbol2, _super);
    function NonSymbolaSymbol2(ch, html, _unusedMathspeak) {
      return _super.call(
        this,
        ch,
        h("span", { class: "mq-nonSymbola" }, [html || h.text(ch)])
      ) || this;
    }
    return NonSymbolaSymbol2;
  })(MQSymbol)
);
LatexCmds["@"] = function() {
  return new NonSymbolaSymbol("@");
};
LatexCmds["&"] = function() {
  return new NonSymbolaSymbol("\\&", h.entityText("&amp;"), "and");
};
LatexCmds["%"] = /** @class */
(function(_super) {
  __extends(class_6, _super);
  function class_6() {
    return _super.call(this, "\\%", h.text("%"), "percent") || this;
  }
  class_6.prototype.parser = function() {
    var optWhitespace = Parser.optWhitespace;
    var string = Parser.string;
    return optWhitespace.then(
      string("\\operatorname{of}").map(function() {
        return PercentOfBuilder();
      })
    ).or(_super.prototype.parser.call(this));
  };
  return class_6;
})(NonSymbolaSymbol);
LatexCmds["∥"] = LatexCmds.parallel = bindVanillaSymbol(
  "\\parallel ",
  "&#x2225;",
  "parallel"
);
LatexCmds["∦"] = LatexCmds.nparallel = bindVanillaSymbol(
  "\\nparallel ",
  "&#x2226;",
  "not parallel"
);
LatexCmds["⟂"] = LatexCmds.perp = bindVanillaSymbol(
  "\\perp ",
  "&#x27C2;",
  "perpendicular"
);
function bindLowercaseGreek(latex) {
  return bindVariable("\\" + latex + " ", "&" + latex + ";");
}
LatexCmds["α"] = LatexCmds.alpha = bindLowercaseGreek("alpha");
LatexCmds["β"] = LatexCmds.beta = bindLowercaseGreek("beta");
LatexCmds["γ"] = LatexCmds.gamma = bindLowercaseGreek("gamma");
LatexCmds["δ"] = LatexCmds.delta = bindLowercaseGreek("delta");
LatexCmds["ζ"] = LatexCmds.zeta = bindLowercaseGreek("zeta");
LatexCmds["η"] = LatexCmds.eta = bindLowercaseGreek("eta");
LatexCmds["θ"] = LatexCmds.theta = bindLowercaseGreek("theta");
LatexCmds["ι"] = LatexCmds.iota = bindLowercaseGreek("iota");
LatexCmds["κ"] = LatexCmds.kappa = bindLowercaseGreek("kappa");
LatexCmds["μ"] = LatexCmds.mu = bindLowercaseGreek("mu");
LatexCmds["ν"] = LatexCmds.nu = bindLowercaseGreek("nu");
LatexCmds["ξ"] = LatexCmds.xi = bindLowercaseGreek("xi");
LatexCmds["ρ"] = LatexCmds.rho = bindLowercaseGreek("rho");
LatexCmds["σ"] = LatexCmds.sigma = bindLowercaseGreek("sigma");
LatexCmds["τ"] = LatexCmds.tau = bindLowercaseGreek("tau");
LatexCmds["χ"] = LatexCmds.chi = bindLowercaseGreek("chi");
LatexCmds["ψ"] = LatexCmds.psi = bindLowercaseGreek("psi");
LatexCmds["ω"] = LatexCmds.omega = bindLowercaseGreek("omega");
LatexCmds["ϕ"] = LatexCmds.phi = bindVariable("\\phi ", "&#981;");
LatexCmds["φ"] = LatexCmds.phiv = LatexCmds.varphi = bindVariable("\\varphi ", "&phi;");
LatexCmds["ϵ"] = LatexCmds.epsilon = bindVariable(
  "\\epsilon ",
  "&#1013;"
);
LatexCmds["ε"] = LatexCmds.epsiv = LatexCmds.varepsilon = bindVariable(
  //Elsevier and 9573-13 //AMS and LaTeX
  "\\varepsilon ",
  "&epsilon;"
);
LatexCmds["ϖ"] = LatexCmds.piv = LatexCmds.varpi = bindVariable("\\varpi ", "&piv;");
LatexCmds["ς"] = // Unicode
LatexCmds.sigmaf = //W3C/Unicode
LatexCmds.sigmav = //Elsevier
LatexCmds.varsigma = //LaTeX
bindVariable("\\varsigma ", "&sigmaf;");
LatexCmds["ϑ"] = // Unicode
LatexCmds.thetav = //Elsevier and 9573-13
LatexCmds.vartheta = //AMS and LaTeX
LatexCmds.thetasym = //W3C/Unicode
bindVariable("\\vartheta ", "&thetasym;");
LatexCmds["υ"] = LatexCmds.upsilon = LatexCmds.upsi = bindVariable(
  //AMS and LaTeX and W3C/Unicode //Elsevier and 9573-13
  "\\upsilon ",
  "&upsilon;"
);
LatexCmds["Ϝ"] = LatexCmds.gammad = //Elsevier
LatexCmds.Gammad = //9573-13 -- WTF, right? I dunno if this was a typo in the reference (see above)
LatexCmds.digamma = //LaTeX
bindVariable("\\digamma ", "&#989;");
LatexCmds["ϰ"] = LatexCmds.kappav = LatexCmds.varkappa = bindVariable(
  //Elsevier //AMS and LaTeX
  "\\varkappa ",
  "&#1008;"
);
LatexCmds["ϱ"] = LatexCmds.rhov = LatexCmds.varrho = bindVariable("\\varrho ", "&#1009;");
LatexCmds.pi = LatexCmds["π"] = function() {
  return new NonSymbolaSymbol("\\pi ", h.entityText("&pi;"), "pi");
};
LatexCmds["λ"] = LatexCmds.lambda = function() {
  return new NonSymbolaSymbol(
    "\\lambda ",
    h.entityText("&lambda;"),
    "lambda"
  );
};
LatexCmds["Υ"] = LatexCmds.Upsilon = //LaTeX
LatexCmds.Upsi = //Elsevier and 9573-13
LatexCmds.upsih = //W3C/Unicode "upsilon with hook"
LatexCmds.Upsih = //'cos it makes sense to me
function() {
  return new MQSymbol(
    "\\Upsilon ",
    h("var", { style: "font-family: serif" }, [
      h.entityText("&upsih;")
    ]),
    "capital upsilon"
  );
};
function bindUppercaseGreek(latex) {
  return function() {
    return new VanillaSymbol(
      "\\" + latex + " ",
      h.entityText("&" + latex + ";")
    );
  };
}
LatexCmds["Γ"] = LatexCmds.Gamma = bindUppercaseGreek("Gamma");
LatexCmds["Δ"] = LatexCmds.Delta = bindUppercaseGreek("Delta");
LatexCmds["Θ"] = LatexCmds.Theta = bindUppercaseGreek("Theta");
LatexCmds["Λ"] = LatexCmds.Lambda = bindUppercaseGreek("Lambda");
LatexCmds["Ξ"] = LatexCmds.Xi = bindUppercaseGreek("Xi");
LatexCmds["Π"] = LatexCmds.Pi = bindUppercaseGreek("Pi");
LatexCmds["Σ"] = LatexCmds.Sigma = bindUppercaseGreek("Sigma");
LatexCmds["Φ"] = LatexCmds.Phi = bindUppercaseGreek("Phi");
LatexCmds["Ψ"] = LatexCmds.Psi = bindUppercaseGreek("Psi");
LatexCmds["Ω"] = LatexCmds.Omega = bindUppercaseGreek("Omega");
LatexCmds["∀"] = LatexCmds.forall = bindUppercaseGreek("forall");
var LatexFragment = (
  /** @class */
  (function(_super) {
    __extends(LatexFragment2, _super);
    function LatexFragment2(latex) {
      var _this_1 = _super.call(this) || this;
      _this_1.latexStr = latex;
      return _this_1;
    }
    LatexFragment2.prototype.createLeftOf = function(cursor) {
      var block = latexMathParser.parse(this.latexStr);
      block.children().adopt(cursor.parent, cursor[L], cursor[R]);
      cursor[L] = block.getEnd(R);
      domFrag(block.html()).insertBefore(cursor.domFrag());
      block.finalizeInsert(cursor.options, cursor);
      var blockEndsR = block.getEnd(R);
      var blockEndsRR = blockEndsR && blockEndsR[R];
      if (blockEndsRR) blockEndsRR.siblingCreated(cursor.options, L);
      var blockEndsL = block.getEnd(L);
      var blockEndsLL = blockEndsL && blockEndsL[L];
      if (blockEndsLL) blockEndsLL.siblingCreated(cursor.options, R);
      cursor.parent.bubble(function(node) {
        node.reflow();
        return void 0;
      });
    };
    LatexFragment2.prototype.mathspeak = function() {
      return latexMathParser.parse(this.latexStr).mathspeak();
    };
    LatexFragment2.prototype.parser = function() {
      var frag = latexMathParser.parse(this.latexStr).children();
      return Parser.succeed(frag);
    };
    return LatexFragment2;
  })(MathCommand)
);
LatexCmds["⁰"] = function() {
  return new LatexFragment("^0");
};
LatexCmds["¹"] = function() {
  return new LatexFragment("^1");
};
LatexCmds["²"] = function() {
  return new LatexFragment("^2");
};
LatexCmds["³"] = function() {
  return new LatexFragment("^3");
};
LatexCmds["⁴"] = function() {
  return new LatexFragment("^4");
};
LatexCmds["⁵"] = function() {
  return new LatexFragment("^5");
};
LatexCmds["⁶"] = function() {
  return new LatexFragment("^6");
};
LatexCmds["⁷"] = function() {
  return new LatexFragment("^7");
};
LatexCmds["⁸"] = function() {
  return new LatexFragment("^8");
};
LatexCmds["⁹"] = function() {
  return new LatexFragment("^9");
};
LatexCmds["¼"] = function() {
  return new LatexFragment("\\frac14");
};
LatexCmds["½"] = function() {
  return new LatexFragment("\\frac12");
};
LatexCmds["¾"] = function() {
  return new LatexFragment("\\frac34");
};
LatexCmds["√"] = function() {
  return new LatexFragment("\\sqrt{}");
};
function nodeEndsBinaryOperator(node) {
  return node instanceof BinaryOperator || node instanceof Letter && node.endsCategory == "infix";
}
function plusMinusIsBinaryOperator(node) {
  if (!node) return false;
  var nodeL = node[L];
  if (nodeL) {
    if (nodeEndsBinaryOperator(nodeL) || nodeL instanceof Letter && nodeL.endsCategory == "prefix" || !(nodeL instanceof Bracket) && // exclude Bracket because ctrlSeq gives "(" even if `node` is after the ")"
    /^(\\ )|[,;:\(\[]$/.test(nodeL.ctrlSeq)) {
      return false;
    }
  } else if (node.parent && node.parent.parent && node.parent.parent.isStyleBlock()) {
    return plusMinusIsBinaryOperator(node.parent.parent);
  } else {
    return false;
  }
  return true;
}
var PlusMinus = (
  /** @class */
  (function(_super) {
    __extends(class_7, _super);
    function class_7(ch, html, mathspeak) {
      return _super.call(this, ch, html, void 0, mathspeak, true) || this;
    }
    class_7.prototype.isBinaryOperator = function() {
      return plusMinusIsBinaryOperator(this);
    };
    class_7.prototype.contactWeld = function(cursor, dir) {
      this.sharedSiblingMethod(cursor.options, dir);
    };
    class_7.prototype.siblingCreated = function(opts, dir) {
      this.sharedSiblingMethod(opts, dir);
    };
    class_7.prototype.siblingDeleted = function(opts, dir) {
      this.sharedSiblingMethod(opts, dir);
    };
    class_7.prototype.sharedSiblingMethod = function(_opts, dir) {
      if (dir === R) return;
      this.domFrag().oneElement().className = plusMinusIsBinaryOperator(this) ? "mq-binary-operator" : "";
      return this;
    };
    return class_7;
  })(BinaryOperator)
);
LatexCmds["+"] = /** @class */
(function(_super) {
  __extends(class_8, _super);
  function class_8() {
    return _super.call(this, "+", h.text("+")) || this;
  }
  class_8.prototype.mathspeak = function() {
    return plusMinusIsBinaryOperator(this) ? "plus" : "positive";
  };
  return class_8;
})(PlusMinus);
var MinusNode = (
  /** @class */
  (function(_super) {
    __extends(MinusNode2, _super);
    function MinusNode2() {
      return _super.call(this, "-", h.entityText("&minus;")) || this;
    }
    MinusNode2.prototype.mathspeak = function() {
      return plusMinusIsBinaryOperator(this) ? "minus" : "negative";
    };
    return MinusNode2;
  })(PlusMinus)
);
LatexCmds["−"] = LatexCmds["—"] = LatexCmds["–"] = LatexCmds["-"] = MinusNode;
LatexCmds["±"] = LatexCmds.pm = LatexCmds.plusmn = LatexCmds.plusminus = function() {
  return new PlusMinus(
    "\\pm ",
    h.entityText("&plusmn;"),
    "plus-or-minus"
  );
};
LatexCmds["∓"] = LatexCmds.mp = LatexCmds.mnplus = LatexCmds.minusplus = function() {
  return new PlusMinus(
    "\\mp ",
    h.entityText("&#8723;"),
    "minus-or-plus"
  );
};
CharCmds["*"] = LatexCmds.sdot = LatexCmds.cdot = bindBinaryOperator("\\cdot ", "&middot;", "*", "times");
var To = (
  /** @class */
  (function(_super) {
    __extends(To2, _super);
    function To2() {
      return _super.call(this, "\\to ", h.entityText("&rarr;"), "to") || this;
    }
    To2.prototype.deleteTowards = function(dir, cursor) {
      if (dir === L) {
        var l = cursor[L];
        new Fragment(l, this).remove();
        cursor[L] = l[L];
        new MinusNode().createLeftOf(cursor);
        cursor[L].bubble(function(node) {
          node.reflow();
          return void 0;
        });
        return;
      }
      _super.prototype.deleteTowards.call(this, dir, cursor);
    };
    return To2;
  })(BinaryOperator)
);
LatexCmds["→"] = LatexCmds.to = To;
var Inequality = (
  /** @class */
  (function(_super) {
    __extends(Inequality2, _super);
    function Inequality2(data, strict) {
      var _this_1 = this;
      var strictness = strict ? "Strict" : "";
      _this_1 = _super.call(
        this,
        data["ctrlSeq".concat(strictness)],
        h.entityText(data["htmlEntity".concat(strictness)]),
        data["text".concat(strictness)],
        data["mathspeak".concat(strictness)]
      ) || this;
      _this_1.data = data;
      _this_1.strict = strict;
      return _this_1;
    }
    Inequality2.prototype.swap = function(strict) {
      this.strict = strict;
      var strictness = strict ? "Strict" : "";
      this.ctrlSeq = this.data["ctrlSeq".concat(strictness)];
      this.domFrag().children().replaceWith(
        domFrag(
          h.entityText(this.data["htmlEntity".concat(strictness)])
        )
      );
      this.textTemplate = [this.data["text".concat(strictness)]];
      this.mathspeakName = this.data["mathspeak".concat(strictness)];
    };
    Inequality2.prototype.deleteTowards = function(dir, cursor) {
      if (dir === L && !this.strict) {
        this.swap(true);
        this.bubble(function(node) {
          node.reflow();
          return void 0;
        });
        return;
      }
      _super.prototype.deleteTowards.call(this, dir, cursor);
    };
    return Inequality2;
  })(BinaryOperator)
);
var less = {
  ctrlSeq: "\\le ",
  htmlEntity: "&le;",
  text: "≤",
  mathspeak: "less than or equal to",
  ctrlSeqStrict: "<",
  htmlEntityStrict: "&lt;",
  textStrict: "<",
  mathspeakStrict: "less than"
};
var greater = {
  ctrlSeq: "\\ge ",
  htmlEntity: "&ge;",
  text: "≥",
  mathspeak: "greater than or equal to",
  ctrlSeqStrict: ">",
  htmlEntityStrict: "&gt;",
  textStrict: ">",
  mathspeakStrict: "greater than"
};
var Greater = (
  /** @class */
  (function(_super) {
    __extends(Greater2, _super);
    function Greater2() {
      return _super.call(this, greater, true) || this;
    }
    Greater2.prototype.createLeftOf = function(cursor) {
      var cursorL = cursor[L];
      if (cursorL instanceof BinaryOperator && cursorL.ctrlSeq === "-") {
        var l = cursorL;
        cursor[L] = l[L];
        l.remove();
        new To().createLeftOf(cursor);
        cursor[L].bubble(function(node) {
          node.reflow();
          return void 0;
        });
        return;
      }
      _super.prototype.createLeftOf.call(this, cursor);
    };
    return Greater2;
  })(Inequality)
);
LatexCmds["<"] = LatexCmds.lt = function() {
  return new Inequality(less, true);
};
LatexCmds[">"] = LatexCmds.gt = Greater;
LatexCmds["≤"] = LatexCmds.le = LatexCmds.leq = function() {
  return new Inequality(less, false);
};
LatexCmds["≥"] = LatexCmds.ge = LatexCmds.geq = function() {
  return new Inequality(greater, false);
};
LatexCmds["∞"] = LatexCmds.infty = LatexCmds.infin = LatexCmds.infinity = bindVanillaSymbol("\\infty ", "&infin;", "infinity");
LatexCmds["≠"] = LatexCmds.ne = LatexCmds.neq = bindBinaryOperator("\\ne ", "&ne;", "not equal");
var Equality = (
  /** @class */
  (function(_super) {
    __extends(Equality2, _super);
    function Equality2() {
      return _super.call(this, "=", h.text("="), "=", "equals") || this;
    }
    Equality2.prototype.createLeftOf = function(cursor) {
      var cursorL = cursor[L];
      if (cursorL instanceof Inequality && cursorL.strict) {
        cursorL.swap(false);
        cursorL.bubble(function(node) {
          node.reflow();
          return void 0;
        });
        return;
      }
      _super.prototype.createLeftOf.call(this, cursor);
    };
    return Equality2;
  })(BinaryOperator)
);
LatexCmds["="] = Equality;
LatexCmds["×"] = LatexCmds.times = LatexCmds.cross = bindBinaryOperator("\\times ", "&times;", "[x]", "times");
LatexCmds["÷"] = LatexCmds.div = LatexCmds.divide = LatexCmds.divides = bindBinaryOperator("\\div ", "&divide;", "[/]", "divided by");
var Sim = (
  /** @class */
  (function(_super) {
    __extends(Sim2, _super);
    function Sim2() {
      return _super.call(this, "\\sim ", h.text("~"), "~", "tilde") || this;
    }
    Sim2.prototype.createLeftOf = function(cursor) {
      if (cursor[L] instanceof Sim2) {
        var l = cursor[L];
        cursor[L] = l[L];
        l.remove();
        new Approx().createLeftOf(cursor);
        cursor[L].bubble(function(node) {
          node.reflow();
          return void 0;
        });
        return;
      }
      _super.prototype.createLeftOf.call(this, cursor);
    };
    return Sim2;
  })(BinaryOperator)
);
var Approx = (
  /** @class */
  (function(_super) {
    __extends(Approx2, _super);
    function Approx2() {
      return _super.call(
        this,
        "\\approx ",
        h.entityText("&approx;"),
        "≈",
        "approximately equal"
      ) || this;
    }
    Approx2.prototype.deleteTowards = function(dir, cursor) {
      if (dir === L) {
        var l = cursor[L];
        new Fragment(l, this).remove();
        cursor[L] = l[L];
        new Sim().createLeftOf(cursor);
        cursor[L].bubble(function(node) {
          node.reflow();
          return void 0;
        });
        return;
      }
      _super.prototype.deleteTowards.call(this, dir, cursor);
    };
    return Approx2;
  })(BinaryOperator)
);
LatexCmds.tildeNbsp = bindVanillaSymbol("~", U_NO_BREAK_SPACE, " ");
LatexCmds.sim = Sim;
LatexCmds["≈"] = LatexCmds.approx = Approx;
CharCmds["~"] = LatexCmds.sim;
LatexCmds["~"] = LatexCmds.tildeNbsp;
baseOptionProcessors.interpretTildeAsSim = function(val) {
  var interpretAsSim = !!val;
  if (interpretAsSim) {
    LatexCmds["~"] = LatexCmds.sim;
  } else {
    LatexCmds["~"] = LatexCmds.tildeNbsp;
  }
  return interpretAsSim;
};
LatexCmds["◯"] = LatexCmds.bigcirc = bindVanillaSymbol(
  "\\bigcirc ",
  "&#9711;",
  "circle"
);
LatexCmds["∠"] = LatexCmds.ang = LatexCmds.angle = bindVanillaSymbol("\\angle ", "&ang;", "angle");
LatexCmds["°"] = LatexCmds.degree = bindVanillaSymbol(
  "\\degree ",
  "&deg;",
  "degrees"
);
LatexCmds["△"] = LatexCmds.triangle = bindVanillaSymbol(
  "\\triangle ",
  "&#9651;",
  "triangle"
);
LatexCmds["≅"] = LatexCmds.cong = bindBinaryOperator(
  "\\cong ",
  "&cong;",
  "cong",
  "congruent"
);
LatexCmds["∡"] = LatexCmds.measuredangle = bindVanillaSymbol(
  "\\measuredangle ",
  "&#8737;",
  "measured angle"
);
LatexCmds["▱"] = LatexCmds.parallelogram = bindVanillaSymbol(
  "\\parallelogram ",
  "&#9649;",
  "parallelogram"
);
LatexCmds["≇"] = LatexCmds.ncong = bindBinaryOperator(
  "\\ncong ",
  "&ncong;",
  "ncong",
  "not congruent"
);
LatexCmds["≁"] = LatexCmds.nsim = bindBinaryOperator(
  "\\nsim ",
  "&nsim;",
  "nsim",
  "not similar"
);
var SVG_SYMBOLS = {
  sqrt: {
    width: "",
    html: function() {
      return h(
        "svg",
        { preserveAspectRatio: "none", viewBox: "0 0 32 54" },
        [
          h("path", {
            d: "M0 33 L7 27 L12.5 47 L13 47 L30 0 L32 0 L13 54 L11 54 L4.5 31 L0 33"
          })
        ]
      );
    }
  },
  "|": {
    width: ".4em",
    html: function() {
      return h(
        "svg",
        { preserveAspectRatio: "none", viewBox: "0 0 10 54" },
        [h("path", { d: "M4.4 0 L4.4 54 L5.6 54 L5.6 0" })]
      );
    }
  },
  "[": {
    width: ".55em",
    html: function() {
      return h(
        "svg",
        { preserveAspectRatio: "none", viewBox: "0 0 11 24" },
        [
          h("path", {
            d: "M8 0 L3 0 L3 24 L8 24 L8 23 L4 23 L4 1 L8 1"
          })
        ]
      );
    }
  },
  "]": {
    width: ".55em",
    html: function() {
      return h(
        "svg",
        { preserveAspectRatio: "none", viewBox: "0 0 11 24" },
        [
          h("path", {
            d: "M3 0 L8 0 L8 24 L3 24 L3 23 L7 23 L7 1 L3 1"
          })
        ]
      );
    }
  },
  "(": {
    width: ".55em",
    html: function() {
      return h(
        "svg",
        { preserveAspectRatio: "none", viewBox: "3 0 106 186" },
        [
          h("path", {
            d: "M85 0 A61 101 0 0 0 85 186 L75 186 A75 101 0 0 1 75 0"
          })
        ]
      );
    }
  },
  ")": {
    width: ".55em",
    html: function() {
      return h(
        "svg",
        { preserveAspectRatio: "none", viewBox: "3 0 106 186" },
        [
          h("path", {
            d: "M24 0 A61 101 0 0 1 24 186 L34 186 A75 101 0 0 0 34 0"
          })
        ]
      );
    }
  },
  "{": {
    width: ".7em",
    html: function() {
      return h(
        "svg",
        { preserveAspectRatio: "none", viewBox: "10 0 210 350" },
        [
          h("path", {
            d: "M170 0 L170 6 A47 52 0 0 0 123 60 L123 127 A35 48 0 0 1 88 175 A35 48 0 0 1 123 223 L123 290 A47 52 0 0 0 170 344 L170 350 L160 350 A58 49 0 0 1 102 301 L103 220 A45 40 0 0 0 58 180 L58 170 A45 40 0 0 0 103 130 L103 49 A58 49 0 0 1 161 0"
          })
        ]
      );
    }
  },
  "}": {
    width: ".7em",
    html: function() {
      return h(
        "svg",
        { preserveAspectRatio: "none", viewBox: "10 0 210 350" },
        [
          h("path", {
            d: "M60 0 L60 6 A47 52 0 0 1 107 60 L107 127 A35 48 0 0 0 142 175 A35 48 0 0 0 107 223 L107 290 A47 52 0 0 1 60 344 L60 350 L70 350 A58 49 0 0 0 128 301 L127 220 A45 40 0 0 1 172 180 L172 170 A45 40 0 0 1 127 130 L127 49 A58 49 0 0 0 70 0"
          })
        ]
      );
    }
  },
  "&#8741;": {
    width: ".7em",
    html: function() {
      return h(
        "svg",
        { preserveAspectRatio: "none", viewBox: "0 0 10 54" },
        [
          h("path", {
            d: "M3.2 0 L3.2 54 L4 54 L4 0 M6.8 0 L6.8 54 L6 54 L6 0"
          })
        ]
      );
    }
  },
  "&lang;": {
    width: ".55em",
    html: function() {
      return h(
        "svg",
        { preserveAspectRatio: "none", viewBox: "0 0 10 54" },
        [
          h("path", {
            d: "M6.8 0 L3.2 27 L6.8 54 L7.8 54 L4.2 27 L7.8 0"
          })
        ]
      );
    }
  },
  "&rang;": {
    width: ".55em",
    html: function() {
      return h(
        "svg",
        { preserveAspectRatio: "none", viewBox: "0 0 10 54" },
        [
          h("path", {
            d: "M3.2 0 L6.8 27 L3.2 54 L2.2 54 L5.8 27 L2.2 0"
          })
        ]
      );
    }
  }
};
var ArrowText = "➤";
var Style = (
  /** @class */
  (function(_super) {
    __extends(Style2, _super);
    function Style2(ctrlSeq, tagName, attrs, ariaLabel, opts) {
      var _this_1 = _super.call(
        this,
        ctrlSeq,
        new DOMView(1, function(blocks) {
          var _c, _d;
          return h.block(tagName, attrs, blocks[0], {
            beforeChild: (_c = opts === null || opts === void 0 ? void 0 : opts.beforeChild) === null || _c === void 0 ? void 0 : _c.call(opts),
            afterChild: (_d = opts === null || opts === void 0 ? void 0 : opts.afterChild) === null || _d === void 0 ? void 0 : _d.call(opts)
          });
        })
      ) || this;
      _this_1.ariaLabel = ariaLabel || ctrlSeq.replace(/^\\/, "");
      _this_1.mathspeakTemplate = [
        "Start" + _this_1.ariaLabel + ",",
        "End" + _this_1.ariaLabel
      ];
      _this_1.shouldNotSpeakDelimiters = opts && opts.shouldNotSpeakDelimiters;
      return _this_1;
    }
    Style2.prototype.mathspeak = function(opts) {
      if (!this.shouldNotSpeakDelimiters || opts && opts.ignoreShorthand) {
        return _super.prototype.mathspeak.call(this);
      }
      return this.foldChildren("", function(speech, block) {
        return speech + " " + block.mathspeak(opts);
      }).trim();
    };
    return Style2;
  })(MathCommand)
);
LatexCmds.mathrm = /** @class */
(function(_super) {
  __extends(mathrm, _super);
  function mathrm() {
    return _super.call(
      this,
      "\\mathrm",
      "span",
      { class: "mq-roman mq-font" },
      "Roman Font",
      {
        shouldNotSpeakDelimiters: true
      }
    ) || this;
  }
  mathrm.prototype.isTextBlock = function() {
    return true;
  };
  return mathrm;
})(Style);
LatexCmds.mathit = function() {
  return new Style("\\mathit", "i", { class: "mq-font" }, "Italic Font");
};
LatexCmds.mathbf = function() {
  return new Style("\\mathbf", "b", { class: "mq-font" }, "Bold Font");
};
LatexCmds.mathsf = function() {
  return new Style(
    "\\mathsf",
    "span",
    { class: "mq-sans-serif mq-font" },
    "Serif Font"
  );
};
LatexCmds.mathtt = function() {
  return new Style(
    "\\mathtt",
    "span",
    { class: "mq-monospace mq-font" },
    "Math Text"
  );
};
LatexCmds.underline = function() {
  return new Style(
    "\\underline",
    "span",
    { class: "mq-non-leaf mq-underline" },
    "Underline"
  );
};
LatexCmds.overline = LatexCmds.bar = function() {
  return new Style(
    "\\overline",
    "span",
    { class: "mq-non-leaf mq-overline" },
    "Overline"
  );
};
LatexCmds.overrightarrow = function() {
  return new Style(
    "\\overrightarrow",
    "span",
    { class: "mq-non-leaf mq-overarrow" },
    "Over Right Arrow",
    {
      afterChild: function() {
        return h("span", { class: "mq-arrow-right-content" }, [
          h.text(ArrowText)
        ]);
      }
    }
  );
};
LatexCmds.overleftarrow = function() {
  return new Style(
    "\\overleftarrow",
    "span",
    { class: "mq-non-leaf mq-overarrow" },
    "Over Left Arrow",
    {
      beforeChild: function() {
        return h("span", { class: "mq-arrow-left-content" }, [
          h.text(ArrowText)
        ]);
      }
    }
  );
};
LatexCmds.overleftrightarrow = function() {
  return new Style(
    "\\overleftrightarrow ",
    "span",
    { class: "mq-non-leaf mq-overarrow" },
    "Over Left and Right Arrow",
    {
      beforeChild: function() {
        return h("span", { class: "mq-arrow-left-content" }, [
          h.text(ArrowText)
        ]);
      },
      afterChild: function() {
        return h("span", { class: "mq-arrow-right-content" }, [
          h.text(ArrowText)
        ]);
      }
    }
  );
};
LatexCmds.overarc = function() {
  return new Style(
    "\\overarc",
    "span",
    { class: "mq-non-leaf mq-overarc" },
    "Over Arc"
  );
};
LatexCmds.dot = function() {
  return new MathCommand(
    "\\dot",
    new DOMView(1, function(blocks) {
      return h("span", { class: "mq-non-leaf" }, [
        h("span", { class: "mq-dot-recurring-inner" }, [
          h("span", { class: "mq-dot-recurring" }, [
            h.text(U_DOT_ABOVE)
          ]),
          h.block("span", { class: "mq-empty-box" }, blocks[0])
        ])
      ]);
    })
  );
};
LatexCmds.textcolor = /** @class */
(function(_super) {
  __extends(class_9, _super);
  function class_9() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  class_9.prototype.setColor = function(color) {
    this.color = color;
    this.domView = new DOMView(1, function(blocks) {
      return h.block(
        "span",
        { class: "mq-textcolor", style: "color:" + color },
        blocks[0]
      );
    });
    this.ariaLabel = color.replace(/^\\/, "");
    this.mathspeakTemplate = [
      "Start " + this.ariaLabel + ",",
      "End " + this.ariaLabel
    ];
  };
  class_9.prototype.latexRecursive = function(ctx) {
    this.checkCursorContextOpen(ctx);
    var blocks0 = this.blocks[0];
    ctx.uncleanedLatex += "\\textcolor{" + this.color + "}{";
    blocks0.latexRecursive(ctx);
    ctx.uncleanedLatex += "}";
    this.checkCursorContextClose(ctx);
  };
  class_9.prototype.parser = function() {
    var _this_1 = this;
    var optWhitespace = Parser.optWhitespace;
    var string = Parser.string;
    var regex = Parser.regex;
    return optWhitespace.then(string("{")).then(regex(/^[#\w\s.,()%-]*/)).skip(string("}")).then(function(color) {
      _this_1.setColor(color);
      return _super.prototype.parser.call(_this_1);
    });
  };
  class_9.prototype.isStyleBlock = function() {
    return true;
  };
  return class_9;
})(MathCommand);
LatexCmds["class"] = /** @class */
(function(_super) {
  __extends(class_10, _super);
  function class_10() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  class_10.prototype.parser = function() {
    var _this_1 = this;
    var string = Parser.string, regex = Parser.regex;
    return Parser.optWhitespace.then(string("{")).then(regex(/^[-\w\s\\\xA0-\xFF]*/)).skip(string("}")).then(function(cls) {
      _this_1.cls = cls || "";
      _this_1.domView = new DOMView(1, function(blocks) {
        return h.block(
          "span",
          { class: "mq-class ".concat(cls) },
          blocks[0]
        );
      });
      _this_1.ariaLabel = cls + " class";
      _this_1.mathspeakTemplate = [
        "Start " + _this_1.ariaLabel + ",",
        "End " + _this_1.ariaLabel
      ];
      return _super.prototype.parser.call(_this_1);
    });
  };
  class_10.prototype.latexRecursive = function(ctx) {
    this.checkCursorContextOpen(ctx);
    var blocks0 = this.blocks[0];
    ctx.uncleanedLatex += "\\class{" + this.cls + "}{";
    blocks0.latexRecursive(ctx);
    ctx.uncleanedLatex += "}";
    this.checkCursorContextClose(ctx);
  };
  class_10.prototype.isStyleBlock = function() {
    return true;
  };
  return class_10;
})(MathCommand);
var intRgx = /^[\+\-]?[\d]+$/;
function getCtrlSeqsFromBlock(block) {
  if (!block) return "";
  var chars = "";
  block.eachChild(function(child) {
    if (child.ctrlSeq !== void 0) chars += child.ctrlSeq;
  });
  return chars;
}
Options.prototype.charsThatBreakOutOfSupSub = "";
var SupSub = (
  /** @class */
  (function(_super) {
    __extends(SupSub2, _super);
    function SupSub2(supsub) {
      var _this_1 = this;
      var ctrlSeq = "_{...}^{...}";
      var domView;
      if (supsub === "sub") {
        domView = new DOMView(1, function(blocks) {
          return h("span", { class: "mq-supsub mq-non-leaf" }, [
            h.block("span", { class: "mq-sub" }, blocks[0]),
            h("span", { style: "display:inline-block;width:0" }, [
              h.text(U_ZERO_WIDTH_SPACE)
            ])
          ]);
        });
      } else {
        domView = new DOMView(1, function(blocks) {
          return h(
            "span",
            { class: "mq-supsub mq-non-leaf mq-sup-only" },
            [h.block("span", { class: "mq-sup" }, blocks[0])]
          );
        });
      }
      _this_1 = _super.call(this, ctrlSeq, domView) || this;
      _this_1.ariaLabel = supsub === "sub" ? "subscript" : "superscript";
      _this_1.supsub = supsub;
      return _this_1;
    }
    SupSub2.prototype.setEnds = function(ends) {
      pray(
        "SupSub ends must be MathBlocks",
        ends[L] instanceof MathBlock && ends[R] instanceof MathBlock
      );
      this.ends = ends;
    };
    SupSub2.prototype.getEnd = function(dir) {
      return this.ends[dir];
    };
    SupSub2.prototype.createLeftOf = function(cursor) {
      if (!this.replacedFragment && !cursor[L] && cursor.options.supSubsRequireOperand)
        return;
      return _super.prototype.createLeftOf.call(this, cursor);
    };
    SupSub2.prototype.contactWeld = function(cursor) {
      for (var dir = L; dir; dir = dir === L ? R : false) {
        var thisDir = this[dir];
        var pt = void 0;
        if (thisDir instanceof SupSub2) {
          for (var supsub = "sub"; supsub; supsub = supsub === "sub" ? "sup" : false) {
            var src = this[supsub], dest = thisDir[supsub];
            if (!src) continue;
            if (!dest) thisDir.addBlock(src.disown());
            else if (!src.isEmpty()) {
              src.domFrag().children().insAtDirEnd(-dir, dest.domFrag().oneElement());
              var children = src.children().disown();
              pt = new Point(
                dest,
                children.getEnd(R),
                dest.getEnd(L)
              );
              if (dir === L) children.adopt(dest, dest.getEnd(R), 0);
              else children.adopt(dest, 0, dest.getEnd(L));
            } else {
              pt = new Point(dest, 0, dest.getEnd(L));
            }
            this.placeCursor = /* @__PURE__ */ (function(dest2, src2) {
              return function(cursor2) {
                cursor2.insAtDirEnd(-dir, dest2 || src2);
              };
            })(dest, src);
          }
          this.remove();
          if (cursor && cursor[L] === this) {
            if (dir === R && pt) {
              if (pt[L]) {
                cursor.insRightOf(pt[L]);
              } else {
                cursor.insAtLeftEnd(pt.parent);
              }
            } else cursor.insRightOf(thisDir);
          }
          break;
        }
      }
    };
    SupSub2.prototype.finalizeTree = function() {
      if (this.supsub === "sub") {
        this.downInto = this.sub = this.getEnd(L);
        this.sub.upOutOf = insLeftOfMeUnlessAtEnd;
      } else if (this.supsub === "sup") {
        this.upInto = this.sup = this.getEnd(R);
        this.sup.downOutOf = insLeftOfMeUnlessAtEnd;
      }
      var endsL = this.getEnd(L);
      endsL.write = function(cursor, ch) {
        if (cursor.options.autoSubscriptNumerals && this === this.parent.sub && "0123456789".indexOf(ch) >= 0) {
          var cmd = this.chToCmd(ch, cursor.options);
          if (cmd instanceof MQSymbol) cursor.deleteSelection();
          else cursor.clearSelection().insRightOf(this.parent);
          cmd.createLeftOf(cursor.show());
          cursor.controller.aria.queue("Baseline").alert(cmd.mathspeak({ createdLeftOf: cursor }));
          return;
        }
        if (cursor[L] && !cursor[R] && !cursor.selection && cursor.options.charsThatBreakOutOfSupSub.indexOf(ch) > -1) {
          cursor.insRightOf(this.parent);
          cursor.controller.aria.queue("Baseline");
        }
        MathBlock.prototype.write.call(this, cursor, ch);
      };
    };
    SupSub2.prototype.moveTowards = function(dir, cursor, updown) {
      if (cursor.options.autoSubscriptNumerals && !this.sup) {
        cursor.insDirOf(dir, this);
      } else _super.prototype.moveTowards.call(this, dir, cursor, updown);
    };
    SupSub2.prototype.deleteTowards = function(dir, cursor) {
      if (cursor.options.autoSubscriptNumerals && this.sub) {
        var cmd = this.sub.getEnd(-dir);
        if (cmd instanceof MQSymbol) cmd.remove();
        else if (cmd)
          cmd.deleteTowards(dir, cursor.insAtDirEnd(-dir, this.sub));
        if (this.sub.isEmpty()) {
          this.sub.deleteOutOf(L, cursor.insAtLeftEnd(this.sub));
          if (this.sup) cursor.insDirOf(-dir, this);
        }
      } else _super.prototype.deleteTowards.call(this, dir, cursor);
    };
    SupSub2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      if (this.sub) {
        ctx.uncleanedLatex += "_{";
        var beforeLength = ctx.uncleanedLatex.length;
        this.sub.latexRecursive(ctx);
        var afterLength = ctx.uncleanedLatex.length;
        if (beforeLength === afterLength) {
          ctx.uncleanedLatex += " ";
        }
        ctx.uncleanedLatex += "}";
      }
      if (this.sup) {
        ctx.uncleanedLatex += "^{";
        var beforeLength = ctx.uncleanedLatex.length;
        this.sup.latexRecursive(ctx);
        var afterLength = ctx.uncleanedLatex.length;
        if (beforeLength === afterLength) {
          ctx.uncleanedLatex += " ";
        }
        ctx.uncleanedLatex += "}";
      }
      this.checkCursorContextClose(ctx);
    };
    SupSub2.prototype.mathspeak = function(opts) {
      if (this.sup !== void 0) {
        var innerText = getCtrlSeqsFromBlock(this.sup);
        if ((!opts || !opts.ignoreShorthand) && intRgx.test(innerText)) {
          var prefix = "";
          if (this.sub) {
            prefix = subMathspeakTemplate[0] + " " + this.sub.mathspeak() + " " + subMathspeakTemplate[1] + " ";
          }
          return prefix + wholeNumberPower(this.sup, innerText);
        }
      }
      this.mathspeakTemplate = this.getMathspeakTemplate();
      return _super.prototype.mathspeak.call(this);
    };
    SupSub2.prototype.getMathspeakTemplate = function() {
      if (this.sub && this.sup) {
        return supSubMathspeakTemplate;
      } else if (this.sup) {
        return supMathspeakTemplate;
      } else {
        return subMathspeakTemplate;
      }
    };
    SupSub2.prototype.text = function() {
      function text(prefix, block) {
        var l = block && block.text() || "";
        return block ? prefix + (l.length === 1 ? l : "(" + (l || " ") + ")") : "";
      }
      return text("_", this.sub) + text("^", this.sup);
    };
    SupSub2.prototype.addBlock = function(block) {
      if (this.supsub === "sub") {
        this.sup = this.upInto = this.sub.upOutOf = block;
        block.adopt(this, this.sub, 0).downOutOf = this.sub;
        block.setDOM(
          domFrag(h("span", { class: "mq-sup" })).append(block.domFrag().children()).prependTo(this.domFrag().oneElement()).oneElement()
        );
        NodeBase.linkElementByBlockNode(
          block.domFrag().oneElement(),
          block
        );
      } else {
        this.sub = this.downInto = this.sup.downOutOf = block;
        block.adopt(this, 0, this.sup).upOutOf = this.sup;
        this.domFrag().removeClass("mq-sup-only");
        block.setDOM(
          domFrag(h("span", { class: "mq-sub" })).append(block.domFrag().children()).appendTo(this.domFrag().oneElement()).oneElement()
        );
        NodeBase.linkElementByBlockNode(
          block.domFrag().oneElement(),
          block
        );
        this.domFrag().append(
          domFrag(
            h("span", { style: "display:inline-block;width:0" }, [
              h.text(U_ZERO_WIDTH_SPACE)
            ])
          )
        );
      }
      var _loop_4 = function(i2) {
        var cmd = this_4;
        var supsub = ["sub", "sup"][i2];
        var oppositeSupsub = ["sup", "sub"][i2];
        var updown = ["down", "up"][i2];
        var cmdSubSub = cmd[supsub];
        cmdSubSub.deleteOutOf = function(dir, cursor) {
          cursor.insDirOf(this[dir] ? -dir : dir, this.parent);
          if (!this.isEmpty()) {
            var end = this.getEnd(dir);
            this.children().disown().withDirAdopt(
              dir,
              cursor.parent,
              cursor[dir],
              cursor[-dir]
            ).domFrag().insDirOf(-dir, cursor.domFrag());
            cursor[-dir] = end;
          }
          cmd.supsub = oppositeSupsub;
          delete cmd[supsub];
          delete cmd["".concat(updown, "Into")];
          var cmdOppositeSupsub = cmd[oppositeSupsub];
          cmdOppositeSupsub["".concat(updown, "OutOf")] = insLeftOfMeUnlessAtEnd;
          delete cmdOppositeSupsub.deleteOutOf;
          if (supsub === "sub") {
            cmd.domFrag().addClass("mq-sup-only").children().last().remove();
          }
          this.remove();
        };
      };
      var this_4 = this;
      for (var i = 0; i < 2; i += 1) {
        _loop_4(i);
      }
    };
    return SupSub2;
  })(MathCommand)
);
function insLeftOfMeUnlessAtEnd(cursor) {
  var cmd = this.parent;
  var ancestorCmd = cursor;
  do {
    if (ancestorCmd[R]) return cursor.insLeftOf(cmd);
    ancestorCmd = ancestorCmd.parent.parent;
  } while (ancestorCmd !== cmd);
  cursor.insRightOf(cmd);
  return void 0;
}
var subMathspeakTemplate = ["Subscript,", ", Baseline"];
var supMathspeakTemplate = ["Superscript,", ", Baseline"];
var supSubMathspeakTemplate = [
  "Subscript,",
  ", Baseline Superscript,",
  ", Baseline"
];
function wholeNumberPower(sup, innerText) {
  if (innerText === "0") {
    return "to the 0 power";
  } else if (innerText === "2") {
    return "squared";
  } else if (innerText === "3") {
    return "cubed";
  }
  var suffix = "";
  if (/^[+-]?\d{1,3}$/.test(innerText)) {
    if (/(11|12|13|4|5|6|7|8|9|0)$/.test(innerText)) {
      suffix = "th";
    } else if (/1$/.test(innerText)) {
      suffix = "st";
    } else if (/2$/.test(innerText)) {
      suffix = "nd";
    } else if (/3$/.test(innerText)) {
      suffix = "rd";
    }
  }
  var innerMathspeak = typeof sup === "object" ? sup.mathspeak() : innerText;
  return "to the " + innerMathspeak + suffix + " power";
}
LatexCmds.subscript = LatexCmds._ = function() {
  return new SupSub("sub");
};
LatexCmds.superscript = LatexCmds.supscript = LatexCmds["^"] = function() {
  return new SupSub("sup");
};
var SummationNotation = (
  /** @class */
  (function(_super) {
    __extends(SummationNotation2, _super);
    function SummationNotation2(ch, symbol, ariaLabel) {
      var _this_1 = _super.call(this) || this;
      _this_1.ariaLabel = ariaLabel || ch.replace(/^\\/, "");
      var domView = new DOMView(2, function(blocks) {
        return h("span", { class: "mq-large-operator mq-non-leaf" }, [
          h("span", { class: "mq-to" }, [h.block("span", {}, blocks[1])]),
          h("big", {}, [h.text(symbol)]),
          h("span", { class: "mq-from" }, [
            h.block("span", {}, blocks[0])
          ])
        ]);
      });
      MQSymbol.prototype.setCtrlSeqHtmlTextAndMathspeak.call(
        _this_1,
        ch,
        domView
      );
      return _this_1;
    }
    SummationNotation2.prototype.createLeftOf = function(cursor) {
      _super.prototype.createLeftOf.call(this, cursor);
      if (cursor.options.sumStartsWithNEquals) {
        new Letter("n").createLeftOf(cursor);
        new Equality().createLeftOf(cursor);
      }
    };
    SummationNotation2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      ctx.uncleanedLatex += this.ctrlSeq + "_{";
      var beforeLength = ctx.uncleanedLatex.length;
      this.getEnd(L).latexRecursive(ctx);
      var afterLength = ctx.uncleanedLatex.length;
      if (afterLength === beforeLength) {
        ctx.uncleanedLatex += " ";
      }
      ctx.uncleanedLatex += "}^{";
      beforeLength = ctx.uncleanedLatex.length;
      this.getEnd(R).latexRecursive(ctx);
      afterLength = ctx.uncleanedLatex.length;
      if (beforeLength === afterLength) {
        ctx.uncleanedLatex += " ";
      }
      ctx.uncleanedLatex += "}";
      this.checkCursorContextClose(ctx);
    };
    SummationNotation2.prototype.mathspeak = function() {
      return "Start " + this.ariaLabel + " from " + this.getEnd(L).mathspeak() + " to " + this.getEnd(R).mathspeak() + ", end " + this.ariaLabel + ", ";
    };
    SummationNotation2.prototype.parser = function() {
      var string = Parser.string;
      var optWhitespace = Parser.optWhitespace;
      var succeed = Parser.succeed;
      var block = latexMathParser.block;
      var self = this;
      var blocks = self.blocks = [new MathBlock(), new MathBlock()];
      for (var i = 0; i < blocks.length; i += 1) {
        blocks[i].adopt(self, self.getEnd(R), 0);
      }
      return optWhitespace.then(string("_").or(string("^"))).then(function(supOrSub) {
        var child = blocks[supOrSub === "_" ? 0 : 1];
        return block.then(function(block2) {
          block2.children().adopt(child, child.getEnd(R), 0);
          return succeed(self);
        });
      }).many().result(self);
    };
    SummationNotation2.prototype.finalizeTree = function() {
      var endsL = this.getEnd(L);
      var endsR = this.getEnd(R);
      endsL.ariaLabel = "lower bound";
      endsR.ariaLabel = "upper bound";
      this.downInto = endsL;
      this.upInto = endsR;
      endsL.upOutOf = endsR;
      endsR.downOutOf = endsL;
    };
    return SummationNotation2;
  })(MathCommand)
);
LatexCmds["∑"] = LatexCmds.sum = LatexCmds.summation = function() {
  return new SummationNotation("\\sum ", U_NARY_SUMMATION, "sum");
};
LatexCmds["∏"] = LatexCmds.prod = LatexCmds.product = function() {
  return new SummationNotation("\\prod ", U_NARY_PRODUCT, "product");
};
LatexCmds.coprod = LatexCmds.coproduct = function() {
  return new SummationNotation("\\coprod ", U_NARY_COPRODUCT, "co product");
};
LatexCmds["∫"] = LatexCmds["int"] = LatexCmds.integral = /** @class */
(function(_super) {
  __extends(class_11, _super);
  function class_11() {
    var _this_1 = _super.call(this, "\\int ", "", "integral") || this;
    _this_1.ariaLabel = "integral";
    _this_1.domView = new DOMView(2, function(blocks) {
      return h("span", { class: "mq-int mq-non-leaf" }, [
        h("big", {}, [h.text(U_INTEGRAL)]),
        h("span", { class: "mq-supsub mq-non-leaf" }, [
          h("span", { class: "mq-sup" }, [
            h.block(
              "span",
              { class: "mq-sup-inner" },
              blocks[1]
            )
          ]),
          h.block("span", { class: "mq-sub" }, blocks[0]),
          h(
            "span",
            { style: "display:inline-block;width:0" },
            [h.text(U_ZERO_WIDTH_SPACE)]
          )
        ])
      ]);
    });
    return _this_1;
  }
  class_11.prototype.createLeftOf = function(cursor) {
    MathCommand.prototype.createLeftOf.call(this, cursor);
  };
  return class_11;
})(SummationNotation);
var Fraction = LatexCmds.frac = LatexCmds.dfrac = LatexCmds.cfrac = LatexCmds.fraction = /** @class */
(function(_super) {
  __extends(FracNode, _super);
  function FracNode() {
    var _this_1 = _super !== null && _super.apply(this, arguments) || this;
    _this_1.ctrlSeq = "\\frac";
    _this_1.domView = new DOMView(2, function(blocks) {
      return h("span", { class: "mq-fraction mq-non-leaf" }, [
        h.block("span", { class: "mq-numerator" }, blocks[0]),
        h.block("span", { class: "mq-denominator" }, blocks[1]),
        h("span", { style: "display:inline-block;width:0" }, [
          h.text(U_ZERO_WIDTH_SPACE)
        ])
      ]);
    });
    _this_1.textTemplate = ["(", ")/(", ")"];
    return _this_1;
  }
  FracNode.prototype.finalizeTree = function() {
    var endsL = this.getEnd(L);
    var endsR = this.getEnd(R);
    this.upInto = endsR.upOutOf = endsL;
    this.downInto = endsL.downOutOf = endsR;
    endsL.ariaLabel = "numerator";
    endsR.ariaLabel = "denominator";
    if (this.getFracDepth() > 1) {
      this.mathspeakTemplate = [
        "StartNestedFraction,",
        "NestedOver",
        ", EndNestedFraction"
      ];
    } else {
      this.mathspeakTemplate = [
        "StartFraction,",
        "Over",
        ", EndFraction"
      ];
    }
  };
  FracNode.prototype.mathspeak = function(opts) {
    if (opts && opts.createdLeftOf) {
      var cursor = opts.createdLeftOf;
      return cursor.parent.mathspeak();
    }
    var numText = getCtrlSeqsFromBlock(this.getEnd(L));
    var denText = getCtrlSeqsFromBlock(this.getEnd(R));
    if ((!opts || !opts.ignoreShorthand) && intRgx.test(numText) && intRgx.test(denText)) {
      var isSingular = numText === "1" || numText === "-1";
      var newDenSpeech = "";
      if (denText === "2") {
        newDenSpeech = isSingular ? "half" : "halves";
      } else if (denText === "3") {
        newDenSpeech = isSingular ? "third" : "thirds";
      } else if (denText === "4") {
        newDenSpeech = isSingular ? "fourth" : "fourths";
      } else if (denText === "5") {
        newDenSpeech = isSingular ? "fifth" : "fifths";
      } else if (denText === "6") {
        newDenSpeech = isSingular ? "sixth" : "sixths";
      } else if (denText === "7") {
        newDenSpeech = isSingular ? "seventh" : "sevenths";
      } else if (denText === "8") {
        newDenSpeech = isSingular ? "eighth" : "eighths";
      } else if (denText === "9") {
        newDenSpeech = isSingular ? "ninth" : "ninths";
      } else if (denText === "10") {
        newDenSpeech = isSingular ? "tenth" : "tenths";
      } else if (denText === "11") {
        newDenSpeech = isSingular ? "eleventh" : "elevenths";
      } else if (denText === "12") {
        newDenSpeech = isSingular ? "twelfth" : "twelfths";
      } else if (denText === "100") {
        newDenSpeech = isSingular ? "hundredth" : "hundredths";
      }
      if (newDenSpeech !== "") {
        var output = "";
        var precededByInteger = false;
        for (var sibling = this[L]; sibling && sibling[L] !== void 0; sibling = sibling[L]) {
          if (sibling.ctrlSeq === "\\ ") {
            continue;
          } else if (intRgx.test(sibling.ctrlSeq || "")) {
            precededByInteger = true;
          } else {
            precededByInteger = false;
            break;
          }
        }
        if (precededByInteger) {
          output += "and ";
        }
        output += this.getEnd(L).mathspeak() + " " + newDenSpeech;
        return output;
      }
    }
    return _super.prototype.mathspeak.call(this);
  };
  FracNode.prototype.getFracDepth = function() {
    var level = 0;
    var walkUp = function(item, level2) {
      if (item instanceof MQNode && item.ctrlSeq && item.ctrlSeq.toLowerCase().search("frac") >= 0)
        level2 += 1;
      if (item && item.parent) return walkUp(item.parent, level2);
      else return level2;
    };
    return walkUp(this, level);
  };
  return FracNode;
})(MathCommand);
var LiveFraction = LatexCmds.over = CharCmds["/"] = /** @class */
(function(_super) {
  __extends(class_12, _super);
  function class_12() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  class_12.prototype.createLeftOf = function(cursor) {
    if (!this.replacedFragment) {
      var leftward = cursor[L];
      var dontScan = cursor.options.typingSlashCreatesNewFraction && this instanceof Fraction;
      if (!dontScan) {
        while (leftward && !(nodeEndsBinaryOperator(leftward) || leftward instanceof DigitGroupingChar && leftward._groupingClass === "mq-ellipsis-end" || leftward instanceof (LatexCmds.text || noop) || leftward instanceof SummationNotation || leftward.ctrlSeq === "\\ " || /^[,;:]$/.test(leftward.ctrlSeq)))
          leftward = leftward[L];
      }
      if (leftward instanceof SummationNotation && leftward[R] instanceof SupSub) {
        leftward = leftward[R];
        var leftwardR = leftward[R];
        if (leftwardR instanceof SupSub && leftwardR.ctrlSeq != leftward.ctrlSeq)
          leftward = leftward[R];
      }
      if (leftward !== cursor[L] && !cursor.isTooDeep(1)) {
        var leftwardR = leftward[R];
        var cursorL = cursor[L];
        this.replaces(
          new Fragment(
            leftwardR || cursor.parent.getEnd(L),
            cursorL
          )
        );
        cursor[L] = leftward;
      }
    }
    _super.prototype.createLeftOf.call(this, cursor);
  };
  return class_12;
})(Fraction);
var AnsBuilder = function() {
  return new MQSymbol(
    "\\operatorname{ans}",
    h("span", { class: "mq-ans" }, [h.text("ans")]),
    "ans"
  );
};
LatexCmds.ans = AnsBuilder;
var PercentOfBuilder = function() {
  return new MQSymbol(
    "\\%\\operatorname{of}",
    h("span", { class: "mq-nonSymbola mq-operator-name" }, [
      h.text("% of ")
    ]),
    "percent of"
  );
};
LatexCmds.percent = LatexCmds.percentof = PercentOfBuilder;
var Token = (
  /** @class */
  (function(_super) {
    __extends(Token2, _super);
    function Token2() {
      var _this_1 = _super !== null && _super.apply(this, arguments) || this;
      _this_1.tokenId = "";
      _this_1.ctrlSeq = "\\token";
      _this_1.textTemplate = ["token(", ")"];
      _this_1.mathspeakTemplate = ["StartToken,", ", EndToken"];
      _this_1.ariaLabel = "token";
      return _this_1;
    }
    Token2.prototype.html = function() {
      var out = h("span", {
        class: "mq-token mq-ignore-mousedown",
        "data-mq-token": this.tokenId
      });
      this.setDOM(out);
      NodeBase.linkElementByCmdNode(out, this);
      return out;
    };
    Token2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      ctx.uncleanedLatex += "\\token{" + this.tokenId + "}";
      this.checkCursorContextClose(ctx);
    };
    Token2.prototype.mathspeak = function() {
      var ariaLabelArray = [];
      this.domFrag().children().eachElement(function(el) {
        var label = el.getAttribute("aria-label");
        if (typeof label === "string" && label !== "")
          ariaLabelArray.push(label);
      });
      return ariaLabelArray.length > 0 ? ariaLabelArray.join(" ").trim() : "token " + this.tokenId;
    };
    Token2.prototype.parser = function() {
      var self = this;
      return latexMathParser.block.map(function(block) {
        var digit = block.getEnd(L);
        if (digit) {
          self.tokenId += digit.ctrlSeq;
          while (digit = digit[R]) {
            self.tokenId += digit.ctrlSeq;
          }
        }
        return self;
      });
    };
    return Token2;
  })(MQSymbol)
);
LatexCmds.token = Token;
var SquareRoot = (
  /** @class */
  (function(_super) {
    __extends(SquareRoot2, _super);
    function SquareRoot2() {
      var _this_1 = _super !== null && _super.apply(this, arguments) || this;
      _this_1.ctrlSeq = "\\sqrt";
      _this_1.domView = new DOMView(1, function(blocks) {
        return h("span", { class: "mq-non-leaf mq-sqrt-container" }, [
          h("span", { class: "mq-scaled mq-sqrt-prefix" }, [
            SVG_SYMBOLS.sqrt.html()
          ]),
          h.block(
            "span",
            { class: "mq-non-leaf mq-sqrt-stem" },
            blocks[0]
          )
        ]);
      });
      _this_1.textTemplate = ["sqrt(", ")"];
      _this_1.mathspeakTemplate = ["StartRoot,", ", EndRoot"];
      _this_1.ariaLabel = "root";
      return _this_1;
    }
    SquareRoot2.prototype.parser = function() {
      return latexMathParser.optBlock.then(function(optBlock) {
        return latexMathParser.block.map(function(block) {
          var nthroot = new NthRoot();
          nthroot.blocks = [optBlock, block];
          optBlock.adopt(nthroot, 0, 0);
          block.adopt(nthroot, optBlock, 0);
          return nthroot;
        });
      }).or(_super.prototype.parser.call(this));
    };
    SquareRoot2.prototype.deleteTowards = function(dir, cursor) {
      if (!this.isEmpty() && dir === 1) {
        this.moveTowards(R, cursor);
        cursor.parent.deleteOutOf(L, cursor);
        return;
      }
      _super.prototype.deleteTowards.call(this, dir, cursor);
    };
    return SquareRoot2;
  })(MathCommand)
);
LatexCmds.sqrt = CharCmds["√"] = SquareRoot;
LatexCmds.hat = /** @class */
(function(_super) {
  __extends(Hat, _super);
  function Hat() {
    var _this_1 = _super !== null && _super.apply(this, arguments) || this;
    _this_1.ctrlSeq = "\\hat";
    _this_1.domView = new DOMView(1, function(blocks) {
      return h("span", { class: "mq-non-leaf" }, [
        h("span", { class: "mq-hat-prefix" }, [h.text("^")]),
        h.block("span", { class: "mq-hat-stem" }, blocks[0])
      ]);
    });
    _this_1.textTemplate = ["hat(", ")"];
    return _this_1;
  }
  return Hat;
})(MathCommand);
var NthRoot = (
  /** @class */
  (function(_super) {
    __extends(NthRoot2, _super);
    function NthRoot2() {
      var _this_1 = _super !== null && _super.apply(this, arguments) || this;
      _this_1.domView = new DOMView(2, function(blocks) {
        return h("span", { class: "mq-nthroot-container mq-non-leaf" }, [
          h.block("sup", { class: "mq-nthroot mq-non-leaf" }, blocks[0]),
          h("span", { class: "mq-scaled mq-sqrt-container" }, [
            h("span", { class: "mq-sqrt-prefix mq-scaled" }, [
              SVG_SYMBOLS.sqrt.html()
            ]),
            h.block(
              "span",
              { class: "mq-sqrt-stem mq-non-leaf" },
              blocks[1]
            )
          ])
        ]);
      });
      _this_1.textTemplate = ["sqrt[", "](", ")"];
      return _this_1;
    }
    NthRoot2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      ctx.uncleanedLatex += "\\sqrt[";
      this.getEnd(L).latexRecursive(ctx);
      ctx.uncleanedLatex += "]{";
      this.getEnd(R).latexRecursive(ctx);
      ctx.uncleanedLatex += "}";
      this.checkCursorContextClose(ctx);
    };
    NthRoot2.prototype.mathspeak = function() {
      var indexMathspeak = this.getEnd(L).mathspeak();
      var radicandMathspeak = this.getEnd(R).mathspeak();
      this.getEnd(L).ariaLabel = "Index";
      this.getEnd(R).ariaLabel = "Radicand";
      if (indexMathspeak === "3") {
        return "Start Cube Root, " + radicandMathspeak + ", End Cube Root";
      } else {
        return "Root Index " + indexMathspeak + ", Start Root, " + radicandMathspeak + ", End Root";
      }
    };
    NthRoot2.prototype.deleteTowards = function(dir, cursor) {
      MathCommand.prototype.deleteTowards.call(this, dir, cursor);
    };
    return NthRoot2;
  })(SquareRoot)
);
LatexCmds.nthroot = NthRoot;
LatexCmds.cbrt = /** @class */
(function(_super) {
  __extends(class_13, _super);
  function class_13() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  class_13.prototype.createLeftOf = function(cursor) {
    _super.prototype.createLeftOf.call(this, cursor);
    new Digit("3").createLeftOf(cursor);
    cursor.controller.moveRight();
  };
  return class_13;
})(NthRoot);
var DiacriticAbove = (
  /** @class */
  (function(_super) {
    __extends(DiacriticAbove2, _super);
    function DiacriticAbove2(ctrlSeq, html, textTemplate) {
      var domView = new DOMView(1, function(blocks) {
        return h("span", { class: "mq-non-leaf" }, [
          h("span", { class: "mq-diacritic-above" }, [html]),
          h.block("span", { class: "mq-diacritic-stem" }, blocks[0])
        ]);
      });
      return _super.call(this, ctrlSeq, domView, textTemplate) || this;
    }
    return DiacriticAbove2;
  })(MathCommand)
);
LatexCmds.vec = function() {
  return new DiacriticAbove("\\vec", h.entityText("&rarr;"), ["vec(", ")"]);
};
LatexCmds.tilde = function() {
  return new DiacriticAbove("\\tilde", h.text("~"), ["tilde(", ")"]);
};
var DelimsNode = (
  /** @class */
  (function(_super) {
    __extends(DelimsNode2, _super);
    function DelimsNode2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    DelimsNode2.prototype.setDOM = function(el) {
      var _c;
      _super.prototype.setDOM.call(this, el);
      var children = this.domFrag().children();
      if (!children.isEmpty()) {
        this.delimFrags = (_c = {}, _c[L] = children.first(), _c[R] = children.last(), _c);
      }
      return this;
    };
    return DelimsNode2;
  })(MathCommand)
);
var Bracket = (
  /** @class */
  (function(_super) {
    __extends(Bracket2, _super);
    function Bracket2(side, open, close, ctrlSeq, end) {
      var _c;
      var _this_1 = _super.call(this, "\\left" + ctrlSeq, void 0, [open, close]) || this;
      _this_1.side = side;
      _this_1.sides = (_c = {}, _c[L] = { ch: open, ctrlSeq }, _c[R] = { ch: close, ctrlSeq: end }, _c);
      return _this_1;
    }
    Bracket2.prototype.numBlocks = function() {
      return 1;
    };
    Bracket2.prototype.html = function() {
      var _this_1 = this;
      var leftSymbol = this.getSymbol(L);
      var rightSymbol = this.getSymbol(R);
      this.domView = new DOMView(1, function(blocks) {
        return h(
          // be set by createLeftOf or parser
          "span",
          { class: "mq-non-leaf mq-bracket-container" },
          [
            h(
              "span",
              {
                style: "width:" + leftSymbol.width,
                class: "mq-scaled mq-bracket-l mq-paren" + (_this_1.side === R ? " mq-ghost" : "")
              },
              [leftSymbol.html()]
            ),
            h.block(
              "span",
              {
                style: "margin-left:" + leftSymbol.width + ";margin-right:" + rightSymbol.width,
                class: "mq-bracket-middle mq-non-leaf"
              },
              blocks[0]
            ),
            h(
              "span",
              {
                style: "width:" + rightSymbol.width,
                class: "mq-scaled mq-bracket-r mq-paren" + (_this_1.side === L ? " mq-ghost" : "")
              },
              [rightSymbol.html()]
            )
          ]
        );
      });
      return _super.prototype.html.call(this);
    };
    Bracket2.prototype.getSymbol = function(side) {
      var ch = this.sides[side || R].ch;
      return SVG_SYMBOLS[ch] || { width: "0", html: "" };
    };
    Bracket2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      ctx.uncleanedLatex += "\\left" + this.sides[L].ctrlSeq;
      this.getEnd(L).latexRecursive(ctx);
      ctx.uncleanedLatex += "\\right" + this.sides[R].ctrlSeq;
      this.checkCursorContextClose(ctx);
    };
    Bracket2.prototype.mathspeak = function(opts) {
      var open = this.sides[L].ch, close = this.sides[R].ch;
      if (open === "|" && close === "|") {
        this.mathspeakTemplate = [
          "StartAbsoluteValue,",
          ", EndAbsoluteValue"
        ];
        this.ariaLabel = "absolute value";
      } else if (opts && opts.createdLeftOf && this.side) {
        var ch = "";
        if (this.side === L) ch = this.textTemplate[0];
        else if (this.side === R) ch = this.textTemplate[1];
        return (this.side === L ? "left " : "right ") + BRACKET_NAMES[ch];
      } else {
        this.mathspeakTemplate = [
          "left " + BRACKET_NAMES[open] + ",",
          ", right " + BRACKET_NAMES[close]
        ];
        this.ariaLabel = BRACKET_NAMES[open] + " block";
      }
      return _super.prototype.mathspeak.call(this);
    };
    Bracket2.prototype.matchBrack = function(opts, expectedSide, node) {
      return node instanceof Bracket2 && node.side && node.side !== -expectedSide && (!opts.restrictMismatchedBrackets || OPP_BRACKS[this.sides[this.side].ch] === node.sides[node.side].ch || // if restrictMismatchedBrackets is "none" instead of true, don't allow mismatched range brackets
      opts.restrictMismatchedBrackets !== "none" && { "(": "]", "[": ")" }[this.sides[L].ch] === node.sides[R].ch) && node;
    };
    Bracket2.prototype.closeOpposing = function(brack) {
      brack.side = 0;
      brack.sides[this.side] = this.sides[this.side];
      var brackFrag = brack.delimFrags[this.side === L ? L : R].removeClass("mq-ghost");
      this.replaceBracket(brackFrag, this.side);
    };
    Bracket2.prototype.createLeftOf = function(cursor) {
      var brack;
      if (!this.replacedFragment) {
        var opts = cursor.options;
        if (this.sides[L].ch === "|") {
          brack = this.matchBrack(opts, R, cursor[R]) || this.matchBrack(opts, L, cursor[L]) || this.matchBrack(opts, 0, cursor.parent.parent);
        } else {
          brack = this.matchBrack(opts, -this.side, cursor[-this.side]) || this.matchBrack(opts, -this.side, cursor.parent.parent);
        }
      }
      if (brack) {
        var side = this.side = -brack.side;
        this.closeOpposing(brack);
        if (brack === cursor.parent.parent && cursor[side]) {
          new Fragment(cursor[side], cursor.parent.getEnd(side), -side).disown().withDirAdopt(-side, brack.parent, brack, brack[side]).domFrag().insDirOf(side, brack.domFrag());
        }
        brack.bubble(function(node) {
          node.reflow();
          return void 0;
        });
      } else {
        brack = this, side = brack.side;
        if (brack.replacedFragment) brack.side = 0;
        else if (cursor[-side]) {
          brack.replaces(
            new Fragment(
              cursor[-side],
              cursor.parent.getEnd(-side),
              side
            )
          );
          cursor[-side] = 0;
        }
        _super.prototype.createLeftOf.call(this, cursor);
      }
      if (side === L) cursor.insAtLeftEnd(brack.getEnd(L));
      else cursor.insRightOf(brack);
    };
    Bracket2.prototype.placeCursor = function() {
    };
    Bracket2.prototype.unwrap = function() {
      this.getEnd(L).children().disown().adopt(this.parent, this, this[R]).domFrag().insertAfter(this.domFrag());
      this.remove();
    };
    Bracket2.prototype.deleteSide = function(side, outward, cursor) {
      var parent = this.parent, sib = this[side], farEnd = parent.getEnd(side);
      if (side === this.side) {
        this.unwrap();
        sib ? cursor.insDirOf(-side, sib) : cursor.insAtDirEnd(side, parent);
        return;
      }
      var opts = cursor.options, wasSolid = !this.side;
      this.side = -side;
      if (this.matchBrack(opts, side, this.getEnd(L).getEnd(this.side))) {
        this.closeOpposing(this.getEnd(L).getEnd(this.side));
        var origEnd = this.getEnd(L).getEnd(side);
        this.unwrap();
        if (origEnd) origEnd.siblingCreated(cursor.options, side);
        if (sib) {
          cursor.insDirOf(-side, sib);
        } else {
          cursor.insAtDirEnd(side, parent);
        }
      } else {
        if (this.matchBrack(opts, side, this.parent.parent)) {
          this.parent.parent.closeOpposing(this);
          this.parent.parent.unwrap();
        } else if (outward && wasSolid) {
          this.unwrap();
          sib ? cursor.insDirOf(-side, sib) : cursor.insAtDirEnd(side, parent);
          return;
        } else {
          this.sides[side] = getOppBracketSide(this);
          this.delimFrags[L].removeClass("mq-ghost");
          this.delimFrags[R].removeClass("mq-ghost");
          var brackFrag = this.delimFrags[side].addClass("mq-ghost");
          this.replaceBracket(brackFrag, side);
        }
        if (sib) {
          var leftEnd = this.getEnd(L);
          var origEnd = leftEnd.getEnd(side);
          leftEnd.domFrag().removeClass("mq-empty");
          new Fragment(sib, farEnd, -side).disown().withDirAdopt(-side, leftEnd, origEnd, 0).domFrag().insAtDirEnd(side, leftEnd.domFrag().oneElement());
          if (origEnd) origEnd.siblingCreated(cursor.options, side);
          cursor.insDirOf(-side, sib);
        } else
          outward ? cursor.insDirOf(side, this) : cursor.insAtDirEnd(side, this.getEnd(L));
      }
    };
    Bracket2.prototype.replaceBracket = function(brackFrag, side) {
      var symbol = this.getSymbol(side);
      brackFrag.children().replaceWith(domFrag(symbol.html()));
      brackFrag.oneElement().style.width = symbol.width;
      if (side === L) {
        var next = brackFrag.next();
        if (!next.isEmpty()) {
          next.oneElement().style.marginLeft = symbol.width;
        }
      } else {
        var prev = brackFrag.prev();
        if (!prev.isEmpty()) {
          prev.oneElement().style.marginRight = symbol.width;
        }
      }
    };
    Bracket2.prototype.deleteTowards = function(dir, cursor) {
      this.deleteSide(-dir, false, cursor);
    };
    Bracket2.prototype.finalizeTree = function() {
      this.getEnd(L).deleteOutOf = function(dir, cursor) {
        this.parent.deleteSide(dir, true, cursor);
      };
      this.finalizeTree = this.intentionalBlur = function() {
        this.delimFrags[this.side === L ? R : L].removeClass("mq-ghost");
        this.side = 0;
      };
    };
    Bracket2.prototype.siblingCreated = function(_opts, dir) {
      if (dir === -this.side) this.finalizeTree();
    };
    return Bracket2;
  })(DelimsNode)
);
function getOppBracketSide(bracket) {
  var side = bracket.side;
  var data = bracket.sides[side];
  return {
    ch: OPP_BRACKS[data.ch],
    ctrlSeq: OPP_BRACKS[data.ctrlSeq]
  };
}
var OPP_BRACKS = {
  "(": ")",
  ")": "(",
  "[": "]",
  "]": "[",
  "{": "}",
  "}": "{",
  "\\{": "\\}",
  "\\}": "\\{",
  "&lang;": "&rang;",
  "&rang;": "&lang;",
  "\\langle ": "\\rangle ",
  "\\rangle ": "\\langle ",
  "|": "|",
  "\\lVert ": "\\rVert ",
  "\\rVert ": "\\lVert "
};
var BRACKET_NAMES = {
  "&lang;": "angle-bracket",
  "&rang;": "angle-bracket",
  "|": "pipe"
};
function bindCharBracketPair(open, ctrlSeq, name) {
  var ctrlSeq = ctrlSeq || open;
  var close = OPP_BRACKS[open];
  var end = OPP_BRACKS[ctrlSeq];
  CharCmds[open] = function() {
    return new Bracket(L, open, close, ctrlSeq, end);
  };
  CharCmds[close] = function() {
    return new Bracket(R, open, close, ctrlSeq, end);
  };
  BRACKET_NAMES[open] = BRACKET_NAMES[close] = name;
}
bindCharBracketPair("(", "", "parenthesis");
bindCharBracketPair("[", "", "bracket");
bindCharBracketPair("{", "\\{", "brace");
LatexCmds.langle = function() {
  return new Bracket(L, "&lang;", "&rang;", "\\langle ", "\\rangle ");
};
LatexCmds.rangle = function() {
  return new Bracket(R, "&lang;", "&rang;", "\\langle ", "\\rangle ");
};
CharCmds["|"] = function() {
  return new Bracket(L, "|", "|", "|", "|");
};
LatexCmds.lVert = function() {
  return new Bracket(L, "&#8741;", "&#8741;", "\\lVert ", "\\rVert ");
};
LatexCmds.rVert = function() {
  return new Bracket(R, "&#8741;", "&#8741;", "\\lVert ", "\\rVert ");
};
LatexCmds.left = /** @class */
(function(_super) {
  __extends(left, _super);
  function left() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  left.prototype.parser = function() {
    var regex = Parser.regex;
    var string = Parser.string;
    var optWhitespace = Parser.optWhitespace;
    return optWhitespace.then(
      regex(
        /^(?:[([|]|\\\{|\\langle(?![a-zA-Z])|\\lVert(?![a-zA-Z]))/
      )
    ).then(function(ctrlSeq) {
      var open = ctrlSeq.replace(/^\\/, "");
      if (ctrlSeq == "\\langle") {
        open = "&lang;";
        ctrlSeq = ctrlSeq + " ";
      }
      if (ctrlSeq == "\\lVert") {
        open = "&#8741;";
        ctrlSeq = ctrlSeq + " ";
      }
      return latexMathParser.then(function(block) {
        return string("\\right").skip(optWhitespace).then(
          regex(
            /^(?:[\])|]|\\\}|\\rangle(?![a-zA-Z])|\\rVert(?![a-zA-Z]))/
          )
        ).map(function(end) {
          var close = end.replace(/^\\/, "");
          if (end == "\\rangle") {
            close = "&rang;";
            end = end + " ";
          }
          if (end == "\\rVert") {
            close = "&#8741;";
            end = end + " ";
          }
          var cmd = new Bracket(0, open, close, ctrlSeq, end);
          cmd.blocks = [block];
          block.adopt(cmd, 0, 0);
          return cmd;
        });
      });
    });
  };
  return left;
})(MathCommand);
LatexCmds.right = /** @class */
(function(_super) {
  __extends(right, _super);
  function right() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  right.prototype.parser = function() {
    return Parser.fail("unmatched \\right");
  };
  return right;
})(MathCommand);
var leftBinomialSymbol = SVG_SYMBOLS["("];
var rightBinomialSymbol = SVG_SYMBOLS[")"];
var Binomial = (
  /** @class */
  (function(_super) {
    __extends(Binomial2, _super);
    function Binomial2() {
      var _this_1 = _super !== null && _super.apply(this, arguments) || this;
      _this_1.ctrlSeq = "\\binom";
      _this_1.domView = new DOMView(2, function(blocks) {
        return h("span", { class: "mq-non-leaf mq-bracket-container" }, [
          h(
            "span",
            {
              style: "width:" + leftBinomialSymbol.width,
              class: "mq-paren mq-bracket-l mq-scaled"
            },
            [leftBinomialSymbol.html()]
          ),
          h(
            "span",
            {
              style: "margin-left:" + leftBinomialSymbol.width + "; margin-right:" + rightBinomialSymbol.width,
              class: "mq-non-leaf mq-bracket-middle"
            },
            [
              h("span", { class: "mq-array mq-non-leaf" }, [
                h.block("span", {}, blocks[0]),
                h.block("span", {}, blocks[1])
              ])
            ]
          ),
          h(
            "span",
            {
              style: "width:" + rightBinomialSymbol.width,
              class: "mq-paren mq-bracket-r mq-scaled"
            },
            [rightBinomialSymbol.html()]
          )
        ]);
      });
      _this_1.textTemplate = ["choose(", ",", ")"];
      _this_1.mathspeakTemplate = [
        "StartBinomial,",
        "Choose",
        ", EndBinomial"
      ];
      _this_1.ariaLabel = "binomial";
      return _this_1;
    }
    Binomial2.prototype.finalizeTree = function() {
      var endsL = this.getEnd(L);
      var endsR = this.getEnd(R);
      this.upInto = endsR.upOutOf = endsL;
      this.downInto = endsL.downOutOf = endsR;
      endsL.ariaLabel = "upper index";
      endsR.ariaLabel = "lower index";
    };
    return Binomial2;
  })(DelimsNode)
);
LatexCmds.binom = LatexCmds.binomial = Binomial;
LatexCmds.choose = /** @class */
(function(_super) {
  __extends(class_14, _super);
  function class_14() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  class_14.prototype.createLeftOf = function(cursor) {
    LiveFraction.prototype.createLeftOf.call(this, cursor);
  };
  return class_14;
})(Binomial);
var MathFieldNode = (
  /** @class */
  (function(_super) {
    __extends(MathFieldNode2, _super);
    function MathFieldNode2() {
      var _this_1 = _super !== null && _super.apply(this, arguments) || this;
      _this_1.ctrlSeq = "\\MathQuillMathField";
      _this_1.domView = new DOMView(1, function(blocks) {
        return h("span", { class: "mq-editable-field" }, [
          h.block(
            "span",
            { class: "mq-root-block", "aria-hidden": "true" },
            blocks[0]
          )
        ]);
      });
      return _this_1;
    }
    MathFieldNode2.prototype.parser = function() {
      var self = this, string = Parser.string, regex = Parser.regex, succeed = Parser.succeed;
      return string("[").then(regex(/^[a-z][a-z0-9]*/i)).skip(string("]")).map(function(name) {
        self.name = name;
      }).or(succeed(void 0)).then(_super.prototype.parser.call(this));
    };
    MathFieldNode2.prototype.finalizeTree = function(options) {
      var ctrlr = new Controller(
        this.getEnd(L),
        this.domFrag().oneElement(),
        options
      );
      ctrlr.KIND_OF_MQ = "MathField";
      ctrlr.editable = true;
      ctrlr.createTextarea();
      ctrlr.editablesTextareaEvents();
      ctrlr.cursor.insAtRightEnd(ctrlr.root);
      RootBlockMixin(ctrlr.root);
      function pushDownAriaHidden(node) {
        if (node.parentNode && !domFrag(node).hasClass("mq-root-block")) {
          pushDownAriaHidden(node.parentNode);
        }
        if (node.nodeType === Node.ELEMENT_NODE) {
          var element = node;
          if (element.getAttribute("aria-hidden") === "true") {
            element.removeAttribute("aria-hidden");
            domFrag(node).children().eachElement(function(child) {
              child.setAttribute("aria-hidden", "true");
            });
          }
        }
      }
      pushDownAriaHidden(this.domFrag().parent().oneElement());
      this.domFrag().oneElement().removeAttribute("aria-hidden");
    };
    MathFieldNode2.prototype.registerInnerField = function(innerFields, MathField) {
      var controller = this.getEnd(L).controller;
      var newField = new MathField(controller);
      innerFields[this.name] = newField;
      innerFields.push(newField);
    };
    MathFieldNode2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      this.getEnd(L).latexRecursive(ctx);
      this.checkCursorContextClose(ctx);
    };
    MathFieldNode2.prototype.text = function() {
      return this.getEnd(L).text();
    };
    return MathFieldNode2;
  })(MathCommand)
);
LatexCmds.editable = LatexCmds.MathQuillMathField = MathFieldNode;
var EmbedNode = (
  /** @class */
  (function(_super) {
    __extends(EmbedNode2, _super);
    function EmbedNode2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    EmbedNode2.prototype.setOptions = function(options) {
      function noop2() {
        return "";
      }
      this.text = options.text || noop2;
      this.domView = new DOMView(0, function() {
        return h("span", {}, [parseHTML(options.htmlString || "")]);
      });
      this.latex = options.latex || noop2;
      return this;
    };
    EmbedNode2.prototype.latexRecursive = function(ctx) {
      this.checkCursorContextOpen(ctx);
      ctx.uncleanedLatex += this.latex();
      this.checkCursorContextClose(ctx);
    };
    EmbedNode2.prototype.parser = function() {
      var self = this, string = Parser.string, regex = Parser.regex, succeed = Parser.succeed;
      return string("{").then(regex(/^[a-z][a-z0-9]*/i)).skip(string("}")).then(function(name) {
        return string("[").then(regex(/^[-\w\s]*/)).skip(string("]")).or(succeed(void 0)).map(function(data) {
          return self.setOptions(EMBEDS[name](data));
        });
      });
    };
    return EmbedNode2;
  })(MQSymbol)
);
LatexCmds.embed = EmbedNode;
CharCmds["\\"] = /** @class */
(function(_super) {
  __extends(LatexCommandInput, _super);
  function LatexCommandInput() {
    var _this_1 = _super !== null && _super.apply(this, arguments) || this;
    _this_1.ctrlSeq = "\\";
    _this_1.domView = new DOMView(1, function(blocks) {
      return h(
        "span",
        { class: "mq-latex-command-input-wrapper mq-non-leaf" },
        [
          h("span", { class: "mq-latex-command-input mq-non-leaf" }, [
            h.text("\\"),
            h.block("span", {}, blocks[0])
          ])
        ]
      );
    });
    _this_1.textTemplate = ["\\"];
    return _this_1;
  }
  LatexCommandInput.prototype.replaces = function(replacedFragment) {
    this._replacedFragment = replacedFragment.disown();
    this.isEmpty = function() {
      return false;
    };
  };
  LatexCommandInput.prototype.createBlocks = function() {
    _super.prototype.createBlocks.call(this);
    var endsL = this.getEnd(L);
    endsL.focus = function() {
      this.parent.domFrag().addClass("mq-hasCursor");
      if (this.isEmpty()) this.parent.domFrag().removeClass("mq-empty");
      return this;
    };
    endsL.blur = function() {
      this.parent.domFrag().removeClass("mq-hasCursor");
      if (this.isEmpty()) this.parent.domFrag().addClass("mq-empty");
      return this;
    };
    endsL.write = function(cursor, ch) {
      cursor.show().deleteSelection();
      if (ch.match(/[a-z]/i)) {
        new VanillaSymbol(ch).createLeftOf(cursor);
        cursor.controller.aria.alert(ch);
      } else {
        var cmd = this.parent.renderCommand(cursor);
        cursor.controller.aria.queue(
          cmd.mathspeak({ createdLeftOf: cursor })
        );
        if (ch !== "\\" || !this.isEmpty())
          cursor.parent.write(cursor, ch);
        else cursor.controller.aria.alert();
      }
    };
    var originalKeystroke = endsL.keystroke;
    endsL.keystroke = function(key, e, ctrlr) {
      if (key === "Tab" || key === "Enter" || key === "Spacebar") {
        var cmd = this.parent.renderCommand(ctrlr.cursor);
        ctrlr.aria.alert(
          cmd.mathspeak({ createdLeftOf: ctrlr.cursor })
        );
        e === null || e === void 0 ? void 0 : e.preventDefault();
        return;
      }
      return originalKeystroke.call(this, key, e, ctrlr);
    };
  };
  LatexCommandInput.prototype.createLeftOf = function(cursor) {
    _super.prototype.createLeftOf.call(this, cursor);
    if (this._replacedFragment) {
      var frag = this.domFrag();
      var el_1 = frag.oneElement();
      this._replacedFragment.domFrag().addClass("mq-blur");
      var rewriteMousedownEventTarget = function(e) {
        {
          e.target = el_1;
          el_1.dispatchEvent(e);
          return false;
        }
      };
      el_1.addEventListener("mousedown", rewriteMousedownEventTarget);
      el_1.addEventListener("mouseup", rewriteMousedownEventTarget);
      this._replacedFragment.domFrag().insertBefore(frag.children().first());
    }
  };
  LatexCommandInput.prototype.latexRecursive = function(ctx) {
    this.checkCursorContextOpen(ctx);
    ctx.uncleanedLatex += "\\";
    this.getEnd(L).latexRecursive(ctx);
    ctx.uncleanedLatex += " ";
    this.checkCursorContextClose(ctx);
  };
  LatexCommandInput.prototype.renderCommand = function(cursor) {
    this.setDOM(this.domFrag().children().lastElement());
    this.remove();
    if (this[R]) {
      cursor.insLeftOf(this[R]);
    } else {
      cursor.insAtRightEnd(this.parent);
    }
    var latex = this.getEnd(L).latex();
    if (!latex) latex = " ";
    var cmd = LatexCmds[latex];
    if (cmd) {
      var node = void 0;
      if (isMQNodeClass(cmd)) {
        node = new cmd(latex);
      } else {
        node = cmd(latex);
      }
      if (this._replacedFragment) node.replaces(this._replacedFragment);
      node.createLeftOf(cursor);
      return node;
    } else {
      var node = new TextBlock();
      node.replaces(latex);
      node.createLeftOf(cursor);
      cursor.insRightOf(node);
      if (this._replacedFragment) {
        this._replacedFragment.remove();
      }
      return node;
    }
  };
  return LatexCommandInput;
})(MathCommand);
if (window.jQuery) {
  MQ1 = getInterface(1);
  for (var key in MQ1)
    (function(key2, val) {
      if (typeof val === "function") {
        MathQuill[key2] = function() {
          insistOnInterVer();
          return val.apply(this, arguments);
        };
        MathQuill[key2].prototype = val.prototype;
      } else MathQuill[key2] = val;
    })(key, MQ1[key]);
}
const MQ = MathQuill.getInterface(3);
const EditableMathField = ({
  latex,
  onChange,
  config,
  mathquillDidMount,
  ...otherProps
}) => {
  const ignoreEditEvents = useRef(2);
  const mathField = useRef(null);
  const wrapperElement = useRef(null);
  const onChangeRef = useRef(onChange);
  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  useEffect(() => {
    if (!wrapperElement.current) return;
    let combinedConfig = {
      restrictMismatchedBrackets: true,
      handlers: {}
    };
    if (config) {
      combinedConfig = {
        ...combinedConfig,
        ...config
      };
    }
    const configEditHandler = combinedConfig.handlers.edit;
    combinedConfig.handlers.edit = (mathField2) => {
      if (configEditHandler) configEditHandler();
      if (ignoreEditEvents.current > 0) {
        ignoreEditEvents.current -= 1;
      } else {
        if (onChangeRef.current) onChangeRef.current(mathField2);
      }
    };
    mathField.current = MQ.MathField(
      wrapperElement.current,
      combinedConfig
    );
    mathField.current.latex(latex || "");
    if (mathquillDidMount) mathquillDidMount(mathField.current);
  }, [wrapperElement]);
  useEffect(() => {
    if (mathField.current && mathField.current.latex() !== latex) {
      mathField.current.latex(latex);
    }
  }, [latex]);
  const ariaLabel = otherProps.ariaLabel;
  delete otherProps.ariaLabel;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { ...otherProps, "aria-label": ariaLabel, ref: wrapperElement });
};
EditableMathField.propTypes = {
  latex: PropTypes.string,
  onChange: PropTypes.func,
  config: PropTypes.object,
  mathquillDidMount: PropTypes.func
};
function MathInput(props) {
  let { id, SVs, actions, ignoreUpdate, callAction } = useDoenetRenderer(props);
  MathInput.baseStateVariable = "rawRendererValue";
  const virtualKeyboardEvents = useAppSelector(
    keyboardSlice.selectors.keyboardInput
  );
  const focusedMathInput = useContext(FocusedMathInputContext);
  const [mathField, setMathField] = useState(null);
  const mathFieldRef = useRef(null);
  mathFieldRef.current = mathField;
  const [focused, setFocused] = useState(null);
  const textareaRef = useRef(null);
  const lastKeyboardAccessTime = useRef(0);
  const lastBlurTime = useRef(0);
  const keyboardCausedBlur = useRef(false);
  const rendererValue = useRef(SVs.rawRendererValue);
  const showCheckWork = useRef(SVs.showCheckWork);
  showCheckWork.current = SVs.showCheckWork;
  if (!ignoreUpdate) {
    rendererValue.current = SVs.rawRendererValue;
  }
  let validationState = useRef("unvalidated");
  const updateValidationState = () => {
    validationState.current = calculateValidationState(SVs);
  };
  const submitAnswer = () => callAction({
    action: actions.submitAnswer
  });
  const handlePressEnter = React__default.useCallback(() => {
    if (!mathFieldRef.current) {
      return;
    }
    callAction({
      action: actions.updateValue,
      baseVariableValue: rendererValue.current
    });
    if (showCheckWork.current && validationState.current === "unvalidated") {
      submitAnswer();
    }
  }, [callAction, mathField]);
  React__default.useEffect(() => {
    if (!mathField || focusedMathInput.current !== mathField.el()) {
      return;
    }
    for (const event of virtualKeyboardEvents) {
      if (event.type === "keystroke" && event.command === "Enter") {
        callAction({
          action: actions.updateValue,
          baseVariableValue: rendererValue.current
        });
        if (showCheckWork.current && validationState.current === "unvalidated") {
          submitAnswer();
        }
        continue;
      }
      if (event.type === "accessed") {
        lastKeyboardAccessTime.current = event.timestamp || 0;
        if (Math.abs(
          lastKeyboardAccessTime.current - lastBlurTime.current
        ) < 100) {
          keyboardCausedBlur.current = true;
        }
      }
      if (keyboardCausedBlur.current) {
        switch (event.type) {
          case "accessed":
            break;
          case "cmd":
            mathField.cmd(event.command);
            break;
          case "write":
            mathField.write(event.command);
            break;
          case "keystroke":
            mathField.keystroke(event.command);
            break;
          case "type":
            mathField.typedText(event.command);
            break;
          default:
            console.warn(
              `Unknown event type: ${event.type} in MathInput`,
              event
            );
            break;
        }
      }
    }
    if (keyboardCausedBlur.current) {
      mathField.focus();
    }
  }, [virtualKeyboardEvents]);
  const handleFocus = (e) => {
    if (mathField) {
      focusedMathInput.current = mathField.el();
    }
    setFocused(true);
  };
  const handleBlur = (e) => {
    lastBlurTime.current = +/* @__PURE__ */ new Date();
    keyboardCausedBlur.current = Math.abs(lastKeyboardAccessTime.current - lastBlurTime.current) < 100;
    if (!keyboardCausedBlur.current) {
      callAction({
        action: actions.updateValue,
        baseVariableValue: rendererValue.current
      });
      setFocused(false);
    }
  };
  const onChangeHandler = (text) => {
    if (text.replace(/\s/g, "").replace(/\^{(\w)}/g, "^$1") !== rendererValue.current?.replace(/\s/g, "").replace(/\^{(\w)}/g, "^$1")) {
      rendererValue.current = text;
      callAction({
        action: actions.updateRawValue,
        args: {
          rawRendererValue: text
        },
        baseVariableValue: text
      });
    }
  };
  if (SVs.hidden) {
    return null;
  }
  updateValidationState();
  let mathInputStyle = {
    /* Set each border attribute separately since the borderColor is updated during rerender (checking mathInput's disabled state)
    Currently does not work with border: "var(--mainBorder)" */
    borderColor: "var(--canvasText)",
    borderStyle: "solid",
    borderWidth: "2px",
    margin: "0px",
    boxShadow: "none",
    outlineOffset: "2px",
    outlineColor: "var(--canvasText)",
    outlineWidth: "2px",
    backgroundColor: "var(--canvas)",
    minWidth: `${SVs.minWidth > 0 ? SVs.minWidth : 0}px`
  };
  if (focused) {
    mathInputStyle.outlineStyle = "solid";
  }
  let mathInputWrapperCursor = "allowed";
  if (SVs.disabled) {
    mathInputStyle.borderColor = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--mainGray");
    mathInputStyle.backgroundColor = "rgba(239, 239, 239, 0.3)";
    mathInputStyle.pointerEvents = "none";
    mathInputWrapperCursor = "not-allowed";
  }
  if (textareaRef.current && textareaRef.current.disabled !== SVs.disabled) {
    textareaRef.current.disabled = SVs.disabled;
  }
  const checkWorkComponent = createCheckWorkComponent(
    SVs,
    id,
    validationState.current,
    submitAnswer,
    false
  );
  let label = SVs.label;
  if (SVs.labelHasLatex) {
    label = /* @__PURE__ */ jsxRuntimeExports.jsx(MathJax, { hideUntilTypeset: "first", inline: true, dynamic: true, children: label });
  }
  const description = SVs.description || void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { id, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { style: { display: "inline-flex", maxWidth: "100%" }, children: [
      label,
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          className: "mathInputWrapper",
          style: {
            cursor: mathInputWrapperCursor,
            display: "block"
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            EditableMathField,
            {
              style: mathInputStyle,
              latex: rendererValue.current,
              ariaLabel: description,
              config: {
                autoCommands: "alpha beta gamma delta epsilon zeta eta mu nu xi omega rho sigma tau phi chi psi omega iota kappa lambda Gamma Delta Xi Omega Sigma Phi Psi Omega Lambda sqrt pi Pi theta Theta integral infinity forall exists",
                autoOperatorNames: "arg deg det dim exp gcd hom ker lg lim ln log max min Pr cos cosh acos acosh arccos arccosh cot coth acot acoth arccot arccoth csc csch acsc acsch arccsc arccsch sec sech asec asech arcsec arcsech sin sinh asin asinh arcsin arcsinh tan tanh atan atanh arctan arctanh nPr nCr",
                handlers: {
                  enter: handlePressEnter
                },
                substituteTextarea: function() {
                  textareaRef.current = document.createElement("textarea");
                  textareaRef.current.disabled = SVs.disabled;
                  return textareaRef.current;
                }
              },
              onChange: (mField) => {
                onChangeHandler(mField.latex());
              },
              onBlur: handleBlur,
              onFocus: handleFocus,
              mathquillDidMount: (mf) => {
                setMathField(mf);
              }
            }
          )
        }
      )
    ] }),
    checkWorkComponent
  ] }) });
}
export {
  MathInput as default
};
